
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3xISK", function(module, exports) {

$parcel$export(module.exports, "register", () => $294744c6a9554c1f$export$6503ec6e8aabbaf, (v) => $294744c6a9554c1f$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $294744c6a9554c1f$export$f7ad0328861e2f03, (v) => $294744c6a9554c1f$export$f7ad0328861e2f03 = v);
var $294744c6a9554c1f$export$6503ec6e8aabbaf;
var $294744c6a9554c1f$export$f7ad0328861e2f03;
"use strict";
var $294744c6a9554c1f$var$mapping = new Map();
function $294744c6a9554c1f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$294744c6a9554c1f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $294744c6a9554c1f$var$resolve(id) {
    var resolved = $294744c6a9554c1f$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$294744c6a9554c1f$export$6503ec6e8aabbaf = $294744c6a9554c1f$var$register;
$294744c6a9554c1f$export$f7ad0328861e2f03 = $294744c6a9554c1f$var$resolve;

});

parcelRegister("d55ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $b17d5a0416dc19e8$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $gNk6E = parcelRequire("gNk6E");

var $3JQTS = parcelRequire("3JQTS");

var $9e8jK = parcelRequire("9e8jK");

var $kHSrs = parcelRequire("kHSrs");

var $eFtsB = parcelRequire("eFtsB");

var $ge12w = parcelRequire("ge12w");

var $fX4To = parcelRequire("fX4To");

var $dAMJX = parcelRequire("dAMJX");

var $99f70 = parcelRequire("99f70");
class $b17d5a0416dc19e8$export$2e2bcd8739ae039 extends $gNk6E.Application {
    constructor(view, assetsList, cb){
        super(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.WIDTH = (0, $99f70.INITIAL_WIDTH), this.HEIGHT = (0, $99f70.INITIAL_HEIGHT), this.Animation = new (0, $eFtsB.default)(), this.SCALE = 1, this.getDim = ()=>({
                WIDTH: this.WIDTH,
                HEIGHT: this.HEIGHT
            }), this.update = (delta)=>this.Animation.update(delta.lastTime);
        if (!$b17d5a0416dc19e8$export$2e2bcd8739ae039.instance) $b17d5a0416dc19e8$export$2e2bcd8739ae039.instance = this;
        this.calcGameSize();
        view.style = `transform:scale(${this.SCALE})`;
        this.init({
            view: view,
            antialias: true,
            backgroundColor: 0xFFFFFF,
            width: this.WIDTH,
            height: this.HEIGHT
        }).then(()=>{
            (0, $ge12w.default).loadLogo().then(()=>{
                const startGame = ()=>{
                    new (0, $9e8jK.default)();
                    new (0, $kHSrs.default)();
                    cb();
                    this.checkVideoMode();
                };
                this.LoadingLayer = new (0, $dAMJX.default)(()=>startGame());
                const assets = (0, $99f70.ROOT_ASSETS_LIST).concat(assetsList);
                (0, $ge12w.default).load(assets, (p)=>this.LoadingLayer.drawLoadingButton(p)).then(()=>{
                    console.log("loaded assets");
                    this.ticker.add((delta)=>this.update(delta));
                });
            });
        });
    }
    static{
        this.getInstance = ()=>$b17d5a0416dc19e8$export$2e2bcd8739ae039.instance;
    }
    calcGameSize() {
        const dims = (0, $fX4To.default)((0, $99f70.INITIAL_WIDTH), (0, $99f70.INITIAL_HEIGHT));
        Object.assign(this, dims);
    }
    checkVideoMode() {
        const params = new URLSearchParams(window.location.search);
        const videoMode = params.get("videomode");
        if (videoMode) (0, $3JQTS.RootEventBus).emit((0, $3JQTS.EnumRootEventBus).onVideoMode);
    }
}

});
parcelRegister("83ZZo", function(module, exports) {

$parcel$export(module.exports, "Application", () => (parcelRequire("gNk6E")).Application);
$parcel$export(module.exports, "Assets", () => (parcelRequire("2eXAo")).Assets);
$parcel$export(module.exports, "Rectangle", () => (parcelRequire("42FDE")).Rectangle);
$parcel$export(module.exports, "Texture", () => (parcelRequire("7Ix7i")).Texture);
$parcel$export(module.exports, "Container", () => (parcelRequire("d7k7b")).Container);
$parcel$export(module.exports, "Graphics", () => (parcelRequire("ly9yM")).Graphics);
$parcel$export(module.exports, "NineSliceSprite", () => (parcelRequire("lBai8")).NineSliceSprite);
$parcel$export(module.exports, "Sprite", () => (parcelRequire("7FQQW")).Sprite);
$parcel$export(module.exports, "Text", () => (parcelRequire("28zzx")).Text);
$parcel$export(module.exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("98bME")))));

var $igKm9 = parcelRequire("igKm9");

var $2RX6O = parcelRequire("2RX6O");

var $cMikx = parcelRequire("cMikx");
parcelRequire("6wgBf");
parcelRequire("jAxN4");













































var $gNk6E = parcelRequire("gNk6E");



var $2eXAo = parcelRequire("2eXAo");
























































































































var $42FDE = parcelRequire("42FDE");
































































































































































































var $7Ix7i = parcelRequire("7Ix7i");









var $2Dvzh = parcelRequire("2Dvzh");

























var $d7k7b = parcelRequire("d7k7b");




































var $ly9yM = parcelRequire("ly9yM");

















































var $lBai8 = parcelRequire("lBai8");











var $7FQQW = parcelRequire("7FQQW");








































var $28zzx = parcelRequire("28zzx");



















var $98bME = parcelRequire("98bME");


















"use strict";
(0, $cMikx.extensions).add((0, $igKm9.browserExt), (0, $2RX6O.webworkerExt));

});
parcelRegister("igKm9", function(module, exports) {

$parcel$export(module.exports, "browserExt", () => $fb1f14e6226026f1$export$a6aad6334ef58a1c);

var $cMikx = parcelRequire("cMikx");
"use strict";

const $fb1f14e6226026f1$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $cMikx.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("47bWv"));
    }
};

});
parcelRegister("47bWv", function(module, exports) {

var $4Bteq = parcelRequire("4Bteq");
module.exports = Promise.all([
    $4Bteq("eS6a7"),
    $4Bteq("8nO6Z"),
    $4Bteq("2ESdP"),
    $4Bteq("1aH1w")
]).then(()=>parcelRequire('7QUNO'));

});
parcelRegister("4Bteq", function(module, exports) {
"use strict";

function $35a14aec9abce9dc$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("3xISK")).resolve(id));
}
module.exports = $35a14aec9abce9dc$var$load;

});



parcelRegister("2RX6O", function(module, exports) {

$parcel$export(module.exports, "webworkerExt", () => $f93bbc58d4eaec2e$export$ee43dd1acddf6cf8);

var $cMikx = parcelRequire("cMikx");
"use strict";

const $f93bbc58d4eaec2e$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $cMikx.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("zOVxB"));
    }
};

});
parcelRegister("zOVxB", function(module, exports) {

var $4Bteq = parcelRequire("4Bteq");
module.exports = Promise.all([
    $4Bteq("eS6a7"),
    $4Bteq("8nO6Z"),
    $4Bteq("2ESdP"),
    $4Bteq("f3Eag")
]).then(()=>parcelRequire('5rECA'));

});


parcelRegister("gNk6E", function(module, exports) {

$parcel$export(module.exports, "Application", () => $aec64804f9cd0a1c$export$16975c34e60e1e61);

var $cMikx = parcelRequire("cMikx");

var $ik0dz = parcelRequire("ik0dz");

var $d7k7b = parcelRequire("d7k7b");

var $AFJYy = parcelRequire("AFJYy");

var $1Ki8H = parcelRequire("1Ki8H");
"use strict";
const $aec64804f9cd0a1c$var$_Application = class _Application {
    /** @ignore */ constructor(...args){
        /**
     * The root display container for your application.
     * All visual elements should be added to this container or its children.
     * @example
     * ```js
     * // Create a sprite and add it to the stage
     * const sprite = Sprite.from('image.png');
     * app.stage.addChild(sprite);
     *
     * // Create a container for grouping objects
     * const container = new Container();
     * app.stage.addChild(container);
     * ```
     */ this.stage = new (0, $d7k7b.Container)();
        if (args[0] !== void 0) (0, $1Ki8H.deprecation)((0, $1Ki8H.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */ async init(options) {
        options = {
            ...options
        };
        this.renderer = await (0, $ik0dz.autoDetectRenderer)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */ get view() {
        (0, $1Ki8H.deprecation)((0, $1Ki8H.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @internal
 */ $aec64804f9cd0a1c$var$_Application._plugins = [];
let $aec64804f9cd0a1c$export$16975c34e60e1e61 = $aec64804f9cd0a1c$var$_Application;
(0, $cMikx.extensions).handleByList((0, $cMikx.ExtensionType).Application, $aec64804f9cd0a1c$export$16975c34e60e1e61._plugins);
(0, $cMikx.extensions).add((0, $AFJYy.ApplicationInitHook));

});
parcelRegister("ik0dz", function(module, exports) {

$parcel$export(module.exports, "autoDetectRenderer", () => $27fac6a194994b44$export$3583b92ab8150eb6);

var $6fnWh = parcelRequire("6fnWh");

var $fLG57 = parcelRequire("fLG57");

var $bRPvq = parcelRequire("bRPvq");
"use strict";
const $27fac6a194994b44$var$renderPriority = [
    "webgl",
    "webgpu",
    "canvas"
];


async function $27fac6a194994b44$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        preferredOrder.push(options.preference);
        $27fac6a194994b44$var$renderPriority.forEach((item)=>{
            if (item !== options.preference) preferredOrder.push(item);
        });
    } else preferredOrder = $27fac6a194994b44$var$renderPriority.slice();
    let RendererClass;
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $fLG57.isWebGPUSupported)()) {
            const { WebGPURenderer: WebGPURenderer } = await (parcelRequire("hS9m6"));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $6fnWh.isWebGLSupported)(options.failIfMajorPerformanceCaveat ?? (0, $bRPvq.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await (parcelRequire("heCDz"));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            finalOptions = {
                ...options
            };
            throw new Error("CanvasRenderer is not yet implemented");
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    if (!RendererClass) throw new Error("No available renderer for the current environment");
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}

});
parcelRegister("6fnWh", function(module, exports) {

$parcel$export(module.exports, "isWebGLSupported", () => $295cbca1fe5faaef$export$83dc396b76015322);

var $aY7HM = parcelRequire("aY7HM");

var $bRPvq = parcelRequire("bRPvq");
"use strict";
let $295cbca1fe5faaef$var$_isWebGLSupported;
function $295cbca1fe5faaef$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($295cbca1fe5faaef$var$_isWebGLSupported !== void 0) return $295cbca1fe5faaef$var$_isWebGLSupported;
    $295cbca1fe5faaef$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $bRPvq.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $aY7HM.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $aY7HM.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (_e) {
            return false;
        }
    })();
    return $295cbca1fe5faaef$var$_isWebGLSupported;
}

});

parcelRegister("fLG57", function(module, exports) {

$parcel$export(module.exports, "isWebGPUSupported", () => $9b326128d2e97156$export$216169f30082c873);

var $aY7HM = parcelRequire("aY7HM");
"use strict";
let $9b326128d2e97156$var$_isWebGPUSupported;
async function $9b326128d2e97156$export$216169f30082c873(options = {}) {
    if ($9b326128d2e97156$var$_isWebGPUSupported !== void 0) return $9b326128d2e97156$var$_isWebGPUSupported;
    $9b326128d2e97156$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $aY7HM.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (_e) {
            return false;
        }
    })();
    return $9b326128d2e97156$var$_isWebGPUSupported;
}

});

parcelRegister("hS9m6", function(module, exports) {

var $4Bteq = parcelRequire("4Bteq");
module.exports = Promise.all([
    $4Bteq("gm9hO"),
    $4Bteq("2ESdP"),
    $4Bteq("6Zoh5")
]).then(()=>parcelRequire('jMDyq'));

});

parcelRegister("heCDz", function(module, exports) {

var $4Bteq = parcelRequire("4Bteq");
module.exports = Promise.all([
    $4Bteq("gm9hO"),
    $4Bteq("2ESdP"),
    $4Bteq("8T1xj")
]).then(()=>parcelRequire('k5UGW'));

});



parcelRegister("2eXAo", function(module, exports) {

$parcel$export(module.exports, "Assets", () => $0a50bb764eb2589b$export$c8eca95e306f7116);

var $cMikx = parcelRequire("cMikx");

var $aa5dq = parcelRequire("aa5dq");

var $hKoNS = parcelRequire("hKoNS");

var $hW95L = parcelRequire("hW95L");

var $Wu73P = parcelRequire("Wu73P");

var $3eudD = parcelRequire("3eudD");

var $5MHAe = parcelRequire("5MHAe");

var $kUVn2 = parcelRequire("kUVn2");

var $5hg5g = parcelRequire("5hg5g");

var $gmwo4 = parcelRequire("gmwo4");

var $a31n8 = parcelRequire("a31n8");

var $aqTQt = parcelRequire("aqTQt");

var $irhTC = parcelRequire("irhTC");

var $aRvh1 = parcelRequire("aRvh1");

var $6KHOw = parcelRequire("6KHOw");

var $cN5Gw = parcelRequire("cN5Gw");

var $byJDg = parcelRequire("byJDg");

var $i7HuW = parcelRequire("i7HuW");

var $arIUQ = parcelRequire("arIUQ");

var $hC5MO = parcelRequire("hC5MO");

var $1MYfV = parcelRequire("1MYfV");

var $e3x48 = parcelRequire("e3x48");

var $dwgkE = parcelRequire("dwgkE");

var $bgbOI = parcelRequire("bgbOI");
"use strict";
class $0a50bb764eb2589b$export$137d4dd907afac85 {
    constructor(){
        this._detections = [];
        this._initialized = false;
        this.resolver = new (0, $e3x48.Resolver)();
        this.loader = new (0, $irhTC.Loader)();
        this.cache = (0, $Wu73P.Cache);
        this._backgroundLoader = new (0, $hW95L.BackgroundLoader)(this.loader);
        this._backgroundLoader.active = true;
        this.reset();
    }
    /**
   * Initializes the Assets class with configuration options. While not required,
   * calling this before loading assets is recommended to set up default behaviors.
   * @param options - Configuration options for the Assets system
   * @example
   * ```ts
   * // Basic initialization (optional as Assets.load will call this automatically)
   * await Assets.init();
   *
   * // With CDN configuration
   * await Assets.init({
   *     basePath: 'https://my-cdn.com/assets/',
   *     defaultSearchParams: { version: '1.0.0' }
   * });
   *
   * // With manifest and preferences
   * await Assets.init({
   *     manifest: {
   *         bundles: [{
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'hero',
   *                     src: 'hero.{png,webp}',
   *                     data: { scaleMode: SCALE_MODES.NEAREST }
   *                 },
   *                 {
   *                     alias: 'map',
   *                     src: 'map.json'
   *                 }
   *             ]
   *         }]
   *     },
   *     // Optimize for device capabilities
   *     texturePreference: {
   *         resolution: window.devicePixelRatio,
   *         format: ['webp', 'png']
   *     },
   *     // Set global preferences
   *     preferences: {
   *         crossOrigin: 'anonymous',
   *     }
   * });
   *
   * // Load assets after initialization
   * const heroTexture = await Assets.load('hero');
   * ```
   * @remarks
   * - Can be called only once; subsequent calls will be ignored with a warning
   * - Format detection runs automatically unless `skipDetections` is true
   * - The manifest can be a URL to a JSON file or an inline object
   * @see {@link AssetInitOptions} For all available initialization options
   * @see {@link AssetsManifest} For manifest format details
   */ async init(options = {}) {
        if (this._initialized) {
            (0, $hKoNS.warn)("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
            return;
        }
        this._initialized = true;
        if (options.defaultSearchParams) this.resolver.setDefaultSearchParams(options.defaultSearchParams);
        if (options.basePath) this.resolver.basePath = options.basePath;
        if (options.bundleIdentifier) this.resolver.setBundleIdentifier(options.bundleIdentifier);
        if (options.manifest) {
            let manifest = options.manifest;
            if (typeof manifest === "string") manifest = await this.load(manifest);
            this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1;
        const resolution = typeof resolutionPref === "number" ? [
            resolutionPref
        ] : resolutionPref;
        const formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        });
        if (options.preferences) this.setPreferences(options.preferences);
    }
    /**
   * Registers assets with the Assets resolver. This method maps keys (aliases) to asset sources,
   * allowing you to load assets using friendly names instead of direct URLs.
   * @param assets - The unresolved assets to add to the resolver
   * @example
   * ```ts
   * // Basic usage - single asset
   * Assets.add({
   *     alias: 'myTexture',
   *     src: 'assets/texture.png'
   * });
   * const texture = await Assets.load('myTexture');
   *
   * // Multiple aliases for the same asset
   * Assets.add({
   *     alias: ['hero', 'player'],
   *     src: 'hero.png'
   * });
   * const hero1 = await Assets.load('hero');
   * const hero2 = await Assets.load('player'); // Same texture
   *
   * // Multiple format support
   * Assets.add({
   *     alias: 'character',
   *     src: 'character.{webp,png}' // Will choose best format
   * });
   * Assets.add({
   *     alias: 'character',
   *     src: ['character.webp', 'character.png'], // Explicitly specify formats
   * });
   *
   * // With texture options
   * Assets.add({
   *     alias: 'sprite',
   *     src: 'sprite.png',
   *     data: { scaleMode: 'nearest' }
   * });
   *
   * // Multiple assets at once
   * Assets.add([
   *     { alias: 'bg', src: 'background.png' },
   *     { alias: 'music', src: 'music.mp3' },
   *     { alias: 'spritesheet', src: 'sheet.json', data: { ignoreMultiPack: false } }
   * ]);
   * ```
   * @remarks
   * - Assets are resolved when loaded, not when added
   * - Multiple formats use the best available format for the browser
   * - Adding with same alias overwrites previous definition
   * - The `data` property is passed to the asset loader
   * @see {@link Resolver} For details on asset resolution
   * @see {@link LoaderParser} For asset-specific data options
   * @advanced
   */ add(assets) {
        this.resolver.add(assets);
    }
    async load(urls, onProgress) {
        if (!this._initialized) await this.init();
        const singleAsset = (0, $bgbOI.isSingleItem)(urls);
        const urlArray = (0, $dwgkE.convertToList)(urls).map((url)=>{
            if (typeof url !== "string") {
                const aliases = this.resolver.getAlias(url);
                if (aliases.some((alias)=>!this.resolver.hasKey(alias))) this.add(url);
                return Array.isArray(aliases) ? aliases[0] : aliases;
            }
            if (!this.resolver.hasKey(url)) this.add({
                alias: url,
                src: url
            });
            return url;
        });
        const resolveResults = this.resolver.resolve(urlArray);
        const out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * Registers a bundle of assets that can be loaded as a group. Bundles are useful for organizing
   * assets into logical groups, such as game levels or UI screens.
   * @param bundleId - Unique identifier for the bundle
   * @param assets - Assets to include in the bundle
   * @example
   * ```ts
   * // Add a bundle using array format
   * Assets.addBundle('animals', [
   *     { alias: 'bunny', src: 'bunny.png' },
   *     { alias: 'chicken', src: 'chicken.png' },
   *     { alias: 'thumper', src: 'thumper.png' },
   * ]);
   *
   * // Add a bundle using object format
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * // Add a bundle with advanced options
   * Assets.addBundle('ui', [
   *     {
   *         alias: 'button',
   *         src: 'button.{webp,png}',
   *         data: { scaleMode: 'nearest' }
   *     },
   *     {
   *         alias: ['logo', 'brand'],  // Multiple aliases
   *         src: 'logo.svg',
   *         data: { resolution: 2 }
   *     }
   * ]);
   *
   * // Load the bundle
   * await Assets.loadBundle('animals');
   *
   * // Use the loaded assets
   * const bunny = Sprite.from('bunny');
   * const chicken = Sprite.from('chicken');
   * ```
   * @remarks
   * - Bundle IDs must be unique
   * - Assets in bundles are not loaded until `loadBundle` is called
   * - Bundles can be background loaded using `backgroundLoadBundle`
   * - Assets in bundles can be loaded individually using their aliases
   * @see {@link Assets.loadBundle} For loading bundles
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Loads a bundle or multiple bundles of assets. Bundles are collections of related assets
   * that can be loaded together.
   * @param bundleIds - Single bundle ID or array of bundle IDs to load
   * @param onProgress - Optional callback for load progress (0.0 to 1.0)
   * @returns Promise that resolves with the loaded bundle assets
   * @example
   * ```ts
   * // Define bundles in your manifest
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}', // use an array of individual assets
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * // Initialize with manifest
   * await Assets.init({ manifest });
   *
   * // Or add bundles programmatically
   * Assets.addBundle('load-screen', [...]);
   * Assets.loadBundle('load-screen');
   *
   * // Load a single bundle
   * await Assets.loadBundle('load-screen');
   * const bg = Sprite.from('background'); // Uses alias from bundle
   *
   * // Load multiple bundles
   * await Assets.loadBundle([
   *     'load-screen',
   *     'game-screen'
   * ]);
   *
   * // Load with progress tracking
   * await Assets.loadBundle('game-screen', (progress) => {
   *     console.log(`Loading: ${Math.round(progress * 100)}%`);
   * });
   * ```
   * @remarks
   * - Bundle assets are cached automatically
   * - Bundles can be pre-loaded using `backgroundLoadBundle`
   * - Assets in bundles can be accessed by their aliases
   * - Progress callback receives values from 0.0 to 1.0
   * @throws {Error} If the bundle ID doesn't exist in the manifest
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ async loadBundle(bundleIds, onProgress) {
        if (!this._initialized) await this.init();
        let singleAsset = false;
        if (typeof bundleIds === "string") {
            singleAsset = true;
            bundleIds = [
                bundleIds
            ];
        }
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const out = {};
        const keys = Object.keys(resolveResults);
        let count = 0;
        let total = 0;
        const _onProgress = ()=>{
            onProgress?.(++count / total);
        };
        const promises = keys.map((bundleId)=>{
            const resolveResult = resolveResults[bundleId];
            total += Object.keys(resolveResult).length;
            return this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        await Promise.all(promises);
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiates background loading of assets. This allows assets to be loaded passively while other operations
   * continue, making them instantly available when needed later.
   *
   * Background loading is useful for:
   * - Preloading game levels while in a menu
   * - Loading non-critical assets during gameplay
   * - Reducing visible loading screens
   * @param urls - Single URL/alias or array of URLs/aliases to load in the background
   * @example
   * ```ts
   * // Basic background loading
   * Assets.backgroundLoad('images/level2-assets.png');
   *
   * // Background load multiple assets
   * Assets.backgroundLoad([
   *     'images/sprite1.png',
   *     'images/sprite2.png',
   *     'images/background.png'
   * ]);
   *
   * // Later, when you need the assets
   * const textures = await Assets.load([
   *     'images/sprite1.png',
   *     'images/sprite2.png'
   * ]); // Resolves immediately if background loading completed
   * ```
   * @remarks
   * - Background loading happens one asset at a time to avoid blocking the main thread
   * - Loading can be interrupted safely by calling `Assets.load()`
   * - Assets are cached as they complete loading
   * - No progress tracking is available for background loading
   */ async backgroundLoad(urls) {
        if (!this._initialized) await this.init();
        if (typeof urls === "string") urls = [
            urls
        ];
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiates background loading of asset bundles. Similar to backgroundLoad but works with
   * predefined bundles of assets.
   *
   * Perfect for:
   * - Preloading level bundles during gameplay
   * - Loading UI assets during splash screens
   * - Preparing assets for upcoming game states
   * @param bundleIds - Single bundle ID or array of bundle IDs to load in the background
   * @example
   * ```ts
   * // Define bundles in your manifest
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *               name: 'home',
   *               assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/home-bg.png',
   *                 },
   *                 {
   *                     alias: 'logo',
   *                     src: 'images/logo.png',
   *                 }
   *              ]
   *            },
   *            {
   *             name: 'level-1',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/level1/bg.png',
   *                 },
   *                 {
   *                     alias: 'sprites',
   *                     src: 'images/level1/sprites.json'
   *                 }
   *             ]
   *         }]
   *     }
   * });
   *
   * // Load the home screen assets right away
   * await Assets.loadBundle('home');
   * showHomeScreen();
   *
   * // Start background loading while showing home screen
   * Assets.backgroundLoadBundle('level-1');
   *
   * // When player starts level, load completes faster
   * await Assets.loadBundle('level-1');
   * hideHomeScreen();
   * startLevel();
   * ```
   * @remarks
   * - Bundle assets are loaded one at a time
   * - Loading can be interrupted safely by calling `Assets.loadBundle()`
   * - Assets are cached as they complete loading
   * - Requires bundles to be registered via manifest or `addBundle`
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.loadBundle} For immediate bundle loading
   * @see {@link AssetsManifest} For manifest format details
   */ async backgroundLoadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        if (typeof bundleIds === "string") bundleIds = [
            bundleIds
        ];
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   * @internal
   */ reset() {
        this.resolver.reset();
        this.loader.reset();
        this.cache.reset();
        this._initialized = false;
    }
    get(keys) {
        if (typeof keys === "string") return (0, $Wu73P.Cache).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $Wu73P.Cache).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */ async _mapLoadToResolve(resolveResults, onProgress) {
        const resolveArray = [
            ...new Set(Object.values(resolveResults))
        ];
        this._backgroundLoader.active = false;
        const loadedAssets = await this.loader.load(resolveArray, onProgress);
        this._backgroundLoader.active = true;
        const out = {};
        resolveArray.forEach((resolveResult)=>{
            const asset = loadedAssets[resolveResult.src];
            const keys = [
                resolveResult.src
            ];
            if (resolveResult.alias) keys.push(...resolveResult.alias);
            keys.forEach((key)=>{
                out[key] = asset;
            });
            (0, $Wu73P.Cache).set(keys, asset);
        });
        return out;
    }
    /**
   * Unloads assets and releases them from memory. This method ensures proper cleanup of
   * loaded assets when they're no longer needed.
   * @param urls - Single URL/alias or array of URLs/aliases to unload
   * @example
   * ```ts
   * // Unload a single asset
   * await Assets.unload('images/sprite.png');
   *
   * // Unload using an alias
   * await Assets.unload('hero'); // Unloads the asset registered with 'hero' alias
   *
   * // Unload multiple assets
   * await Assets.unload([
   *     'images/background.png',
   *     'images/character.png',
   *     'hero'
   * ]);
   *
   * // Unload and handle creation of new instances
   * await Assets.unload('hero');
   * const newHero = await Assets.load('hero'); // Will load fresh from source
   * ```
   * @remarks
   * > [!WARNING]
   * > Make sure assets aren't being used before unloading:
   * > - Remove sprites using the texture
   * > - Clear any references to the asset
   * > - Textures will be destroyed and can't be used after unloading
   * @throws {Error} If the asset is not found in cache
   */ async unload(urls) {
        if (!this._initialized) await this.init();
        const urlArray = (0, $dwgkE.convertToList)(urls).map((url)=>typeof url !== "string" ? url.src : url);
        const resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Unloads all assets in a bundle. Use this to free memory when a bundle's assets
   * are no longer needed, such as when switching game levels.
   * @param bundleIds - Single bundle ID or array of bundle IDs to unload
   * @example
   * ```ts
   * // Define and load a bundle
   * Assets.addBundle('level-1', {
   *     background: 'level1/bg.png',
   *     sprites: 'level1/sprites.json',
   *     music: 'level1/music.mp3'
   * });
   *
   * // Load the bundle
   * const level1 = await Assets.loadBundle('level-1');
   *
   * // Use the assets
   * const background = Sprite.from(level1.background);
   *
   * // When done with the level, unload everything
   * await Assets.unloadBundle('level-1');
   * // background sprite is now invalid!
   *
   * // Unload multiple bundles
   * await Assets.unloadBundle([
   *     'level-1',
   *     'level-2',
   *     'ui-elements'
   * ]);
   * ```
   * @remarks
   * > [!WARNING]
   * > - All assets in the bundle will be destroyed
   * > - Bundle needs to be reloaded to use assets again
   * > - Make sure no sprites or other objects are using the assets
   * @throws {Error} If the bundle is not found
   * @see {@link Assets.addBundle} For adding bundles
   * @see {@link Assets.loadBundle} For loading bundles
   */ async unloadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        bundleIds = (0, $dwgkE.convertToList)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $Wu73P.Cache).remove(resolveResult2.src);
        });
        await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        if (options.preferredFormats) formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ];
        for (const detection of options.detections){
            if (options.skipDetections || await detection.test()) formats = await detection.add(formats);
            else if (!options.skipDetections) formats = await detection.remove(formats);
        }
        formats = formats.filter((format, index)=>formats.indexOf(format) === index);
        return formats;
    }
    /**
   * All the detection parsers currently added to the Assets class.
   * @advanced
   */ get detections() {
        return this._detections;
    }
    /**
   * Sets global preferences for asset loading behavior. This method configures how assets
   * are loaded and processed across all parsers.
   * @param preferences - Asset loading preferences
   * @example
   * ```ts
   * // Basic preferences
   * Assets.setPreferences({
   *     crossOrigin: 'anonymous',
   *     parseAsGraphicsContext: false
   * });
   * ```
   * @remarks
   * Preferences are applied to all compatible parsers and affect future asset loading.
   * Common preferences include:
   * - `crossOrigin`: CORS setting for loaded assets
   * - `preferWorkers`: Whether to use web workers for loading textures
   * - `preferCreateImageBitmap`: Use `createImageBitmap` for texture creation. Turning this off will use the `Image` constructor instead.
   * @see {@link AssetsPreferences} For all available preferences
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            if (!parser.config) return;
            Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $0a50bb764eb2589b$export$c8eca95e306f7116 = new $0a50bb764eb2589b$export$137d4dd907afac85();
(0, $cMikx.extensions).handleByList((0, $cMikx.ExtensionType).LoadParser, $0a50bb764eb2589b$export$c8eca95e306f7116.loader.parsers).handleByList((0, $cMikx.ExtensionType).ResolveParser, $0a50bb764eb2589b$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $cMikx.ExtensionType).CacheParser, $0a50bb764eb2589b$export$c8eca95e306f7116.cache.parsers).handleByList((0, $cMikx.ExtensionType).DetectionParser, $0a50bb764eb2589b$export$c8eca95e306f7116.detections);
(0, $cMikx.extensions).add((0, $3eudD.cacheTextureArray), (0, $kUVn2.detectDefaults), (0, $5MHAe.detectAvif), (0, $aqTQt.detectWebp), (0, $5hg5g.detectMp4), (0, $gmwo4.detectOgv), (0, $a31n8.detectWebm), (0, $aRvh1.loadJson), (0, $6KHOw.loadTxt), (0, $cN5Gw.loadWebFont), (0, $byJDg.loadSvg), (0, $i7HuW.loadTextures), (0, $arIUQ.loadVideoTextures), (0, $aa5dq.loadBitmapFont), (0, $aa5dq.bitmapFontCachePlugin), (0, $1MYfV.resolveTextureUrl), (0, $hC5MO.resolveJsonUrl));
const $0a50bb764eb2589b$var$assetKeyMap = {
    loader: (0, $cMikx.ExtensionType).LoadParser,
    resolver: (0, $cMikx.ExtensionType).ResolveParser,
    cache: (0, $cMikx.ExtensionType).CacheParser,
    detection: (0, $cMikx.ExtensionType).DetectionParser
};
(0, $cMikx.extensions).handle((0, $cMikx.ExtensionType).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($0a50bb764eb2589b$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $cMikx.extensions).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($0a50bb764eb2589b$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $cMikx.extensions).remove(ref[key]));
});

});
parcelRegister("aa5dq", function(module, exports) {

$parcel$export(module.exports, "bitmapFontCachePlugin", () => $e0eaa1143943c219$export$778a313228f06f6c);
$parcel$export(module.exports, "loadBitmapFont", () => $e0eaa1143943c219$export$402edee29ac8bed4);

var $fVQLb = parcelRequire("fVQLb");

var $dtCcy = parcelRequire("dtCcy");

var $aY7HM = parcelRequire("aY7HM");

var $cMikx = parcelRequire("cMikx");

var $gn7Lb = parcelRequire("gn7Lb");

var $ltGU0 = parcelRequire("ltGU0");

var $bePkN = parcelRequire("bePkN");

var $dWyt9 = parcelRequire("dWyt9");
"use strict";
const $e0eaa1143943c219$var$validExtensions = [
    ".xml",
    ".fnt"
];
const $e0eaa1143943c219$export$778a313228f06f6c = {
    extension: {
        type: (0, $cMikx.ExtensionType).CacheParser,
        name: "cacheBitmapFont"
    },
    test: (asset)=>asset instanceof (0, $ltGU0.BitmapFont),
    getCacheableAssets (keys, asset) {
        const out = {};
        keys.forEach((key)=>{
            out[key] = asset;
            out[`${key}-bitmap`] = asset;
        });
        out[`${asset.fontFamily}-bitmap`] = asset;
        return out;
    }
};
const $e0eaa1143943c219$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $cMikx.ExtensionType).LoadParser,
        priority: (0, $fVQLb.LoaderParserPriority).Normal
    },
    name: "loadBitmapFont",
    test (url) {
        return $e0eaa1143943c219$var$validExtensions.includes((0, $gn7Lb.path).extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $bePkN.bitmapFontTextParser).test(data) || (0, $dWyt9.bitmapFontXMLStringParser).test(data);
    },
    async parse (asset, data, loader) {
        const bitmapFontData = (0, $bePkN.bitmapFontTextParser).test(asset) ? (0, $bePkN.bitmapFontTextParser).parse(asset) : (0, $dWyt9.bitmapFontXMLStringParser).parse(asset);
        const { src: src } = data;
        const { pages: pages } = bitmapFontData;
        const textureUrls = [];
        const textureOptions = bitmapFontData.distanceField ? {
            scaleMode: "linear",
            alphaMode: "premultiply-alpha-on-upload",
            autoGenerateMipmaps: false,
            resolution: 1
        } : {};
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $gn7Lb.path).join((0, $gn7Lb.path).dirname(src), pageFile);
            imagePath = (0, $dtCcy.copySearchParams)(imagePath, src);
            textureUrls.push({
                src: imagePath,
                data: textureOptions
            });
        }
        const loadedTextures = await loader.load(textureUrls);
        const textures = textureUrls.map((url)=>loadedTextures[url.src]);
        const bitmapFont = new (0, $ltGU0.BitmapFont)({
            data: bitmapFontData,
            textures: textures
        }, src);
        return bitmapFont;
    },
    async load (url, _options) {
        const response = await (0, $aY7HM.DOMAdapter).get().fetch(url);
        return await response.text();
    },
    async unload (bitmapFont, _resolvedAsset, loader) {
        await Promise.all(bitmapFont.pages.map((page)=>loader.unload(page.texture.source._sourceOrigin)));
        bitmapFont.destroy();
    }
};

});
parcelRegister("ltGU0", function(module, exports) {

$parcel$export(module.exports, "BitmapFont", () => $1d98f6048dee7e47$export$17957a09927cadc7);

var $42FDE = parcelRequire("42FDE");

var $7Ix7i = parcelRequire("7Ix7i");

var $dTtNF = parcelRequire("dTtNF");

var $hQ6Uz = parcelRequire("hQ6Uz");
"use strict";
class $1d98f6048dee7e47$export$17957a09927cadc7 extends (0, $dTtNF.AbstractBitmapFont) {
    constructor(options, url){
        super();
        const { textures: textures, data: data } = options;
        Object.keys(data.pages).forEach((key)=>{
            const pageData = data.pages[parseInt(key, 10)];
            const texture = textures[pageData.id];
            this.pages.push({
                texture: texture
            });
        });
        Object.keys(data.chars).forEach((key)=>{
            const charData = data.chars[key];
            const { frame: textureFrame, source: textureSource } = textures[charData.page];
            const frameReal = new (0, $42FDE.Rectangle)(charData.x + textureFrame.x, charData.y + textureFrame.y, charData.width, charData.height);
            const texture = new (0, $7Ix7i.Texture)({
                source: textureSource,
                frame: frameReal
            });
            this.chars[key] = {
                id: key.codePointAt(0),
                xOffset: charData.xOffset,
                yOffset: charData.yOffset,
                xAdvance: charData.xAdvance,
                kerning: charData.kerning ?? {},
                texture: texture
            };
        });
        this.baseRenderedFontSize = data.fontSize;
        this.baseMeasurementFontSize = data.fontSize;
        this.fontMetrics = {
            ascent: 0,
            descent: 0,
            fontSize: data.fontSize
        };
        this.baseLineOffset = data.baseLineOffset;
        this.lineHeight = data.lineHeight;
        this.fontFamily = data.fontFamily;
        this.distanceField = data.distanceField ?? {
            type: "none",
            range: 0
        };
        this.url = url;
    }
    /** Destroys the BitmapFont object. */ destroy() {
        super.destroy();
        for(let i = 0; i < this.pages.length; i++){
            const { texture: texture } = this.pages[i];
            texture.destroy(true);
        }
        this.pages = null;
    }
    /**
   * Generates and installs a bitmap font with the specified options.
   * The font will be cached and available for use in BitmapText objects.
   * @param options - Setup options for font generation
   * @returns Installed font instance
   * @example
   * ```ts
   * // Install a basic font
   * BitmapFont.install({
   *     name: 'Title',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 32,
   *         fill: '#ffffff'
   *     }
   * });
   *
   * // Install with advanced options
   * BitmapFont.install({
   *     name: 'Custom',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 24,
   *         fill: '#00ff00',
   *         stroke: { color: '#000000', width: 2 }
   *     },
   *     chars: [['a', 'z'], ['A', 'Z'], ['0', '9']],
   *     resolution: 2,
   *     padding: 4,
   *     textureStyle: {
   *         scaleMode: 'nearest'
   *     }
   * });
   * ```
   */ static install(options) {
        (0, $hQ6Uz.BitmapFontManager).install(options);
    }
    /**
   * Uninstalls a bitmap font from the cache.
   * This frees up memory and resources associated with the font.
   * @param name - The name of the bitmap font to uninstall
   * @example
   * ```ts
   * // Remove a font when it's no longer needed
   * BitmapFont.uninstall('MyCustomFont');
   *
   * // Clear multiple fonts
   * ['Title', 'Heading', 'Body'].forEach(BitmapFont.uninstall);
   * ```
   */ static uninstall(name) {
        (0, $hQ6Uz.BitmapFontManager).uninstall(name);
    }
}

});

parcelRegister("bePkN", function(module, exports) {

$parcel$export(module.exports, "bitmapFontTextParser", () => $9319da30bed3b9e4$export$4c1815a0944ccac0);
"use strict";
const $9319da30bed3b9e4$export$4c1815a0944ccac0 = {
    test (data) {
        return typeof data === "string" && data.startsWith("info face=");
    },
    parse (txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm);
        const rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0];
            const attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            const itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("=");
                const key = split[0];
                const strValue = split[1].replace(/"/gm, "");
                const floatValue = parseFloat(strValue);
                const value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const [info] = rawData.info;
        const [common] = rawData.common;
        const [distanceField] = rawData.distanceField ?? [];
        if (distanceField) font.distanceField = {
            range: parseInt(distanceField.distanceRange, 10),
            type: distanceField.fieldType
        };
        font.fontSize = parseInt(info.size, 10);
        font.fontFamily = info.face;
        font.lineHeight = parseInt(common.lineHeight, 10);
        const page = rawData.page;
        for(let i = 0; i < page.length; i++)font.pages.push({
            id: parseInt(page[i].id, 10) || 0,
            file: page[i].file
        });
        const map = {};
        font.baseLineOffset = font.lineHeight - parseInt(common.base, 10);
        const char = rawData.char;
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.id, 10);
            let letter = charNode.letter ?? charNode.char ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            font.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.page, 10) || 0,
                x: parseInt(charNode.x, 10),
                y: parseInt(charNode.y, 10),
                width: parseInt(charNode.width, 10),
                height: parseInt(charNode.height, 10),
                xOffset: parseInt(charNode.xoffset, 10),
                yOffset: parseInt(charNode.yoffset, 10),
                xAdvance: parseInt(charNode.xadvance, 10),
                kerning: {}
            };
        }
        const kerning = rawData.kerning || [];
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].first, 10);
            const second = parseInt(kerning[i].second, 10);
            const amount = parseInt(kerning[i].amount, 10);
            font.chars[map[second]].kerning[map[first]] = amount;
        }
        return font;
    }
};

});

parcelRegister("dWyt9", function(module, exports) {

$parcel$export(module.exports, "bitmapFontXMLStringParser", () => $b96843384ebec2b0$export$bfc0a19e2e2cc16);

var $aY7HM = parcelRequire("aY7HM");

var $iXEQU = parcelRequire("iXEQU");
"use strict";
const $b96843384ebec2b0$export$bfc0a19e2e2cc16 = {
    test (data) {
        if (typeof data === "string" && data.includes("<font>")) return (0, $iXEQU.bitmapFontXMLParser).test((0, $aY7HM.DOMAdapter).get().parseXML(data));
        return false;
    },
    parse (data) {
        return (0, $iXEQU.bitmapFontXMLParser).parse((0, $aY7HM.DOMAdapter).get().parseXML(data));
    }
};

});
parcelRegister("iXEQU", function(module, exports) {

$parcel$export(module.exports, "bitmapFontXMLParser", () => $024e307deb328bbf$export$7a7adbcafc5cf8e3);
"use strict";
const $024e307deb328bbf$export$7a7adbcafc5cf8e3 = {
    test (data) {
        const xml = data;
        return typeof xml !== "string" && "getElementsByTagName" in xml && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    },
    parse (xml) {
        const data = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const info = xml.getElementsByTagName("info")[0];
        const common = xml.getElementsByTagName("common")[0];
        const distanceField = xml.getElementsByTagName("distanceField")[0];
        if (distanceField) data.distanceField = {
            type: distanceField.getAttribute("fieldType"),
            range: parseInt(distanceField.getAttribute("distanceRange"), 10)
        };
        const page = xml.getElementsByTagName("page");
        const char = xml.getElementsByTagName("char");
        const kerning = xml.getElementsByTagName("kerning");
        data.fontSize = parseInt(info.getAttribute("size"), 10);
        data.fontFamily = info.getAttribute("face");
        data.lineHeight = parseInt(common.getAttribute("lineHeight"), 10);
        for(let i = 0; i < page.length; i++)data.pages.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        const map = {};
        data.baseLineOffset = data.lineHeight - parseInt(common.getAttribute("base"), 10);
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.getAttribute("id"), 10);
            let letter = charNode.getAttribute("letter") ?? charNode.getAttribute("char") ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            data.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.getAttribute("page"), 10) || 0,
                x: parseInt(charNode.getAttribute("x"), 10),
                y: parseInt(charNode.getAttribute("y"), 10),
                width: parseInt(charNode.getAttribute("width"), 10),
                height: parseInt(charNode.getAttribute("height"), 10),
                // render deets..
                xOffset: parseInt(charNode.getAttribute("xoffset"), 10),
                yOffset: parseInt(charNode.getAttribute("yoffset"), 10),
                // + baseLineOffset,
                xAdvance: parseInt(charNode.getAttribute("xadvance"), 10),
                kerning: {}
            };
        }
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].getAttribute("first"), 10);
            const second = parseInt(kerning[i].getAttribute("second"), 10);
            const amount = parseInt(kerning[i].getAttribute("amount"), 10);
            data.chars[map[second]].kerning[map[first]] = amount;
        }
        return data;
    }
};

});



parcelRegister("hW95L", function(module, exports) {

$parcel$export(module.exports, "BackgroundLoader", () => $9fc6f040c669b264$export$1949379a83b843d5);
"use strict";
class $9fc6f040c669b264$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = false){
        this._loader = loader;
        this._assetList = [];
        this._isLoading = false;
        this._maxConcurrent = 1;
        this.verbose = verbose;
    }
    /**
   * Adds assets to the background loading queue. Assets are loaded one at a time to minimize
   * performance impact.
   * @param assetUrls - Array of resolved assets to load in the background
   * @example
   * ```ts
   * // Add assets to background load queue
   * backgroundLoader.add([
   *     { src: 'images/level1/bg.png' },
   *     { src: 'images/level1/characters.json' }
   * ]);
   *
   * // Assets will load sequentially in the background
   * // The loader automatically pauses when high-priority loads occur
   * // e.g. Assets.load() is called
   * ```
   * @remarks
   * - Assets are loaded one at a time to minimize performance impact
   * - Loading automatically pauses when Assets.load() is called
   * - No progress tracking is available for background loading
   * - Assets are cached as they complete loading
   * @internal
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        });
        if (this.verbose) console.log("[BackgroundLoader] assets: ", this._assetList);
        if (this._isActive && !this._isLoading) this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = true;
            const toLoad = [];
            const toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad);
            this._isLoading = false;
            this._next();
        }
    }
    /**
   * Controls the active state of the background loader. When active, the loader will
   * continue processing its queue. When inactive, loading is paused.
   * @returns Whether the background loader is currently active
   * @example
   * ```ts
   * // Pause background loading
   * backgroundLoader.active = false;
   *
   * // Resume background loading
   * backgroundLoader.active = true;
   *
   * // Check current state
   * console.log(backgroundLoader.active); // true/false
   *
   * // Common use case: Pause during intensive operations
   * backgroundLoader.active = false;  // Pause background loading
   * ... // Perform high-priority tasks
   * backgroundLoader.active = true;   // Resume background loading
   * ```
   * @remarks
   * - Setting to true resumes loading immediately
   * - Setting to false pauses after current asset completes
   * - Background loading is automatically paused during `Assets.load()`
   * - Assets already being loaded will complete even when set to false
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        if (this._isActive === value) return;
        this._isActive = value;
        if (value && !this._isLoading) this._next();
    }
}

});

parcelRegister("3eudD", function(module, exports) {

$parcel$export(module.exports, "cacheTextureArray", () => $200996a287bcffae$export$407b4625a915919d);

var $cMikx = parcelRequire("cMikx");

var $7Ix7i = parcelRequire("7Ix7i");
"use strict";
const $200996a287bcffae$export$407b4625a915919d = {
    extension: {
        type: (0, $cMikx.ExtensionType).CacheParser,
        name: "cacheTextureArray"
    },
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $7Ix7i.Texture)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        });
        return out;
    }
};

});

parcelRegister("5MHAe", function(module, exports) {

$parcel$export(module.exports, "detectAvif", () => $549806c6e767fe3b$export$a60d2d4a3c570783);

var $cMikx = parcelRequire("cMikx");

var $daLxT = parcelRequire("daLxT");
"use strict";
const $549806c6e767fe3b$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $cMikx.ExtensionType).DetectionParser,
        priority: 1
    },
    test: async ()=>(0, $daLxT.testImageFormat)(// eslint-disable-next-line max-len
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="),
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};

});
parcelRegister("daLxT", function(module, exports) {

$parcel$export(module.exports, "testImageFormat", () => $3e2679816c63b07b$export$7c459e568e7cea2c);
"use strict";
async function $3e2679816c63b07b$export$7c459e568e7cea2c(imageData) {
    if ("Image" in globalThis) return new Promise((resolve)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(true);
        };
        image.onerror = ()=>{
            resolve(false);
        };
        image.src = imageData;
    });
    if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
        try {
            const blob = await (await fetch(imageData)).blob();
            await createImageBitmap(blob);
        } catch (_e) {
            return false;
        }
        return true;
    }
    return false;
}

});


parcelRegister("kUVn2", function(module, exports) {

$parcel$export(module.exports, "detectDefaults", () => $0f6d67a5f60bd16a$export$b106d7c2de3b4d89);

var $cMikx = parcelRequire("cMikx");
"use strict";
const $0f6d67a5f60bd16a$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
];
const $0f6d67a5f60bd16a$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $cMikx.ExtensionType).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(true),
    add: async (formats)=>[
            ...formats,
            ...$0f6d67a5f60bd16a$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$0f6d67a5f60bd16a$var$imageFormats.includes(f))
};

});

parcelRegister("5hg5g", function(module, exports) {

$parcel$export(module.exports, "detectMp4", () => $c6209044ec80e133$export$7726d83fee274e25);

var $cMikx = parcelRequire("cMikx");

var $bWRoV = parcelRequire("bWRoV");
"use strict";
const $c6209044ec80e133$export$7726d83fee274e25 = {
    extension: {
        type: (0, $cMikx.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $bWRoV.testVideoFormat)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};

});
parcelRegister("bWRoV", function(module, exports) {

$parcel$export(module.exports, "testVideoFormat", () => $9f9a51ec92e427d7$export$7a571c147b03abb1);
"use strict";
const $9f9a51ec92e427d7$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $9f9a51ec92e427d7$export$7a571c147b03abb1(mimeType) {
    if ($9f9a51ec92e427d7$var$inWorker) return false;
    const video = document.createElement("video");
    return video.canPlayType(mimeType) !== "";
}

});


parcelRegister("gmwo4", function(module, exports) {

$parcel$export(module.exports, "detectOgv", () => $8e64e5c5a51b1d6c$export$5a1da481121f806a);

var $cMikx = parcelRequire("cMikx");

var $bWRoV = parcelRequire("bWRoV");
"use strict";
const $8e64e5c5a51b1d6c$export$5a1da481121f806a = {
    extension: {
        type: (0, $cMikx.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $bWRoV.testVideoFormat)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};

});

parcelRegister("a31n8", function(module, exports) {

$parcel$export(module.exports, "detectWebm", () => $9a5f7ad34a14e434$export$a041d698a1896657);

var $cMikx = parcelRequire("cMikx");

var $bWRoV = parcelRequire("bWRoV");
"use strict";
const $9a5f7ad34a14e434$export$a041d698a1896657 = {
    extension: {
        type: (0, $cMikx.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $bWRoV.testVideoFormat)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};

});

parcelRegister("aqTQt", function(module, exports) {

$parcel$export(module.exports, "detectWebp", () => $2016464c0c050ed0$export$d19529a9ed9823d4);

var $cMikx = parcelRequire("cMikx");

var $daLxT = parcelRequire("daLxT");
"use strict";
const $2016464c0c050ed0$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $cMikx.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $daLxT.testImageFormat)("data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="),
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};

});

parcelRegister("irhTC", function(module, exports) {

$parcel$export(module.exports, "Loader", () => $28363db786fd3e00$export$3b0d6d7590275603);

var $hKoNS = parcelRequire("hKoNS");

var $gn7Lb = parcelRequire("gn7Lb");

var $dwgkE = parcelRequire("dwgkE");

var $bgbOI = parcelRequire("bgbOI");
"use strict";
class $28363db786fd3e00$export$3b0d6d7590275603 {
    constructor(){
        this._parsers = [];
        this._parsersValidated = false;
        /**
     * All loader parsers registered
     * @type {assets.LoaderParser[]}
     */ this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>{
                this._parsersValidated = false;
                target[key] = value;
                return true;
            }
        });
        /** Cache loading promises that ae currently active */ this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = false;
        this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        result.promise = (async ()=>{
            let asset = null;
            let parser = null;
            if (data.loadParser) {
                parser = this._parserHash[data.loadParser];
                if (!parser) (0, $hKoNS.warn)(`[Assets] specified load parser "${data.loadParser}" not found while loading ${url}`);
            }
            if (!parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) {
                    (0, $hKoNS.warn)(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`);
                    return null;
                }
            }
            asset = await parser.load(url, data, this);
            result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                if (parser2.parse) {
                    if (parser2.parse && await parser2.testParse?.(asset, data, this)) {
                        asset = await parser2.parse(asset, data, this) || asset;
                        result.parser = parser2;
                    }
                }
            }
            return asset;
        })();
        return result;
    }
    async load(assetsToLoadIn, onProgress) {
        if (!this._parsersValidated) this._validateParsers();
        let count = 0;
        const assets = {};
        const singleAsset = (0, $bgbOI.isSingleItem)(assetsToLoadIn);
        const assetsToLoad = (0, $dwgkE.convertToList)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item,
                data: {}
            }));
        const total = assetsToLoad.length;
        const promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $gn7Lb.path).toAbsolute(asset.src);
            if (!assets[asset.src]) try {
                if (!this.promiseCache[url]) this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset);
                assets[asset.src] = await this.promiseCache[url].promise;
                if (onProgress) onProgress(++count / total);
            } catch (e) {
                delete this.promiseCache[url];
                delete assets[asset.src];
                throw new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            }
        });
        await Promise.all(promises);
        return singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const assetsToUnload = (0, $dwgkE.convertToList)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            }));
        const promises = assetsToUnload.map(async (asset)=>{
            const url = (0, $gn7Lb.path).toAbsolute(asset.src);
            const loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url];
                await loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = true;
        this._parserHash = this._parsers.filter((parser)=>parser.name).reduce((hash, parser)=>{
            if (!parser.name) (0, $hKoNS.warn)(`[Assets] loadParser should have a name`);
            else if (hash[parser.name]) (0, $hKoNS.warn)(`[Assets] loadParser name conflict "${parser.name}"`);
            return {
                ...hash,
                [parser.name]: parser
            };
        }, {});
    }
}

});

parcelRegister("aRvh1", function(module, exports) {

$parcel$export(module.exports, "loadJson", () => $6ec1243084986c25$export$e7c8553478f3aac7);

var $aY7HM = parcelRequire("aY7HM");

var $cMikx = parcelRequire("cMikx");

var $57Ubo = parcelRequire("57Ubo");

var $lyYOs = parcelRequire("lyYOs");

var $fVQLb = parcelRequire("fVQLb");
"use strict";
const $6ec1243084986c25$var$validJSONExtension = ".json";
const $6ec1243084986c25$var$validJSONMIME = "application/json";
const $6ec1243084986c25$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $cMikx.ExtensionType).LoadParser,
        priority: (0, $fVQLb.LoaderParserPriority).Low
    },
    name: "loadJson",
    test (url) {
        return (0, $57Ubo.checkDataUrl)(url, $6ec1243084986c25$var$validJSONMIME) || (0, $lyYOs.checkExtension)(url, $6ec1243084986c25$var$validJSONExtension);
    },
    async load (url) {
        const response = await (0, $aY7HM.DOMAdapter).get().fetch(url);
        const json = await response.json();
        return json;
    }
};

});
parcelRegister("57Ubo", function(module, exports) {

$parcel$export(module.exports, "checkDataUrl", () => $6b364f6c1668c81b$export$7ff8b059fb914323);
"use strict";
function $6b364f6c1668c81b$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes){
            if (url.startsWith(`data:${mime}`)) return true;
        }
        return false;
    }
    return url.startsWith(`data:${mimes}`);
}

});

parcelRegister("lyYOs", function(module, exports) {

$parcel$export(module.exports, "checkExtension", () => $b544cc6471920133$export$fd0180357b95b812);

var $gn7Lb = parcelRequire("gn7Lb");
"use strict";
function $b544cc6471920133$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0];
    const ext = (0, $gn7Lb.path).extname(tempURL).toLowerCase();
    if (Array.isArray(extension)) return extension.includes(ext);
    return ext === extension;
}

});


parcelRegister("6KHOw", function(module, exports) {

$parcel$export(module.exports, "loadTxt", () => $7abb7a9279bb3dc3$export$3835b7ee6dbebde8);

var $aY7HM = parcelRequire("aY7HM");

var $cMikx = parcelRequire("cMikx");

var $57Ubo = parcelRequire("57Ubo");

var $lyYOs = parcelRequire("lyYOs");

var $fVQLb = parcelRequire("fVQLb");
"use strict";
const $7abb7a9279bb3dc3$var$validTXTExtension = ".txt";
const $7abb7a9279bb3dc3$var$validTXTMIME = "text/plain";
const $7abb7a9279bb3dc3$export$3835b7ee6dbebde8 = {
    name: "loadTxt",
    extension: {
        type: (0, $cMikx.ExtensionType).LoadParser,
        priority: (0, $fVQLb.LoaderParserPriority).Low,
        name: "loadTxt"
    },
    test (url) {
        return (0, $57Ubo.checkDataUrl)(url, $7abb7a9279bb3dc3$var$validTXTMIME) || (0, $lyYOs.checkExtension)(url, $7abb7a9279bb3dc3$var$validTXTExtension);
    },
    async load (url) {
        const response = await (0, $aY7HM.DOMAdapter).get().fetch(url);
        const txt = await response.text();
        return txt;
    }
};

});

parcelRegister("cN5Gw", function(module, exports) {

$parcel$export(module.exports, "loadWebFont", () => $96f79b7ca8336194$export$129ed93ad26b0298);

var $aY7HM = parcelRequire("aY7HM");

var $cMikx = parcelRequire("cMikx");

var $hKoNS = parcelRequire("hKoNS");

var $gn7Lb = parcelRequire("gn7Lb");

var $Wu73P = parcelRequire("Wu73P");

var $57Ubo = parcelRequire("57Ubo");

var $lyYOs = parcelRequire("lyYOs");

var $fVQLb = parcelRequire("fVQLb");
"use strict";
const $96f79b7ca8336194$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
];
const $96f79b7ca8336194$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
];
const $96f79b7ca8336194$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
];
const $96f79b7ca8336194$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $96f79b7ca8336194$export$c461ca8f39d93d9b(url) {
    const ext = (0, $gn7Lb.path).extname(url);
    const name = (0, $gn7Lb.path).basename(url, ext);
    const nameWithSpaces = name.replace(/(-|_)/g, " ");
    const nameTokens = nameWithSpaces.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($96f79b7ca8336194$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = false;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    if (!valid) fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`;
    return fontFamilyName;
}
const $96f79b7ca8336194$var$validURICharactersRegex = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function $96f79b7ca8336194$var$encodeURIWhenNeeded(uri) {
    if ($96f79b7ca8336194$var$validURICharactersRegex.test(uri)) return uri;
    return encodeURI(uri);
}
const $96f79b7ca8336194$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $cMikx.ExtensionType).LoadParser,
        priority: (0, $fVQLb.LoaderParserPriority).Low
    },
    name: "loadWebFont",
    test (url) {
        return (0, $57Ubo.checkDataUrl)(url, $96f79b7ca8336194$var$validFontMIMEs) || (0, $lyYOs.checkExtension)(url, $96f79b7ca8336194$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $aY7HM.DOMAdapter).get().getFontFaceSet();
        if (fonts) {
            const fontFaces = [];
            const name = options.data?.family ?? $96f79b7ca8336194$export$c461ca8f39d93d9b(url);
            const weights = options.data?.weights?.filter((weight)=>$96f79b7ca8336194$var$validWeights.includes(weight)) ?? [
                "normal"
            ];
            const data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i];
                const font = new FontFace(name, `url(${$96f79b7ca8336194$var$encodeURIWhenNeeded(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load();
                fonts.add(font);
                fontFaces.push(font);
            }
            (0, $Wu73P.Cache).set(`${name}-and-url`, {
                url: url,
                fontFaces: fontFaces
            });
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        (0, $hKoNS.warn)("[loadWebFont] FontFace API is not supported. Skipping loading font");
        return null;
    },
    unload (font) {
        (Array.isArray(font) ? font : [
            font
        ]).forEach((t)=>{
            (0, $Wu73P.Cache).remove(`${t.family}-and-url`);
            (0, $aY7HM.DOMAdapter).get().getFontFaceSet().delete(t);
        });
    }
};

});

parcelRegister("byJDg", function(module, exports) {

$parcel$export(module.exports, "loadSvg", () => $05ab9e5717562599$export$b6a2e78b63791dfa);

var $aY7HM = parcelRequire("aY7HM");

var $cMikx = parcelRequire("cMikx");

var $c0TgU = parcelRequire("c0TgU");

var $gJl7e = parcelRequire("gJl7e");

var $3A2Ze = parcelRequire("3A2Ze");

var $57Ubo = parcelRequire("57Ubo");

var $lyYOs = parcelRequire("lyYOs");

var $fVQLb = parcelRequire("fVQLb");

var $hbKjY = parcelRequire("hbKjY");
"use strict";
const $05ab9e5717562599$var$validSVGExtension = ".svg";
const $05ab9e5717562599$var$validSVGMIME = "image/svg+xml";
const $05ab9e5717562599$export$b6a2e78b63791dfa = {
    extension: {
        type: (0, $cMikx.ExtensionType).LoadParser,
        priority: (0, $fVQLb.LoaderParserPriority).Low,
        name: "loadSVG"
    },
    name: "loadSVG",
    config: {
        crossOrigin: "anonymous",
        parseAsGraphicsContext: false
    },
    test (url) {
        return (0, $57Ubo.checkDataUrl)(url, $05ab9e5717562599$var$validSVGMIME) || (0, $lyYOs.checkExtension)(url, $05ab9e5717562599$var$validSVGExtension);
    },
    async load (url, asset, loader) {
        if (asset.data?.parseAsGraphicsContext ?? this.config.parseAsGraphicsContext) return $05ab9e5717562599$var$loadAsGraphics(url);
        return $05ab9e5717562599$var$loadAsTexture(url, asset, loader, this.config.crossOrigin);
    },
    unload (asset) {
        asset.destroy(true);
    }
};
async function $05ab9e5717562599$var$loadAsTexture(url, asset, loader, crossOrigin) {
    const response = await (0, $aY7HM.DOMAdapter).get().fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const image = new Image();
    image.src = blobUrl;
    image.crossOrigin = crossOrigin;
    await image.decode();
    URL.revokeObjectURL(blobUrl);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const resolution = asset.data?.resolution || (0, $3A2Ze.getResolutionOfUrl)(url);
    const width = asset.data?.width ?? image.width;
    const height = asset.data?.height ?? image.height;
    canvas.width = width * resolution;
    canvas.height = height * resolution;
    context.drawImage(image, 0, 0, width * resolution, height * resolution);
    const { parseAsGraphicsContext: _p, ...rest } = asset.data ?? {};
    const base = new (0, $c0TgU.ImageSource)({
        resource: canvas,
        alphaMode: "premultiply-alpha-on-upload",
        resolution: resolution,
        ...rest
    });
    return (0, $hbKjY.createTexture)(base, loader, url);
}
async function $05ab9e5717562599$var$loadAsGraphics(url) {
    const response = await (0, $aY7HM.DOMAdapter).get().fetch(url);
    const svgSource = await response.text();
    const context = new (0, $gJl7e.GraphicsContext)();
    context.svg(svgSource);
    return context;
}

});
parcelRegister("3A2Ze", function(module, exports) {

$parcel$export(module.exports, "getResolutionOfUrl", () => $c94ade671df3efcf$export$8695ab2f322d2637);

var $e3x48 = parcelRequire("e3x48");
"use strict";
function $c94ade671df3efcf$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $e3x48.Resolver).RETINA_PREFIX?.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue;
}

});

parcelRegister("hbKjY", function(module, exports) {

$parcel$export(module.exports, "createTexture", () => $5b06a0a22bf518be$export$37b981a8c575f415);

var $7Ix7i = parcelRequire("7Ix7i");

var $hKoNS = parcelRequire("hKoNS");

var $Wu73P = parcelRequire("Wu73P");
"use strict";
function $5b06a0a22bf518be$export$37b981a8c575f415(source, loader, url) {
    source.label = url;
    source._sourceOrigin = url;
    const texture = new (0, $7Ix7i.Texture)({
        source: source,
        label: url
    });
    const unload = ()=>{
        delete loader.promiseCache[url];
        if ((0, $Wu73P.Cache).has(url)) (0, $Wu73P.Cache).remove(url);
    };
    texture.source.once("destroy", ()=>{
        if (loader.promiseCache[url]) {
            (0, $hKoNS.warn)("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource.");
            unload();
        }
    });
    texture.once("destroy", ()=>{
        if (!source.destroyed) {
            (0, $hKoNS.warn)("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture.");
            unload();
        }
    });
    return texture;
}

});


parcelRegister("i7HuW", function(module, exports) {

$parcel$export(module.exports, "loadTextures", () => $ed2b76cd7cf16fb8$export$897b113ee8307cd0);

var $aY7HM = parcelRequire("aY7HM");

var $cMikx = parcelRequire("cMikx");

var $c0TgU = parcelRequire("c0TgU");

var $3A2Ze = parcelRequire("3A2Ze");

var $57Ubo = parcelRequire("57Ubo");

var $lyYOs = parcelRequire("lyYOs");

var $2qLRS = parcelRequire("2qLRS");

var $fVQLb = parcelRequire("fVQLb");

var $hbKjY = parcelRequire("hbKjY");
"use strict";
const $ed2b76cd7cf16fb8$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
];
const $ed2b76cd7cf16fb8$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $ed2b76cd7cf16fb8$export$c614e6247302006d(url, asset) {
    const response = await (0, $aY7HM.DOMAdapter).get().fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    return asset?.data?.alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, {
        premultiplyAlpha: "none"
    }) : createImageBitmap(imageBlob);
}
const $ed2b76cd7cf16fb8$export$897b113ee8307cd0 = {
    name: "loadTextures",
    extension: {
        type: (0, $cMikx.ExtensionType).LoadParser,
        priority: (0, $fVQLb.LoaderParserPriority).High,
        name: "loadTextures"
    },
    config: {
        preferWorkers: true,
        preferCreateImageBitmap: true,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $57Ubo.checkDataUrl)(url, $ed2b76cd7cf16fb8$var$validImageMIMEs) || (0, $lyYOs.checkExtension)(url, $ed2b76cd7cf16fb8$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        let src = null;
        if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
            if (this.config.preferWorkers && await (0, $2qLRS.WorkerManager).isImageBitmapSupported()) src = await (0, $2qLRS.WorkerManager).loadImageBitmap(url, asset);
            else src = await $ed2b76cd7cf16fb8$export$c614e6247302006d(url, asset);
        } else src = await new Promise((resolve, reject)=>{
            src = new Image();
            src.crossOrigin = this.config.crossOrigin;
            src.src = url;
            if (src.complete) resolve(src);
            else {
                src.onload = ()=>{
                    resolve(src);
                };
                src.onerror = reject;
            }
        });
        const base = new (0, $c0TgU.ImageSource)({
            resource: src,
            alphaMode: "premultiply-alpha-on-upload",
            resolution: asset.data?.resolution || (0, $3A2Ze.getResolutionOfUrl)(url),
            ...asset.data
        });
        return (0, $hbKjY.createTexture)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(true);
    }
};

});
parcelRegister("2qLRS", function(module, exports) {

$parcel$export(module.exports, "WorkerManager", () => $a0cecceb0ad43d98$export$bcff6015853c67ce);

var $5qmvQ = parcelRequire("5qmvQ");

var $5s8JL = parcelRequire("5s8JL");
"use strict";
let $a0cecceb0ad43d98$var$UUID = 0;
let $a0cecceb0ad43d98$var$MAX_WORKERS;
class $a0cecceb0ad43d98$var$WorkerManagerClass {
    constructor(){
        this._initialized = false;
        this._createdWorkers = 0;
        this._workerPool = [];
        this._queue = [];
        this._resolveHash = {};
    }
    isImageBitmapSupported() {
        if (this._isImageBitmapSupported !== void 0) return this._isImageBitmapSupported;
        this._isImageBitmapSupported = new Promise((resolve)=>{
            const { worker: worker } = new (0, $5qmvQ.default)();
            worker.addEventListener("message", (event)=>{
                worker.terminate();
                (0, $5qmvQ.default).revokeObjectURL();
                resolve(event.data);
            });
        });
        return this._isImageBitmapSupported;
    }
    loadImageBitmap(src, asset) {
        return this._run("loadImageBitmap", [
            src,
            asset?.data?.alphaMode
        ]);
    }
    async _initWorkers() {
        if (this._initialized) return;
        this._initialized = true;
    }
    _getWorker() {
        if ($a0cecceb0ad43d98$var$MAX_WORKERS === void 0) $a0cecceb0ad43d98$var$MAX_WORKERS = navigator.hardwareConcurrency || 4;
        let worker = this._workerPool.pop();
        if (!worker && this._createdWorkers < $a0cecceb0ad43d98$var$MAX_WORKERS) {
            this._createdWorkers++;
            worker = new (0, $5s8JL.default)().worker;
            worker.addEventListener("message", (event)=>{
                this._complete(event.data);
                this._returnWorker(event.target);
                this._next();
            });
        }
        return worker;
    }
    _returnWorker(worker) {
        this._workerPool.push(worker);
    }
    _complete(data) {
        if (data.error !== void 0) this._resolveHash[data.uuid].reject(data.error);
        else this._resolveHash[data.uuid].resolve(data.data);
        this._resolveHash[data.uuid] = null;
    }
    async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this._queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        this._next();
        return promise;
    }
    _next() {
        if (!this._queue.length) return;
        const worker = this._getWorker();
        if (!worker) return;
        const toDo = this._queue.pop();
        const id = toDo.id;
        this._resolveHash[$a0cecceb0ad43d98$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        };
        worker.postMessage({
            data: toDo.arguments,
            uuid: $a0cecceb0ad43d98$var$UUID++,
            id: id
        });
    }
}
const $a0cecceb0ad43d98$export$bcff6015853c67ce = new $a0cecceb0ad43d98$var$WorkerManagerClass();

});
parcelRegister("5qmvQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3e9cc3f29992358$export$2e2bcd8739ae039);
const $c3e9cc3f29992358$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    const WHITE_PNG = \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=\";\n    async function checkImageBitmap() {\n      try {\n        if (typeof createImageBitmap !== \"function\")\n          return false;\n        const response = await fetch(WHITE_PNG);\n        const imageBlob = await response.blob();\n        const imageBitmap = await createImageBitmap(imageBlob);\n        return imageBitmap.width === 1 && imageBitmap.height === 1;\n      } catch (_e) {\n        return false;\n      }\n    }\n    void checkImageBitmap().then((result) => {\n      self.postMessage(result);\n    });\n\n})();\n";
let $c3e9cc3f29992358$var$WORKER_URL = null;
class $c3e9cc3f29992358$export$2e2bcd8739ae039 {
    constructor(){
        if (!$c3e9cc3f29992358$var$WORKER_URL) $c3e9cc3f29992358$var$WORKER_URL = URL.createObjectURL(new Blob([
            $c3e9cc3f29992358$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($c3e9cc3f29992358$var$WORKER_URL);
    }
}
$c3e9cc3f29992358$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($c3e9cc3f29992358$var$WORKER_URL) {
        URL.revokeObjectURL($c3e9cc3f29992358$var$WORKER_URL);
        $c3e9cc3f29992358$var$WORKER_URL = null;
    }
};

});

parcelRegister("5s8JL", function(module, exports) {

$parcel$export(module.exports, "default", () => $449e176c3c6c22ff$export$2e2bcd8739ae039);
const $449e176c3c6c22ff$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    async function loadImageBitmap(url, alphaMode) {\n      const response = await fetch(url);\n      if (!response.ok) {\n        throw new Error(`[WorkerManager.loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);\n      }\n      const imageBlob = await response.blob();\n      return alphaMode === \"premultiplied-alpha\" ? createImageBitmap(imageBlob, { premultiplyAlpha: \"none\" }) : createImageBitmap(imageBlob);\n    }\n    self.onmessage = async (event) => {\n      try {\n        const imageBitmap = await loadImageBitmap(event.data.data[0], event.data.data[1]);\n        self.postMessage({\n          data: imageBitmap,\n          uuid: event.data.uuid,\n          id: event.data.id\n        }, [imageBitmap]);\n      } catch (e) {\n        self.postMessage({\n          error: e,\n          uuid: event.data.uuid,\n          id: event.data.id\n        });\n      }\n    };\n\n})();\n";
let $449e176c3c6c22ff$var$WORKER_URL = null;
class $449e176c3c6c22ff$export$2e2bcd8739ae039 {
    constructor(){
        if (!$449e176c3c6c22ff$var$WORKER_URL) $449e176c3c6c22ff$var$WORKER_URL = URL.createObjectURL(new Blob([
            $449e176c3c6c22ff$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($449e176c3c6c22ff$var$WORKER_URL);
    }
}
$449e176c3c6c22ff$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($449e176c3c6c22ff$var$WORKER_URL) {
        URL.revokeObjectURL($449e176c3c6c22ff$var$WORKER_URL);
        $449e176c3c6c22ff$var$WORKER_URL = null;
    }
};

});



parcelRegister("arIUQ", function(module, exports) {

$parcel$export(module.exports, "loadVideoTextures", () => $4649a5e5564cac41$export$68fa0976ba667d63);

var $cMikx = parcelRequire("cMikx");

var $K9X5x = parcelRequire("K9X5x");

var $kMtu5 = parcelRequire("kMtu5");

var $3A2Ze = parcelRequire("3A2Ze");

var $57Ubo = parcelRequire("57Ubo");

var $lyYOs = parcelRequire("lyYOs");

var $hbKjY = parcelRequire("hbKjY");
"use strict";
const $4649a5e5564cac41$var$validVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogg",
    ".ogv",
    ".h264",
    ".avi",
    ".mov"
];
const $4649a5e5564cac41$var$validVideoMIMEs = $4649a5e5564cac41$var$validVideoExtensions.map((ext)=>`video/${ext.substring(1)}`);
function $4649a5e5564cac41$export$c47cb7c63271266e(element, url, crossorigin) {
    if (crossorigin === void 0 && !url.startsWith("data:")) element.crossOrigin = $4649a5e5564cac41$export$292083da55c5b406(url);
    else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === "string" ? crossorigin : "anonymous";
}
function $4649a5e5564cac41$export$856bfbe81968ff62(element) {
    return new Promise((resolve, reject)=>{
        element.addEventListener("canplaythrough", loaded);
        element.addEventListener("error", error);
        element.load();
        function loaded() {
            cleanup();
            resolve();
        }
        function error(err) {
            cleanup();
            reject(err);
        }
        function cleanup() {
            element.removeEventListener("canplaythrough", loaded);
            element.removeEventListener("error", error);
        }
    });
}
function $4649a5e5564cac41$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc || (loc = globalThis.location);
    const parsedUrl = new URL(url, document.baseURI);
    if (parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol) return "anonymous";
    return "";
}
const $4649a5e5564cac41$export$68fa0976ba667d63 = {
    name: "loadVideo",
    extension: {
        type: (0, $cMikx.ExtensionType).LoadParser,
        name: "loadVideo"
    },
    test (url) {
        const isValidDataUrl = (0, $57Ubo.checkDataUrl)(url, $4649a5e5564cac41$var$validVideoMIMEs);
        const isValidExtension = (0, $lyYOs.checkExtension)(url, $4649a5e5564cac41$var$validVideoExtensions);
        return isValidDataUrl || isValidExtension;
    },
    async load (url, asset, loader) {
        const options = {
            ...(0, $K9X5x.VideoSource).defaultOptions,
            resolution: asset.data?.resolution || (0, $3A2Ze.getResolutionOfUrl)(url),
            alphaMode: asset.data?.alphaMode || await (0, $kMtu5.detectVideoAlphaMode)(),
            ...asset.data
        };
        const videoElement = document.createElement("video");
        const attributeMap = {
            preload: options.autoLoad !== false ? "auto" : void 0,
            "webkit-playsinline": options.playsinline !== false ? "" : void 0,
            playsinline: options.playsinline !== false ? "" : void 0,
            muted: options.muted === true ? "" : void 0,
            loop: options.loop === true ? "" : void 0,
            autoplay: options.autoPlay !== false ? "" : void 0
        };
        Object.keys(attributeMap).forEach((key)=>{
            const value = attributeMap[key];
            if (value !== void 0) videoElement.setAttribute(key, value);
        });
        if (options.muted === true) videoElement.muted = true;
        $4649a5e5564cac41$export$c47cb7c63271266e(videoElement, url, options.crossorigin);
        const sourceElement = document.createElement("source");
        let mime;
        if (url.startsWith("data:")) mime = url.slice(5, url.indexOf(";"));
        else if (!url.startsWith("blob:")) {
            const ext = url.split("?")[0].slice(url.lastIndexOf(".") + 1).toLowerCase();
            mime = (0, $K9X5x.VideoSource).MIME_TYPES[ext] || `video/${ext}`;
        }
        sourceElement.src = url;
        if (mime) sourceElement.type = mime;
        return new Promise((resolve)=>{
            const onCanPlay = async ()=>{
                const base = new (0, $K9X5x.VideoSource)({
                    ...options,
                    resource: videoElement
                });
                videoElement.removeEventListener("canplay", onCanPlay);
                if (asset.data.preload) await $4649a5e5564cac41$export$856bfbe81968ff62(videoElement);
                resolve((0, $hbKjY.createTexture)(base, loader, url));
            };
            if (options.preload && !options.autoPlay) videoElement.load();
            videoElement.addEventListener("canplay", onCanPlay);
            videoElement.appendChild(sourceElement);
        });
    },
    unload (texture) {
        texture.destroy(true);
    }
};

});

parcelRegister("hC5MO", function(module, exports) {

$parcel$export(module.exports, "resolveJsonUrl", () => $76bd9a1ddafede62$export$2b5cca0b89cb089c);

var $cMikx = parcelRequire("cMikx");

var $e3x48 = parcelRequire("e3x48");

var $1MYfV = parcelRequire("1MYfV");
"use strict";
const $76bd9a1ddafede62$export$2b5cca0b89cb089c = {
    extension: {
        type: (0, $cMikx.ExtensionType).ResolveParser,
        priority: -2,
        name: "resolveJson"
    },
    test: (value)=>(0, $e3x48.Resolver).RETINA_PREFIX.test(value) && value.endsWith(".json"),
    parse: (0, $1MYfV.resolveTextureUrl).parse
};

});
parcelRegister("1MYfV", function(module, exports) {

$parcel$export(module.exports, "resolveTextureUrl", () => $6edae31b75e16c6f$export$cc356fa83de02bea);

var $cMikx = parcelRequire("cMikx");

var $i7HuW = parcelRequire("i7HuW");

var $e3x48 = parcelRequire("e3x48");
"use strict";
const $6edae31b75e16c6f$export$cc356fa83de02bea = {
    extension: {
        type: (0, $cMikx.ExtensionType).ResolveParser,
        name: "resolveTexture"
    },
    test: (0, $i7HuW.loadTextures).test,
    parse: (value)=>({
            resolution: parseFloat((0, $e3x48.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};

});



parcelRegister("lBai8", function(module, exports) {

$parcel$export(module.exports, "NineSliceSprite", () => $df80615b3c927adf$export$ea7c4e309714d712);

var $i0rEf = parcelRequire("i0rEf");

var $7Ix7i = parcelRequire("7Ix7i");

var $1Ki8H = parcelRequire("1Ki8H");

var $jXfjX = parcelRequire("jXfjX");

var $3jgt7 = parcelRequire("3jgt7");
"use strict";
const $df80615b3c927adf$var$_NineSliceSprite = class _NineSliceSprite extends (0, $jXfjX.ViewContainer) {
    constructor(options){
        if (options instanceof (0, $7Ix7i.Texture)) options = {
            texture: options
        };
        const { width: width, height: height, anchor: anchor, leftWidth: leftWidth, rightWidth: rightWidth, topHeight: topHeight, bottomHeight: bottomHeight, texture: texture, roundPixels: roundPixels, ...rest } = options;
        super({
            label: "NineSliceSprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "nineSliceSprite";
        /** @internal */ this.batched = true;
        this._leftWidth = leftWidth ?? texture?.defaultBorders?.left ?? (0, $3jgt7.NineSliceGeometry).defaultOptions.leftWidth;
        this._topHeight = topHeight ?? texture?.defaultBorders?.top ?? (0, $3jgt7.NineSliceGeometry).defaultOptions.topHeight;
        this._rightWidth = rightWidth ?? texture?.defaultBorders?.right ?? (0, $3jgt7.NineSliceGeometry).defaultOptions.rightWidth;
        this._bottomHeight = bottomHeight ?? texture?.defaultBorders?.bottom ?? (0, $3jgt7.NineSliceGeometry).defaultOptions.bottomHeight;
        this._width = width ?? texture.width ?? (0, $3jgt7.NineSliceGeometry).defaultOptions.width;
        this._height = height ?? texture.height ?? (0, $3jgt7.NineSliceGeometry).defaultOptions.height;
        this.allowChildren = false;
        this.texture = texture ?? _NineSliceSprite.defaultOptions.texture;
        this.roundPixels = roundPixels ?? false;
        this._anchor = new (0, $i0rEf.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (this.texture.defaultAnchor) this.anchor = this.texture.defaultAnchor;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The width of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The width affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed width
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     width: 200  // Sets initial width
   * });
   *
   * // Adjust width dynamically
   * panel.width = 300;  // Stretches middle sections
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#height} For setting height
   */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
        this.onViewUpdate();
    }
    /**
   * The height of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The height affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed height
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     height: 150  // Sets initial height
   * });
   *
   * // Adjust height dynamically
   * panel.height = 200;  // Stretches middle sections
   *
   * // Create responsive UI element
   * const dialog = new NineSliceSprite({
   *     texture: Texture.from('dialog.png'),
   *     topHeight: 30,
   *     bottomHeight: 30,
   *     height: parent.height * 0.5  // 50% of parent height
   * });
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#width} For setting width
   */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
        this.onViewUpdate();
    }
    /**
   * Sets the size of the NineSliceSprite to the specified width and height.
   * This method directly modifies the vertices and UV coordinates of the sprite.
   *
   * Using this is more efficient than setting width and height separately as it only triggers one update.
   * @example
   * ```ts
   * // Set to specific dimensions
   * panel.setSize(300, 200); // Width: 300, Height: 200
   *
   * // Set uniform size
   * panel.setSize(200); // Makes a square 200x200
   *
   * // Set size using object
   * panel.setSize({
   *     width: 400,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a Size object with width/height properties
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link NineSliceSprite#width} For setting width only
   * @see {@link NineSliceSprite#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        }
        this._width = value;
        this._height = height ?? value;
        this.onViewUpdate();
    }
    /**
   * Retrieves the size of the NineSliceSprite as a [Size]{@link Size} object.
   * This method is more efficient than getting width and height separately.
   * @example
   * ```ts
   * // Get basic size
   * const size = panel.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * panel.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the NineSliceSprite
   * @see {@link NineSliceSprite#width} For getting just the width
   * @see {@link NineSliceSprite#height} For getting just the height
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   */ getSize(out) {
        out || (out = {});
        out.width = this._width;
        out.height = this._height;
        return out;
    }
    /**
   * Width of the left vertical bar (A).
   * Controls the size of the left edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., leftWidth: 20 });
   * sprite.leftWidth = 20; // Set left border width
   * ```
   * @default 10
   */ get leftWidth() {
        return this._leftWidth;
    }
    set leftWidth(value) {
        this._leftWidth = value;
        this.onViewUpdate();
    }
    /**
   * Height of the top horizontal bar (C).
   * Controls the size of the top edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., topHeight: 20 });
   * sprite.topHeight = 20; // Set top border height
   * ```
   * @default 10
   */ get topHeight() {
        return this._topHeight;
    }
    set topHeight(value) {
        this._topHeight = value;
        this.onViewUpdate();
    }
    /**
   * Width of the right vertical bar (B).
   * Controls the size of the right edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., rightWidth: 20 });
   * sprite.rightWidth = 20; // Set right border width
   * ```
   * @default 10
   */ get rightWidth() {
        return this._rightWidth;
    }
    set rightWidth(value) {
        this._rightWidth = value;
        this.onViewUpdate();
    }
    /**
   * Height of the bottom horizontal bar (D).
   * Controls the size of the bottom edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., bottomHeight: 20 });
   * sprite.bottomHeight = 20; // Set bottom border height
   * ```
   * @default 10
   */ get bottomHeight() {
        return this._bottomHeight;
    }
    set bottomHeight(value) {
        this._bottomHeight = value;
        this.onViewUpdate();
    }
    /**
   * The texture to use on the NineSliceSprite.
   * ```ts
   * // Create a sprite with a texture
   * const sprite = new NineSliceSprite({
   *     texture: Texture.from('path/to/image.png')
   * });
   * // Update the texture later
   * sprite.texture = Texture.from('path/to/another-image.png');
   * ```
   * @default Texture.EMPTY
   */ get texture() {
        return this._texture;
    }
    set texture(value) {
        value || (value = (0, $7Ix7i.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        this.onViewUpdate();
    }
    /**
   * The original width of the texture before any nine-slice scaling.
   * This is the width of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.width = sprite.originalWidth * 2; // Double the original width
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#width} For the current displayed width
   * @see {@link Texture#width} For direct texture width access
   * @returns The original width of the texture
   */ get originalWidth() {
        return this._texture.width;
    }
    /**
   * The original height of the texture before any nine-slice scaling.
   * This is the height of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.height = sprite.originalHeight * 2; // Double the original height
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#height} For the current displayed height
   * @see {@link Texture#height} For direct texture height access
   * @returns The original height of the texture
   */ get originalHeight() {
        return this._texture.height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * nineSliceSprite.destroy();
   * nineSliceSprite.destroy(true);
   * nineSliceSprite.destroy({ texture: true, textureSource: true });
   */ destroy(options) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        const width = this._width;
        const height = this._height;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
};
/**
 * The default options used to override initial values of any options passed in the constructor.
 * These values are used as fallbacks when specific options are not provided.
 * @example
 * ```ts
 * // Override default options globally
 * NineSliceSprite.defaultOptions.texture = Texture.from('defaultButton.png');
 * // Create sprite with default texture
 * const sprite = new NineSliceSprite({...});
 * // sprite will use 'defaultButton.png' as its texture
 *
 * // Reset to empty texture
 * NineSliceSprite.defaultOptions.texture = Texture.EMPTY;
 * ```
 * @type {NineSliceSpriteOptions}
 * @see {@link NineSliceSpriteOptions} For all available options
 * @see {@link Texture#defaultBorders} For texture-level border settings
 */ $df80615b3c927adf$var$_NineSliceSprite.defaultOptions = {
    /** @default Texture.EMPTY */ texture: (0, $7Ix7i.Texture).EMPTY
};
let $df80615b3c927adf$export$ea7c4e309714d712 = $df80615b3c927adf$var$_NineSliceSprite;
class $df80615b3c927adf$export$acdf4cb3f489544e extends $df80615b3c927adf$export$ea7c4e309714d712 {
    constructor(...args){
        let options = args[0];
        if (options instanceof (0, $7Ix7i.Texture)) {
            (0, $1Ki8H.deprecation)((0, $1Ki8H.v8_0_0), "NineSlicePlane now uses the options object {texture, leftWidth, rightWidth, topHeight, bottomHeight}");
            options = {
                texture: options,
                leftWidth: args[1],
                topHeight: args[2],
                rightWidth: args[3],
                bottomHeight: args[4]
            };
        }
        (0, $1Ki8H.deprecation)((0, $1Ki8H.v8_0_0), "NineSlicePlane is deprecated. Use NineSliceSprite instead.");
        super(options);
    }
}

});

parcelRegister("28zzx", function(module, exports) {

$parcel$export(module.exports, "Text", () => $d540f5fc9e14d6f4$export$5f1af8db9871e1d6);

var $dnMlr = parcelRequire("dnMlr");

var $1LHE7 = parcelRequire("1LHE7");

var $iBLNk = parcelRequire("iBLNk");

var $2eRNU = parcelRequire("2eRNU");

var $4wdrc = parcelRequire("4wdrc");
"use strict";
class $d540f5fc9e14d6f4$export$5f1af8db9871e1d6 extends (0, $1LHE7.AbstractText) {
    constructor(...args){
        const options = (0, $1LHE7.ensureTextOptions)(args, "Text");
        super(options, (0, $4wdrc.TextStyle));
        /** @internal */ this.renderPipeId = "text";
        if (options.textureStyle) this.textureStyle = options.textureStyle instanceof (0, $dnMlr.TextureStyle) ? options.textureStyle : new (0, $dnMlr.TextureStyle)(options.textureStyle);
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        let width = 0;
        let height = 0;
        if (this._style.trim) {
            const { frame: frame, canvasAndContext: canvasAndContext } = (0, $iBLNk.CanvasTextGenerator).getCanvasAndContext({
                text: this.text,
                style: this._style,
                resolution: 1
            });
            (0, $iBLNk.CanvasTextGenerator).returnCanvasAndContext(canvasAndContext);
            width = frame.width;
            height = frame.height;
        } else {
            const canvasMeasurement = (0, $2eRNU.CanvasTextMetrics).measureText(this._text, this._style);
            width = canvasMeasurement.width;
            height = canvasMeasurement.height;
        }
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}

});
parcelRegister("1LHE7", function(module, exports) {

$parcel$export(module.exports, "AbstractText", () => $abf504e452dd1f16$export$daf74670712de91);
$parcel$export(module.exports, "ensureTextOptions", () => $abf504e452dd1f16$export$8ddfb4f614f8ed86);

var $i0rEf = parcelRequire("i0rEf");

var $1Ki8H = parcelRequire("1Ki8H");

var $jXfjX = parcelRequire("jXfjX");
"use strict";
class $abf504e452dd1f16$export$daf74670712de91 extends (0, $jXfjX.ViewContainer) {
    constructor(options, styleClass){
        const { text: text, resolution: resolution, style: style, anchor: anchor, width: width, height: height, roundPixels: roundPixels, ...rest } = options;
        super({
            ...rest
        });
        /** @internal */ this.batched = true;
        /** @internal */ this._resolution = null;
        /** @internal */ this._autoResolution = true;
        /** @internal */ this._didTextUpdate = true;
        this._styleClass = styleClass;
        this.text = text ?? "";
        this.style = style;
        this.resolution = resolution ?? null;
        this.allowChildren = false;
        this._anchor = new (0, $i0rEf.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * The anchor point of the text that controls the origin point for positioning and rotation.
   * Can be a number (same value for x/y) or a PointData object.
   * - (0,0) is top-left
   * - (0.5,0.5) is center
   * - (1,1) is bottom-right
   * ```ts
   * // Set anchor to center
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: 0.5 // Same as { x: 0.5, y: 0.5 }
   * });
   * // Set anchor to top-left
   * const text2 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 0, y: 0 } // Top-left corner
   * });
   * // Set anchor to bottom-right
   * const text3 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 1, y: 1 } // Bottom-right corner
   * });
   * ```
   * @default { x: 0, y: 0 }
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The text content to display. Use '\n' for line breaks.
   * Accepts strings, numbers, or objects with toString() method.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   * });
   * const multilineText = new Text({
   *     text: 'Line 1\nLine 2\nLine 3',
   * });
   * const numberText = new Text({
   *     text: 12345, // Will be converted to '12345'
   * });
   * const objectText = new Text({
   *     text: { toString: () => 'Object Text' }, // Custom toString
   * });
   *
   * // Update text dynamically
   * text.text = 'Updated Text'; // Re-renders with new text
   * text.text = 67890; // Updates to '67890'
   * text.text = { toString: () => 'Dynamic Text' }; // Uses custom toString method
   * // Clear text
   * text.text = ''; // Clears the text
   * ```
   * @default ''
   */ set text(value) {
        value = value.toString();
        if (this._text === value) return;
        this._text = value;
        this.onViewUpdate();
    }
    get text() {
        return this._text;
    }
    /**
   * The resolution/device pixel ratio for rendering.
   * Higher values result in sharper text at the cost of performance.
   * Set to null for auto-resolution based on device.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     resolution: 2 // High DPI for sharper text
   * });
   * const autoResText = new Text({
   *     text: 'Auto Resolution',
   *     resolution: null // Use device's pixel ratio
   * });
   * ```
   * @default null
   */ set resolution(value) {
        this._autoResolution = value === null;
        this._resolution = value;
        this.onViewUpdate();
    }
    get resolution() {
        return this._resolution;
    }
    get style() {
        return this._style;
    }
    /**
   * The style configuration for the text.
   * Can be a TextStyle instance or a configuration object.
   * Supports canvas text styles, HTML text styles, and bitmap text styles.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Styled Text',
   *     style: {
   *         fontSize: 24,
   *         fill: 0xff1010, // Red color
   *         fontFamily: 'Arial',
   *         align: 'center', // Center alignment
   *         stroke: { color: '#4a1850', width: 5 }, // Purple stroke
   *         dropShadow: {
   *             color: '#000000', // Black shadow
   *             blur: 4, // Shadow blur
   *             distance: 6 // Shadow distance
   *         }
   *     }
   * });
   * const htmlText = new HTMLText({
   *     text: 'HTML Styled Text',
   *     style: {
   *         fontSize: '20px',
   *         fill: 'blue',
   *         fontFamily: 'Verdana',
   *     }
   * });
   * const bitmapText = new BitmapText({
   *     text: 'Bitmap Styled Text',
   *     style: {
   *         fontName: 'Arial',
   *         fontSize: 32,
   *     }
   * })
   *
   * // Update style dynamically
   * text.style = {
   *     fontSize: 30, // Change font size
   *     fill: 0x00ff00, // Change color to green
   *     align: 'right', // Change alignment to right
   *     stroke: { color: '#000000', width: 2 }, // Add black stroke
   * }
   */ set style(style) {
        style || (style = {});
        this._style?.off("update", this.onViewUpdate, this);
        if (style instanceof this._styleClass) this._style = style;
        else this._style = new this._styleClass(style);
        this._style.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * texture.width = 200;
   * console.log(texture.scale.x); // Scale adjusted to match width
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this.bounds.width;
    }
    set width(value) {
        this._setWidth(value, this.bounds.width);
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * texture.height = 200;
   * console.log(texture.scale.y); // Scale adjusted to match height
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this.bounds.height;
    }
    set height(value) {
        this._setHeight(value, this.bounds.height);
    }
    /**
   * Retrieves the size of the Text as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     style: { fontSize: 24 }
   * });
   * const size = text.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * text.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Text#width} For getting just the width
   * @see {@link Text#height} For getting just the height
   * @see {@link Text#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this.bounds.width;
        out.height = Math.abs(this.scale.y) * this.bounds.height;
        return out;
    }
    /**
   * Sets the size of the Text to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const text = new Text({
   *    text: 'Hello Pixi!',
   *    style: { fontSize: 24 }
   * });
   * text.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * text.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * text.setSize({
   *     width: 200,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Text#width} For setting width only
   * @see {@link Text#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this.bounds.width);
        height !== void 0 && this._setHeight(height, this.bounds.height);
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the text's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = text.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the text's bounds
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const width = this.bounds.width;
        const height = this.bounds.height;
        const x1 = -width * this.anchor.x;
        let y1 = 0;
        if (point.x >= x1 && point.x <= x1 + width) {
            y1 = -height * this.anchor.y;
            if (point.y >= y1 && point.y <= y1 + height) return true;
        }
        return false;
    }
    /** @internal */ onViewUpdate() {
        if (!this.didViewUpdate) this._didTextUpdate = true;
        super.onViewUpdate();
    }
    /**
   * Destroys this text renderable and optionally its style texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroys the text and its style
   * text.destroy({ style: true, texture: true, textureSource: true });
   * text.destroy(true);
   * text.destroy() // Destroys the text, but not its style
   */ destroy(options = false) {
        super.destroy(options);
        this.owner = null;
        this._bounds = null;
        this._anchor = null;
        if (typeof options === "boolean" ? options : options?.style) this._style.destroy(options);
        this._style = null;
        this._text = null;
    }
}
function $abf504e452dd1f16$export$8ddfb4f614f8ed86(args, name) {
    let options = args[0] ?? {};
    if (typeof options === "string" || args[1]) {
        (0, $1Ki8H.deprecation)((0, $1Ki8H.v8_0_0), `use new ${name}({ text: "hi!", style }) instead`);
        options = {
            text: options,
            style: args[1]
        };
    }
    return options;
}

});



parcelRegister("3JQTS", function(module, exports) {

$parcel$export(module.exports, "EnumRootEventBus", () => $89186b6754ab1927$export$f8b196b0adfd67bd);
$parcel$export(module.exports, "RootEventBus", () => $89186b6754ab1927$export$e361388e3caa8d9e);
parcelRequire("83ZZo");
var $98bME = parcelRequire("98bME");
var $89186b6754ab1927$export$f8b196b0adfd67bd = /*#__PURE__*/ function(EnumRootEventBus) {
    EnumRootEventBus["onVideoMode"] = "ON_VIDEO_MODE";
    EnumRootEventBus["setInfoSliderPage"] = "SET_INFO_SLIDER_PAGE";
    EnumRootEventBus["setInfoSliderPageWArr"] = "SET_INFO_SLIDER_PAGE_WITH_ARROW";
    EnumRootEventBus["setCurPage"] = "SET_CURRENT_PAGE";
    EnumRootEventBus["updateEdgeState"] = "UPDATE_EDGE_STATE";
    EnumRootEventBus["startIntroAnim"] = "START_INTRODUCTION_ANIMATION";
    EnumRootEventBus["completedIntroAnim"] = "COMPLETED_INTRODUCTION_ANIMATION";
    EnumRootEventBus["setRedPointTag"] = "SET_RED_POINT_TAG";
    EnumRootEventBus["setRedPointCoord"] = "SET_RED_POINT_COORD";
    EnumRootEventBus["setRefRadians"] = "SET_REFERANCE_RADIANS";
    EnumRootEventBus["getCircleCoord"] = "GET_CIRCLE_COORD";
    EnumRootEventBus["drawElements"] = "DRAW_ELEMENTS";
    return EnumRootEventBus;
}({});
const $89186b6754ab1927$export$e361388e3caa8d9e = new (0, (/*@__PURE__*/$parcel$interopDefault($98bME)))();

});

parcelRegister("9e8jK", function(module, exports) {

$parcel$export(module.exports, "default", () => $325eaa2a51897581$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");

var $d55ji = parcelRequire("d55ji");

var $hGj9y = parcelRequire("hGj9y");

var $gOEUv = parcelRequire("gOEUv");
class $325eaa2a51897581$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(){
        super(), this.Game = (0, $d55ji.default).getInstance();
        if (!$325eaa2a51897581$export$2e2bcd8739ae039.instance) $325eaa2a51897581$export$2e2bcd8739ae039.instance = this;
        this.Bottom = new $325eaa2a51897581$var$BaseLayer();
        this.Middle = new $325eaa2a51897581$var$BaseLayer();
        this.Top = new $325eaa2a51897581$var$BaseLayer();
        this.Info = new $325eaa2a51897581$var$BaseLayer();
        this.UI = new $325eaa2a51897581$var$BaseLayer();
        this.VideoMode = new $325eaa2a51897581$var$BaseLayer();
        this.UI.interactive = true;
        this.checkVideoMode();
        this.addToStage();
    }
    checkVideoMode() {
        const params = new URLSearchParams(window.location.search);
        const videoMode = params.get("videomode");
        if (videoMode) {
            new (0, $gOEUv.default)();
            new (0, $hGj9y.default)();
        }
    }
    addToStage() {
        this.Game.stage.addChild(this);
    }
    static getInstance() {
        return $325eaa2a51897581$export$2e2bcd8739ae039.instance;
    }
}
class $325eaa2a51897581$var$BaseLayer extends $d7k7b.Container {
    constructor(){
        super(), this.Layers = $325eaa2a51897581$export$2e2bcd8739ae039.getInstance(), this.addToLayers = ()=>this.Layers.addChild(this);
        this.addToLayers();
    }
}

});
parcelRegister("hGj9y", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c8d1b489fa0bd18$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $ly9yM = parcelRequire("ly9yM");

var $d55ji = parcelRequire("d55ji");

var $9e8jK = parcelRequire("9e8jK");
class $3c8d1b489fa0bd18$export$2e2bcd8739ae039 extends $ly9yM.Graphics {
    constructor(){
        super(), this.Game = (0, $d55ji.default).getInstance(), this.Layers = (0, $9e8jK.default).getInstance(), this.addToLayer = ()=>this.Layers.VideoMode.addChild(this);
        this.draw();
        this.followPointer();
        this.addToLayer();
    }
    draw() {
        this.circle(0, 0, 20).fill("yellow").alpha = .5;
    }
    followPointer() {
        this.Layers.UI.on("pointermove", (e)=>{
            this.position.copyFrom(e.data.global);
        });
    }
}

});

parcelRegister("gOEUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef34ad277769c83$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $7FQQW = parcelRequire("7FQQW");

var $9e8jK = parcelRequire("9e8jK");

var $ge12w = parcelRequire("ge12w");

var $99f70 = parcelRequire("99f70");
const $6ef34ad277769c83$var$LOGO_PATH = "/logo-small.png";
class $6ef34ad277769c83$export$2e2bcd8739ae039 extends $7FQQW.Sprite {
    constructor(){
        super(), this.Layers = (0, $9e8jK.default).getInstance();
        Object.assign(this, (0, $99f70.LOGO_BOUNDS));
        this.anchor.set(.5);
        this.texture = (0, $ge12w.default).getTexture($6ef34ad277769c83$var$LOGO_PATH);
        this.Layers.VideoMode.addChild(this);
    }
}

});
parcelRegister("ge12w", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a722ae0abbd0b1$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $2eXAo = parcelRequire("2eXAo");
var $7Ix7i = parcelRequire("7Ix7i");

var $99f70 = parcelRequire("99f70");
class $98a722ae0abbd0b1$export$2e2bcd8739ae039 {
    static{
        this.basePath = (0, $99f70.BASE_PATH);
    }
    static{
        this.logoPath = `${this.basePath}${0, $99f70.LOGO_PATH}`;
    }
    constructor(){}
    static{
        this.getLogo = ()=>new $7Ix7i.Texture(this.logo);
    }
    static async load(assetsList, cb) {
        this.assetList = [
            ...assetsList.map((asset)=>`${this.basePath}${asset}`)
        ];
        this.textures = await $2eXAo.Assets.load(this.assetList, (p)=>cb(Math.floor(p * 100)));
    }
    static async loadLogo() {
        this.logo = await $2eXAo.Assets.load(this.logoPath);
    }
    static getTexture(_path) {
        const path = `${this.basePath}${_path}`;
        let Texture = this.textures[path];
        if (!Texture) {
            console.log("Texture is not found", path);
            Texture = $7Ix7i.Texture.WHITE;
        }
        return new $7Ix7i.Texture(Texture);
    }
}

});
parcelRegister("99f70", function(module, exports) {

$parcel$export(module.exports, "INITIAL_WIDTH", () => $c7aaed061f837cfb$export$f288ef2b564392e7);
$parcel$export(module.exports, "INITIAL_HEIGHT", () => $c7aaed061f837cfb$export$bcc993773d425214);
$parcel$export(module.exports, "INITIAL_CIRCLE_RADIUS", () => $c7aaed061f837cfb$export$f5c0794bc0266f1);
$parcel$export(module.exports, "GUIDE_TEXT_COORD", () => $c7aaed061f837cfb$export$158208f930a33a87);
$parcel$export(module.exports, "CENTER_ANGLE_COLOR", () => $c7aaed061f837cfb$export$c4ea4e1e5a8f943);
$parcel$export(module.exports, "CIRCUM_ANGLE_COLOR", () => $c7aaed061f837cfb$export$1b467e970dd19e37);
$parcel$export(module.exports, "INFO_SLIDER_DIMS", () => $c7aaed061f837cfb$export$6cb4ba5e1687d4db);
$parcel$export(module.exports, "LOGO_BOUNDS", () => $c7aaed061f837cfb$export$64f72e9985500875);
$parcel$export(module.exports, "BASE_PATH", () => $c7aaed061f837cfb$export$2812a1fb15aca49c);
$parcel$export(module.exports, "ROOT_ASSETS_LIST", () => $c7aaed061f837cfb$export$1dfe9ddb85bd80cb);
$parcel$export(module.exports, "LOGO_PATH", () => $c7aaed061f837cfb$export$6a3201cd80ff343f);
const $c7aaed061f837cfb$export$f288ef2b564392e7 = 1600;
const $c7aaed061f837cfb$export$bcc993773d425214 = 900;
const $c7aaed061f837cfb$export$f5c0794bc0266f1 = 200;
const $c7aaed061f837cfb$export$158208f930a33a87 = {
    x: 50,
    y: 20
};
const $c7aaed061f837cfb$export$c4ea4e1e5a8f943 = {
    color: 0xFC99C4,
    textColor: 0xf94f6f
};
const $c7aaed061f837cfb$export$1b467e970dd19e37 = {
    color: 0x21D4FE,
    textColor: 0x0195b8
};
const $c7aaed061f837cfb$export$6cb4ba5e1687d4db = {
    width: 405,
    height: 270
};
const $c7aaed061f837cfb$export$64f72e9985500875 = {
    x: 1550,
    y: 100,
    width: 134,
    height: 134
};
const $c7aaed061f837cfb$export$2812a1fb15aca49c = "/static/images";
const $c7aaed061f837cfb$export$1dfe9ddb85bd80cb = [
    "/default.png",
    "/logo.png",
    "/logo-small.png",
    "/info-slider/mask.png",
    "/info-slider/arrow.png"
];
const $c7aaed061f837cfb$export$6a3201cd80ff343f = "/logo.png";

});




parcelRegister("kHSrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $348124b1edd11ebe$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $7FQQW = parcelRequire("7FQQW");
var $7Ix7i = parcelRequire("7Ix7i");

var $d55ji = parcelRequire("d55ji");

var $9e8jK = parcelRequire("9e8jK");

var $3JQTS = parcelRequire("3JQTS");

var $6vXZw = parcelRequire("6vXZw");
class $348124b1edd11ebe$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(){
        super(), this.Game = (0, $d55ji.default).getInstance(), this.Layers = (0, $9e8jK.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.circleCoord = {
            x: 100,
            y: 100
        }, this.lastUnixTime = 0, this.addToLayer = ()=>this.Layers.UI.addChild(this), this.handleMouseup = ()=>this.setRedPointTag(""), this.setRedPointTag = (PointTag)=>this.RedPointTag = PointTag;
        this.addBg();
        this.addToLayer();
        this.on("mousemove", (e)=>this.handleMousemove(e));
        this.on("touchmove", (e)=>this.handleMousemove(e));
        this.on("mouseup", ()=>this.handleMouseup());
        this.on("touchend", ()=>this.handleMouseup());
        this.on("mouseupoutside", ()=>this.handleMouseup());
        this.on("touchendoutside", ()=>this.handleMouseup());
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).setRedPointTag, (PointTag)=>this.setRedPointTag(PointTag));
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.interactive = true);
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).getCircleCoord, (coord)=>this.circleCoord = coord);
    }
    addBg() {
        const texture = new $7Ix7i.Texture($7Ix7i.Texture.EMPTY);
        const sprite = new $7FQQW.Sprite(texture);
        const dim = this.Game.getDim();
        sprite.width = dim.WIDTH;
        sprite.height = dim.HEIGHT;
        sprite.x = 0;
        sprite.y = 0;
        this.addChild(sprite);
    }
    handleMousemove(e) {
        const UnixTime = Date.now();
        if (this.RedPointTag == "" || this.RedPointTag == undefined || UnixTime < this.lastUnixTime + 10) return;
        this.lastUnixTime = UnixTime;
        let radian = (0, $6vXZw.default)(this.circleCoord, e.global);
        this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).setRedPointCoord, [
            {
                pTag: this.RedPointTag,
                radian: radian
            }
        ]);
    }
}

});
parcelRegister("6vXZw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b065a614bd22dd9$export$2e2bcd8739ae039);
function $4b065a614bd22dd9$export$2e2bcd8739ae039(cStart, cEnd) {
    return Number(Math.atan2(cEnd.y - cStart.y, cEnd.x - cStart.x).toFixed(4));
}

});


parcelRegister("eFtsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6d3744458a525e$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");
class $2e6d3744458a525e$export$2e2bcd8739ae039 {
    constructor(){}
    update(delta) {
        (0, $lyHkj.default).update(delta);
    }
}

});
parcelRegister("lyHkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e61b8a8c2565f$export$2e2bcd8739ae039);

var $2cEQi = parcelRequire("2cEQi");
var $fb1e61b8a8c2565f$var$NOW;
// Include a performance.now polyfill.
// In node.js, use process.hrtime.
// @ts-ignore
if (typeof self === 'undefined' && typeof $2cEQi !== 'undefined' && $2cEQi.hrtime) $fb1e61b8a8c2565f$var$NOW = function() {
    // @ts-ignore
    var time = $2cEQi.hrtime();
    // Convert [seconds, nanoseconds] to milliseconds.
    return time[0] * 1000 + time[1] / 1000000;
};
else if (typeof self !== 'undefined' && self.performance !== undefined && self.performance.now !== undefined) // This must be bound, because directly assigning this function
// leads to an invocation exception in Chrome.
$fb1e61b8a8c2565f$var$NOW = self.performance.now.bind(self.performance);
else if (Date.now !== undefined) $fb1e61b8a8c2565f$var$NOW = Date.now;
else $fb1e61b8a8c2565f$var$NOW = function() {
    return new Date().getTime();
};
var $fb1e61b8a8c2565f$var$NOW$1 = $fb1e61b8a8c2565f$var$NOW;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var $fb1e61b8a8c2565f$var$Group = /** @class */ function() {
    function Group() {
        this._tweens = {};
        this._tweensAddedDuringUpdate = {};
    }
    Group.prototype.getAll = function() {
        var _this = this;
        return Object.keys(this._tweens).map(function(tweenId) {
            return _this._tweens[tweenId];
        });
    };
    Group.prototype.removeAll = function() {
        this._tweens = {};
    };
    Group.prototype.add = function(tween) {
        this._tweens[tween.getId()] = tween;
        this._tweensAddedDuringUpdate[tween.getId()] = tween;
    };
    Group.prototype.remove = function(tween) {
        delete this._tweens[tween.getId()];
        delete this._tweensAddedDuringUpdate[tween.getId()];
    };
    Group.prototype.update = function(time, preserve) {
        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) return false;
        time = time !== undefined ? time : $fb1e61b8a8c2565f$var$NOW$1();
        // Tweens are updated in "batches". If you add a new tween during an
        // update, then the new tween will be updated in the next batch.
        // If you remove a tween during an update, it may or may not be updated.
        // However, if the removed tween was added during the current batch,
        // then it will not be updated.
        while(tweenIds.length > 0){
            this._tweensAddedDuringUpdate = {};
            for(var i = 0; i < tweenIds.length; i++){
                var tween = this._tweens[tweenIds[i]];
                if (tween && tween.update(time) === false) {
                    tween.playing = false;
                    if (!preserve) delete this._tweens[tweenIds[i]];
                }
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }
        return true;
    };
    return Group;
}();
/**
 * The Ease class provides a collection of easing functions for use with tween.js.
 */ var $fb1e61b8a8c2565f$var$Easing = {
    Linear: {
        None: function(amount) {
            return amount;
        }
    },
    Quadratic: {
        In: function(amount) {
            return amount * amount;
        },
        Out: function(amount) {
            return amount * (2 - amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount;
            return -0.5 * (--amount * (amount - 2) - 1);
        }
    },
    Cubic: {
        In: function(amount) {
            return amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount + 2);
        }
    },
    Quartic: {
        In: function(amount) {
            return amount * amount * amount * amount;
        },
        Out: function(amount) {
            return 1 - --amount * amount * amount * amount;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount;
            return -0.5 * ((amount -= 2) * amount * amount * amount - 2);
        }
    },
    Quintic: {
        In: function(amount) {
            return amount * amount * amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount * amount * amount + 2);
        }
    },
    Sinusoidal: {
        In: function(amount) {
            return 1 - Math.cos(amount * Math.PI / 2);
        },
        Out: function(amount) {
            return Math.sin(amount * Math.PI / 2);
        },
        InOut: function(amount) {
            return 0.5 * (1 - Math.cos(Math.PI * amount));
        }
    },
    Exponential: {
        In: function(amount) {
            return amount === 0 ? 0 : Math.pow(1024, amount - 1);
        },
        Out: function(amount) {
            return amount === 1 ? 1 : 1 - Math.pow(2, -10 * amount);
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            if ((amount *= 2) < 1) return 0.5 * Math.pow(1024, amount - 1);
            return 0.5 * (-Math.pow(2, -10 * (amount - 1)) + 2);
        }
    },
    Circular: {
        In: function(amount) {
            return 1 - Math.sqrt(1 - amount * amount);
        },
        Out: function(amount) {
            return Math.sqrt(1 - --amount * amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return -0.5 * (Math.sqrt(1 - amount * amount) - 1);
            return 0.5 * (Math.sqrt(1 - (amount -= 2) * amount) + 1);
        }
    },
    Elastic: {
        In: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return -Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
        },
        Out: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return Math.pow(2, -10 * amount) * Math.sin((amount - 0.1) * 5 * Math.PI) + 1;
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            amount *= 2;
            if (amount < 1) return -0.5 * Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
            return 0.5 * Math.pow(2, -10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI) + 1;
        }
    },
    Back: {
        In: function(amount) {
            var s = 1.70158;
            return amount * amount * ((s + 1) * amount - s);
        },
        Out: function(amount) {
            var s = 1.70158;
            return --amount * amount * ((s + 1) * amount + s) + 1;
        },
        InOut: function(amount) {
            var s = 2.5949095;
            if ((amount *= 2) < 1) return 0.5 * (amount * amount * ((s + 1) * amount - s));
            return 0.5 * ((amount -= 2) * amount * ((s + 1) * amount + s) + 2);
        }
    },
    Bounce: {
        In: function(amount) {
            return 1 - $fb1e61b8a8c2565f$var$Easing.Bounce.Out(1 - amount);
        },
        Out: function(amount) {
            if (amount < 1 / 2.75) return 7.5625 * amount * amount;
            else if (amount < 2 / 2.75) return 7.5625 * (amount -= 1.5 / 2.75) * amount + 0.75;
            else if (amount < 2.5 / 2.75) return 7.5625 * (amount -= 2.25 / 2.75) * amount + 0.9375;
            else return 7.5625 * (amount -= 2.625 / 2.75) * amount + 0.984375;
        },
        InOut: function(amount) {
            if (amount < 0.5) return $fb1e61b8a8c2565f$var$Easing.Bounce.In(amount * 2) * 0.5;
            return $fb1e61b8a8c2565f$var$Easing.Bounce.Out(amount * 2 - 1) * 0.5 + 0.5;
        }
    }
};
/**
 *
 */ var $fb1e61b8a8c2565f$var$Interpolation = {
    Linear: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = $fb1e61b8a8c2565f$var$Interpolation.Utils.Linear;
        if (k < 0) return fn(v[0], v[1], f);
        if (k > 1) return fn(v[m], v[m - 1], m - f);
        return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
    },
    Bezier: function(v, k) {
        var b = 0;
        var n = v.length - 1;
        var pw = Math.pow;
        var bn = $fb1e61b8a8c2565f$var$Interpolation.Utils.Bernstein;
        for(var i = 0; i <= n; i++)b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
        return b;
    },
    CatmullRom: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = $fb1e61b8a8c2565f$var$Interpolation.Utils.CatmullRom;
        if (v[0] === v[m]) {
            if (k < 0) i = Math.floor(f = m * (1 + k));
            return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
        } else {
            if (k < 0) return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
            if (k > 1) return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
            return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
        }
    },
    Utils: {
        Linear: function(p0, p1, t) {
            return (p1 - p0) * t + p0;
        },
        Bernstein: function(n, i) {
            var fc = $fb1e61b8a8c2565f$var$Interpolation.Utils.Factorial;
            return fc(n) / fc(i) / fc(n - i);
        },
        Factorial: function() {
            var a = [
                1
            ];
            return function(n) {
                var s = 1;
                if (a[n]) return a[n];
                for(var i = n; i > 1; i--)s *= i;
                a[n] = s;
                return s;
            };
        }(),
        CatmullRom: function(p0, p1, p2, p3, t) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
        }
    }
};
/**
 * Utils
 */ var $fb1e61b8a8c2565f$var$Sequence = /** @class */ function() {
    function Sequence() {}
    Sequence._nextId = 0;
    Sequence.nextId = function() {
        return Sequence._nextId++;
    };
    return Sequence;
}();
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ /**
 * A tween (from in-between) is a concept that allows you to change the values of the properties of an object in a
 * smooth way. You just tell it which properties you want to change, which final values should they have when the
 * tween finishes running, and how long should this take, and the tweening engine will take care of finding the
 * intermediate values from the starting to the ending point.
 */ var $fb1e61b8a8c2565f$var$Tween = /** @class */ function() {
    function Tween(object, groupRef) {
        this.playing = false;
        this.paused = false;
        this.pauseStart = 0;
        this.valuesStart = {};
        this.valuesEnd = {};
        this.valuesStartRepeat = {};
        this.durationValue = 1000;
        this.repeatValue = 0;
        this.yoyoValue = false;
        this.reversed = false;
        this.delayTime = 0;
        this.startTime = 0;
        this.easingFunction = $fb1e61b8a8c2565f$var$Easing.Linear.None;
        this.interpolationFunction = $fb1e61b8a8c2565f$var$Interpolation.Linear;
        this.chainedTweens = [];
        this.onStartCallbackFired = false;
        this.id = $fb1e61b8a8c2565f$var$Sequence.nextId();
        this.object = object;
        this.groupRef = groupRef || Tween.TWEEN;
    }
    Tween.inject = function(instance) {
        Tween.TWEEN = instance;
    };
    Tween.prototype.getId = function() {
        return this.id;
    };
    Tween.prototype.isPlaying = function() {
        return this.playing;
    };
    Tween.prototype.isPaused = function() {
        return this.paused;
    };
    Tween.prototype.to = function(properties, duration) {
        this.valuesEnd = Object.create(properties);
        if (duration !== undefined) this.durationValue = duration;
        return this;
    };
    Tween.prototype.duration = function(value) {
        this.durationValue = value;
        return this;
    };
    Tween.prototype.start = function(time) {
        this.groupRef.add(this);
        this.playing = true;
        this.paused = false;
        this.onStartCallbackFired = false;
        this.startTime = time !== undefined ? typeof time === 'string' ? $fb1e61b8a8c2565f$var$NOW$1() + parseFloat(time) : time : $fb1e61b8a8c2565f$var$NOW$1();
        this.startTime += this.delayTime;
        for(var property in this.valuesEnd){
            // Check if an Array was provided as property value
            if (this.valuesEnd[property] instanceof Array) {
                if (this.valuesEnd[property].length === 0) continue;
                // Create a local copy of the Array with the start value at the front
                this.valuesEnd[property] = [
                    this.object[property]
                ].concat(this.valuesEnd[property]);
            }
            // If `to()` specifies a property that doesn't exist in the source object,
            // we should not set that property in the object
            if (this.object[property] === undefined) continue;
            // Save the starting value, but only once.
            if (typeof this.valuesStart[property] === 'undefined') this.valuesStart[property] = this.object[property];
            if (this.valuesStart[property] instanceof Array === false) this.valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
            this.valuesStartRepeat[property] = this.valuesStart[property] || 0;
        }
        return this;
    };
    Tween.prototype.stop = function() {
        if (!this.playing) return this;
        this.groupRef.remove(this);
        this.playing = false;
        this.paused = false;
        if (this.onStopCallback) this.onStopCallback(this.object);
        this.stopChainedTweens();
        return this;
    };
    Tween.prototype.end = function() {
        this.update(Infinity);
        return this;
    };
    Tween.prototype.pause = function(time) {
        if (this.paused || !this.playing) return this;
        this.paused = true;
        this.pauseStart = time === undefined ? $fb1e61b8a8c2565f$var$NOW$1() : time;
        this.groupRef.remove(this);
        return this;
    };
    Tween.prototype.resume = function(time) {
        if (!this.paused || !this.playing) return this;
        this.paused = false;
        this.startTime += (time === undefined ? $fb1e61b8a8c2565f$var$NOW$1() : time) - this.pauseStart;
        this.pauseStart = 0;
        this.groupRef.add(this);
        return this;
    };
    Tween.prototype.stopChainedTweens = function() {
        for(var i = 0, numChainedTweens = this.chainedTweens.length; i < numChainedTweens; i++)this.chainedTweens[i].stop();
    };
    Tween.prototype.group = function(group) {
        this.groupRef = group;
        return this;
    };
    Tween.prototype.delay = function(amount) {
        this.delayTime = amount;
        return this;
    };
    Tween.prototype.repeat = function(times) {
        this.repeatValue = times;
        return this;
    };
    Tween.prototype.repeatDelay = function(amount) {
        this.repeatDelayTime = amount;
        return this;
    };
    Tween.prototype.yoyo = function(yoyo) {
        this.yoyoValue = yoyo;
        return this;
    };
    Tween.prototype.easing = function(easing) {
        this.easingFunction = easing;
        return this;
    };
    Tween.prototype.interpolation = function(interpolation) {
        this.interpolationFunction = interpolation;
        return this;
    };
    Tween.prototype.chain = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this.chainedTweens = tweens;
        return this;
    };
    Tween.prototype.onStart = function(callback) {
        this.onStartCallback = callback;
        return this;
    };
    Tween.prototype.onUpdate = function(callback) {
        this.onUpdateCallback = callback;
        return this;
    };
    Tween.prototype.onRepeat = function(callback) {
        this.onRepeatCallback = callback;
        return this;
    };
    Tween.prototype.onComplete = function(callback) {
        this.onCompleteCallback = callback;
        return this;
    };
    Tween.prototype.onStop = function(callback) {
        this.onStopCallback = callback;
        return this;
    };
    /**
     * Tween.js doesn't run by itself. You need to tell it when to run, by explicitly calling the update method.
     * The recommended method is to do this inside your main animation loop, which should be called with
     * requestAnimationFrame for getting the best graphics performance
     *
     * If called without parameters, update will determine the current time in order to find out how long has it been
     * since the last time it ran.
     *
     * @param time
     */ Tween.prototype.update = function(time) {
        if (time === void 0) time = 0;
        var property;
        var elapsed;
        var value;
        if (time < this.startTime) return true;
        if (this.onStartCallbackFired === false) {
            if (this.onStartCallback) this.onStartCallback(this.object);
            this.onStartCallbackFired = true;
        }
        elapsed = (time - this.startTime) / this.durationValue;
        elapsed = this.durationValue === 0 || elapsed > 1 ? 1 : elapsed;
        value = this.easingFunction(elapsed);
        for(property in this.valuesEnd){
            // Don't update properties that do not exist in the source object
            if (this.valuesStart[property] === undefined) continue;
            var start = this.valuesStart[property] || 0;
            var end = this.valuesEnd[property];
            if (end instanceof Array) this.object[property] = this.interpolationFunction(end, value);
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                if (typeof end === 'string') {
                    if (end.charAt(0) === '+' || end.charAt(0) === '-') end = start + parseFloat(end);
                    else end = parseFloat(end);
                }
                // Protect against non numeric properties.
                if (typeof end === 'number') this.object[property] = start + (end - start) * value;
            }
        }
        if (this.onUpdateCallback) this.onUpdateCallback(this.object, elapsed);
        if (elapsed === 1) {
            if (this.repeatValue > 0) {
                if (isFinite(this.repeatValue)) this.repeatValue--;
                // Reassign starting values, restart by making startTime = now
                for(property in this.valuesStartRepeat){
                    if (typeof this.valuesEnd[property] === 'string') this.valuesStartRepeat[property] = this.valuesStartRepeat[property] + parseFloat(this.valuesEnd[property]);
                    if (this.yoyoValue) {
                        var tmp = this.valuesStartRepeat[property];
                        this.valuesStartRepeat[property] = this.valuesEnd[property];
                        this.valuesEnd[property] = tmp;
                    }
                    this.valuesStart[property] = this.valuesStartRepeat[property];
                }
                if (this.yoyoValue) this.reversed = !this.reversed;
                if (this.repeatDelayTime !== undefined) this.startTime = time + this.repeatDelayTime;
                else this.startTime = time + this.delayTime;
                if (this.onRepeatCallback) this.onRepeatCallback(this.object);
                return true;
            } else {
                if (this.onCompleteCallback) this.onCompleteCallback(this.object);
                for(var i = 0, numChainedTweens = this.chainedTweens.length; i < numChainedTweens; i++)// Make the chained tweens start exactly at the time they should,
                // even if the `update()` method was called way past the duration of the tween
                this.chainedTweens[i].start(this.startTime + this.durationValue);
                return false;
            }
        }
        return true;
    };
    return Tween;
}();
var $fb1e61b8a8c2565f$var$VERSION = '18.6.0';
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var $fb1e61b8a8c2565f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var $fb1e61b8a8c2565f$var$Main = /** @class */ function(_super) {
    $fb1e61b8a8c2565f$var$__extends(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.version = $fb1e61b8a8c2565f$var$VERSION;
        _this.now = $fb1e61b8a8c2565f$var$NOW$1;
        _this.Group = $fb1e61b8a8c2565f$var$Group;
        _this.Easing = $fb1e61b8a8c2565f$var$Easing;
        _this.Interpolation = $fb1e61b8a8c2565f$var$Interpolation;
        _this.nextId = $fb1e61b8a8c2565f$var$Sequence.nextId;
        _this.Tween = $fb1e61b8a8c2565f$var$Tween;
        return _this;
    }
    return Main;
}($fb1e61b8a8c2565f$var$Group);
var $fb1e61b8a8c2565f$var$TWEEN = new $fb1e61b8a8c2565f$var$Main();
$fb1e61b8a8c2565f$var$Tween.inject($fb1e61b8a8c2565f$var$TWEEN);
var $fb1e61b8a8c2565f$export$2e2bcd8739ae039 = $fb1e61b8a8c2565f$var$TWEEN;

});
parcelRegister("2cEQi", function(module, exports) {
// shim for using process in browser
var $19ac623c8e71a05e$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $19ac623c8e71a05e$var$cachedSetTimeout;
var $19ac623c8e71a05e$var$cachedClearTimeout;
function $19ac623c8e71a05e$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $19ac623c8e71a05e$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $19ac623c8e71a05e$var$cachedSetTimeout = setTimeout;
        else $19ac623c8e71a05e$var$cachedSetTimeout = $19ac623c8e71a05e$var$defaultSetTimout;
    } catch (e) {
        $19ac623c8e71a05e$var$cachedSetTimeout = $19ac623c8e71a05e$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $19ac623c8e71a05e$var$cachedClearTimeout = clearTimeout;
        else $19ac623c8e71a05e$var$cachedClearTimeout = $19ac623c8e71a05e$var$defaultClearTimeout;
    } catch (e) {
        $19ac623c8e71a05e$var$cachedClearTimeout = $19ac623c8e71a05e$var$defaultClearTimeout;
    }
})();
function $19ac623c8e71a05e$var$runTimeout(fun) {
    if ($19ac623c8e71a05e$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($19ac623c8e71a05e$var$cachedSetTimeout === $19ac623c8e71a05e$var$defaultSetTimout || !$19ac623c8e71a05e$var$cachedSetTimeout) && setTimeout) {
        $19ac623c8e71a05e$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $19ac623c8e71a05e$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $19ac623c8e71a05e$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $19ac623c8e71a05e$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $19ac623c8e71a05e$var$runClearTimeout(marker) {
    if ($19ac623c8e71a05e$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($19ac623c8e71a05e$var$cachedClearTimeout === $19ac623c8e71a05e$var$defaultClearTimeout || !$19ac623c8e71a05e$var$cachedClearTimeout) && clearTimeout) {
        $19ac623c8e71a05e$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $19ac623c8e71a05e$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $19ac623c8e71a05e$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $19ac623c8e71a05e$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $19ac623c8e71a05e$var$queue = [];
var $19ac623c8e71a05e$var$draining = false;
var $19ac623c8e71a05e$var$currentQueue;
var $19ac623c8e71a05e$var$queueIndex = -1;
function $19ac623c8e71a05e$var$cleanUpNextTick() {
    if (!$19ac623c8e71a05e$var$draining || !$19ac623c8e71a05e$var$currentQueue) return;
    $19ac623c8e71a05e$var$draining = false;
    if ($19ac623c8e71a05e$var$currentQueue.length) $19ac623c8e71a05e$var$queue = $19ac623c8e71a05e$var$currentQueue.concat($19ac623c8e71a05e$var$queue);
    else $19ac623c8e71a05e$var$queueIndex = -1;
    if ($19ac623c8e71a05e$var$queue.length) $19ac623c8e71a05e$var$drainQueue();
}
function $19ac623c8e71a05e$var$drainQueue() {
    if ($19ac623c8e71a05e$var$draining) return;
    var timeout = $19ac623c8e71a05e$var$runTimeout($19ac623c8e71a05e$var$cleanUpNextTick);
    $19ac623c8e71a05e$var$draining = true;
    var len = $19ac623c8e71a05e$var$queue.length;
    while(len){
        $19ac623c8e71a05e$var$currentQueue = $19ac623c8e71a05e$var$queue;
        $19ac623c8e71a05e$var$queue = [];
        while(++$19ac623c8e71a05e$var$queueIndex < len)if ($19ac623c8e71a05e$var$currentQueue) $19ac623c8e71a05e$var$currentQueue[$19ac623c8e71a05e$var$queueIndex].run();
        $19ac623c8e71a05e$var$queueIndex = -1;
        len = $19ac623c8e71a05e$var$queue.length;
    }
    $19ac623c8e71a05e$var$currentQueue = null;
    $19ac623c8e71a05e$var$draining = false;
    $19ac623c8e71a05e$var$runClearTimeout(timeout);
}
$19ac623c8e71a05e$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $19ac623c8e71a05e$var$queue.push(new $19ac623c8e71a05e$var$Item(fun, args));
    if ($19ac623c8e71a05e$var$queue.length === 1 && !$19ac623c8e71a05e$var$draining) $19ac623c8e71a05e$var$runTimeout($19ac623c8e71a05e$var$drainQueue);
};
// v8 likes predictible objects
function $19ac623c8e71a05e$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$19ac623c8e71a05e$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$19ac623c8e71a05e$var$process.title = 'browser';
$19ac623c8e71a05e$var$process.browser = true;
$19ac623c8e71a05e$var$process.env = {};
$19ac623c8e71a05e$var$process.argv = [];
$19ac623c8e71a05e$var$process.version = ''; // empty string to avoid regexp issues
$19ac623c8e71a05e$var$process.versions = {};
function $19ac623c8e71a05e$var$noop() {}
$19ac623c8e71a05e$var$process.on = $19ac623c8e71a05e$var$noop;
$19ac623c8e71a05e$var$process.addListener = $19ac623c8e71a05e$var$noop;
$19ac623c8e71a05e$var$process.once = $19ac623c8e71a05e$var$noop;
$19ac623c8e71a05e$var$process.off = $19ac623c8e71a05e$var$noop;
$19ac623c8e71a05e$var$process.removeListener = $19ac623c8e71a05e$var$noop;
$19ac623c8e71a05e$var$process.removeAllListeners = $19ac623c8e71a05e$var$noop;
$19ac623c8e71a05e$var$process.emit = $19ac623c8e71a05e$var$noop;
$19ac623c8e71a05e$var$process.prependListener = $19ac623c8e71a05e$var$noop;
$19ac623c8e71a05e$var$process.prependOnceListener = $19ac623c8e71a05e$var$noop;
$19ac623c8e71a05e$var$process.listeners = function(name) {
    return [];
};
$19ac623c8e71a05e$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$19ac623c8e71a05e$var$process.cwd = function() {
    return '/';
};
$19ac623c8e71a05e$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$19ac623c8e71a05e$var$process.umask = function() {
    return 0;
};

});



parcelRegister("fX4To", function(module, exports) {

$parcel$export(module.exports, "default", () => $52dd4134d59bc275$export$2e2bcd8739ae039);

var $wctnt = parcelRequire("wctnt");
function $52dd4134d59bc275$export$2e2bcd8739ae039(INITIAL_WIDTH, INITIAL_HEIGHT) {
    let iWidth = window.innerWidth;
    let iHeight = window.innerHeight;
    const { width: width, height: height } = $52dd4134d59bc275$var$checkConDim();
    if (width && height) {
        iWidth = width;
        iHeight = height;
    }
    const dims = (0, $wctnt.default)(INITIAL_WIDTH, INITIAL_HEIGHT, iWidth, iHeight);
    let dimsAndScale = {
        WIDTH: dims.width,
        HEIGHT: dims.height,
        SCALE: dims.scale
    };
    return dimsAndScale;
}
function $52dd4134d59bc275$var$checkConDim() {
    const params = new URLSearchParams(window.location.search);
    const width = Number(params.get("width"));
    const height = Number(params.get("height"));
    return {
        width: width,
        height: height
    };
}

});
parcelRegister("wctnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c849cdf5fe7a1ddc$export$2e2bcd8739ae039);
function $c849cdf5fe7a1ddc$export$2e2bcd8739ae039(width, height, innerW, innerH) {
    let w = width;
    let h = height;
    if (innerH > innerW) {
        w = height;
        h = width;
    }
    let scaleW = innerW / w;
    let scaleH = innerH / h;
    let scale = scaleW > scaleH ? scaleH : scaleW;
    let newWidth = scaleW > scaleH ? innerW / scale : w;
    let newHeight = scaleW > scaleH ? innerH / scale : h;
    return {
        scale: scale,
        width: newWidth,
        height: newHeight
    };
}

});


parcelRegister("dAMJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ea6e9a73c47380$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $ly9yM = parcelRequire("ly9yM");
var $7FQQW = parcelRequire("7FQQW");
var $28zzx = parcelRequire("28zzx");

var $d55ji = parcelRequire("d55ji");

var $ge12w = parcelRequire("ge12w");

var $bSgxu = parcelRequire("bSgxu");

var $gErQO = parcelRequire("gErQO");
const $27ea6e9a73c47380$var$Bar = {
    width: 400,
    height: 60,
    radius: 10
};
class $27ea6e9a73c47380$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(handlePress){
        super(), this.Game = (0, $d55ji.default).getInstance(), this.elementScale = .5;
        this.handlePress = handlePress;
        this.addCoord();
        this.isVertical();
        this.addLogo();
        this.drawLoadingBarBg();
        this.addLoadingButton();
        this.addCheckbox();
        this.addToStage();
    }
    addCoord() {
        const dim = this.Game.getDim();
        this.coord = {
            x: dim.WIDTH / 2,
            y: dim.HEIGHT * 5 / 8
        };
    }
    addCheckbox() {
        const dim = this.Game.getDim();
        const x = this.coord.x - 200 * this.elementScale;
        const y = this.coord.y + 80 * this.elementScale;
        this.FsCheckbox = new (0, $gErQO.default)({
            x: x,
            y: y
        }, "Fullscreen", 0xf94f6f, true);
        this.FsCheckbox.scale.set(dim.WIDTH < dim.HEIGHT ? .8 : .6);
        this.addChild(this.FsCheckbox);
    }
    isVertical() {
        const dim = this.Game.getDim();
        if (dim.WIDTH < dim.HEIGHT) this.elementScale = .8;
        return dim.WIDTH < dim.HEIGHT;
    }
    addLogo() {
        const logoTexture = (0, $ge12w.default).getLogo();
        const logo = new $7FQQW.Sprite(logoTexture);
        logo.anchor.set(.5);
        logo.scale.set(this.elementScale);
        logo.x = this.coord.x;
        logo.y = this.coord.y - 260 * this.elementScale;
        this.addChild(logo);
    }
    drawLoadingBarBg() {
        const bg = new $ly9yM.Graphics().roundRect(-$27ea6e9a73c47380$var$Bar.width / 2, -$27ea6e9a73c47380$var$Bar.height / 2, $27ea6e9a73c47380$var$Bar.width, $27ea6e9a73c47380$var$Bar.height, $27ea6e9a73c47380$var$Bar.radius).fill(0xEFEFEF);
        bg.scale.set(this.elementScale);
        Object.assign(bg, this.coord);
        this.addChild(bg);
    }
    addLoadingButton() {
        this.button = new $ly9yM.Graphics().roundRect(-$27ea6e9a73c47380$var$Bar.width / 2, -$27ea6e9a73c47380$var$Bar.height / 2, 0, $27ea6e9a73c47380$var$Bar.height, $27ea6e9a73c47380$var$Bar.radius);
        Object.assign(this.button, this.coord);
        this.button.scale.set(this.elementScale);
        this.buttonTitle = new $28zzx.Text({
            text: "Start Game"
        });
        this.buttonTitle.style.fill = 0x0195b8;
        this.buttonTitle.style.fontSize = 40;
        this.buttonTitle.anchor.set(.5);
        this.buttonTitle.visible = false;
        this.buttonTitle.scale.set(this.elementScale);
        Object.assign(this.buttonTitle, this.coord);
        this.addChild(this.button, this.buttonTitle);
    }
    addButtonInteractivity() {
        const handleButton = ()=>{
            this.visible = false;
            const isFullscreen = this.FsCheckbox.getIsChecked().isChecked;
            isFullscreen && (0, $bSgxu.default)();
            setTimeout(()=>this.handlePress(), isFullscreen ? 100 : 0);
        };
        this.button.interactive = true;
        this.button.cursor = "pointer";
        this.button.on("mouseup", ()=>handleButton());
        this.button.on("touchend", ()=>handleButton());
    }
    drawLoadingButton(percent) {
        const barWidth = percent / 100 * $27ea6e9a73c47380$var$Bar.width;
        this.button.clear();
        if (percent == 100) {
            this.buttonTitle.visible = true;
            this.button.roundRect(-$27ea6e9a73c47380$var$Bar.width / 2, -$27ea6e9a73c47380$var$Bar.height / 2, $27ea6e9a73c47380$var$Bar.width, $27ea6e9a73c47380$var$Bar.height, $27ea6e9a73c47380$var$Bar.radius).fill(0x21D4FE);
            this.addButtonInteractivity();
            return;
        }
        this.button.roundRect(-$27ea6e9a73c47380$var$Bar.width / 2, -$27ea6e9a73c47380$var$Bar.height / 2, barWidth, $27ea6e9a73c47380$var$Bar.height, $27ea6e9a73c47380$var$Bar.radius).fill(0x21D4FE);
    }
    addToStage() {
        this.Game.stage.addChild(this);
    }
}

});
parcelRegister("bSgxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a1ee2628cf79d60$export$2e2bcd8739ae039);
function $0a1ee2628cf79d60$export$2e2bcd8739ae039() {
    const el = document.documentElement;
    if (el.requestFullscreen) el.requestFullscreen();
    else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
    else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
    else if (el.msRequestFullscreen) el.msRequestFullscreen();
    //@ts-ignore
    if (window.webkitFullscreen) //@ts-ignore
    window.webkitFullscreen.endabled();
}

});

parcelRegister("gErQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6cb654b09b0ec7$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $ly9yM = parcelRequire("ly9yM");
var $28zzx = parcelRequire("28zzx");

var $9e8jK = parcelRequire("9e8jK");
class $7e6cb654b09b0ec7$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(coord, label, color, useCustomLayer = false, handleFunc = (label, v)=>{}){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.isChecked = false, this.addToLayer = ()=>this.Layers.addChild(this);
        Object.assign(this, coord);
        this.checkBoxLabel = label;
        this.color = color;
        this.handleFunc = handleFunc;
        this.addCheckbox();
        this.addLabel();
        this.addInteractivity();
        !useCustomLayer && this.addToLayer();
    }
    addCheckbox() {
        this.checkedSquare = new $ly9yM.Graphics();
        this.drawCheckbox();
        this.addChild(this.checkedSquare);
    }
    addLabel() {
        const text = new $28zzx.Text({
            text: this.checkBoxLabel
        });
        text.style.fontSize = 36;
        text.style.fill = this.color;
        text.anchor.set(0, .5);
        text.x = 50;
        text.y = 0;
        this.addChild(text);
    }
    drawCheckbox() {
        const fillColor = this.isChecked ? this.color : 0xFFFFFF;
        this.checkedSquare.clear().roundRect(0, -20, 40, 40, 10).fill(fillColor).stroke({
            width: 2,
            color: 0x000000
        });
    }
    addInteractivity() {
        this.interactive = true;
        this.cursor = "pointer";
        this.on("mouseup", ()=>this.handleCheckbox());
        this.on("touchend", ()=>this.handleCheckbox());
    }
    handleCheckbox() {
        this.isChecked = !this.isChecked;
        this.handleFunc(this.checkBoxLabel, this.isChecked);
        this.drawCheckbox();
    }
    getIsChecked() {
        return {
            label: this.checkBoxLabel,
            isChecked: this.isChecked
        };
    }
}

});



parcelRegister("2wguv", function(module, exports) {

$parcel$export(module.exports, "default", () => $035fbd44a2418458$export$2e2bcd8739ae039);

var $93yRI = parcelRequire("93yRI");

var $1yS4F = parcelRequire("1yS4F");

var $2Msgp = parcelRequire("2Msgp");

var $er2zg = parcelRequire("er2zg");

var $3JQTS = parcelRequire("3JQTS");
class $035fbd44a2418458$export$2e2bcd8739ae039 {
    constructor(cCoord, CIRCLE_RADIUS, RADIANS){
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.pointInitialRadians = [];
        this.pointRadians = [];
        this.pointRefRadians = [];
        this.pointRedCoords = [];
        this.RedPointsArr = [];
        this.setAllVisible = (v)=>[
                this.circlePoint,
                ...this.RedPointsArr
            ].forEach((p)=>p.visible = v);
        this.getRadians = ()=>this.pointRadians;
        this.getInitialRadians = ()=>this.pointInitialRadians;
        this.getRefRadians = ()=>this.pointRefRadians;
        this.getRedPoints = ()=>this.RedPointsArr;
        this.getPoints = ()=>[
                this.circlePoint,
                ...this.RedPointsArr
            ];
        this.getPointsCoord = ()=>[
                this.cCoord,
                ...this.pointRedCoords
            ];
        this.getRedPointsCoord = ()=>this.pointRedCoords;
        this.addSetCoordExtraCode = (cb)=>this.addSetCoordExtraCode = cb;
        this.emitRedPointTag = (PointTag)=>this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).setRedPointTag, PointTag);
        this.setRefRadians = ()=>this.pointRefRadians = [
                ...this.pointRadians
            ];
        if (!$035fbd44a2418458$export$2e2bcd8739ae039.instance) $035fbd44a2418458$export$2e2bcd8739ae039.instance = this;
        const radians = RADIANS.map((r)=>(0, $er2zg.normalizeRadian)(r));
        this.cCoord = cCoord;
        this.circleRadius = CIRCLE_RADIUS;
        this.pointInitialRadians = [
            ...radians
        ];
        this.pointRefRadians = [
            ...radians
        ];
        this.pointRadians = radians;
        this.RedPointsArr = Array(radians.length).fill(null).map((_, vI)=>`p${vI + 1}`).map((pT)=>new (0, $1yS4F.default)(pT, this.cCoord, (pT)=>this.emitRedPointTag(pT), ()=>this.emitRedPointTag("")));
        this.circlePoint = new (0, $93yRI.default)(this.cCoord);
        this.pointRedCoords = (0, $2Msgp.default)(this.cCoord, this.pointRadians, this.circleRadius);
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).setRedPointCoord, (arr)=>this.setRadian(arr));
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).setRefRadians, ()=>this.setRefRadians());
    }
    static{
        this.getInstance = ()=>$035fbd44a2418458$export$2e2bcd8739ae039.instance;
    }
    //setCoord and setRadius are the public-facing method that can be overridden by subclasses.
    setCoord() {
        this._setCoord();
    }
    setRadian(pointInfoArr, isSlider = false) {
        this._setRadian(pointInfoArr, isSlider);
    }
    draw() {
        const points = this.getPoints();
        [
            this.circlePoint,
            ...this.RedPointsArr
        ].forEach((p, pI)=>p.draw(points[pI]));
    }
    _setRadian(pointInfoArr, isSlider = false) {
        const points = this.getRedPoints();
        points.forEach((p, pI)=>{
            pointInfoArr.forEach((pInfo)=>{
                if (p.tag == pInfo.pTag) {
                    const radian = (0, $er2zg.normalizeRadian)(pInfo.radian);
                    this.pointRadians[pI] = radian;
                    if (isSlider == false) this.pointRefRadians[pI] = radian;
                    this.setCoord();
                }
            });
        });
    }
    _setCoord() {
        this.pointRedCoords = (0, $2Msgp.default)(this.cCoord, this.pointRadians, this.circleRadius);
        this.RedPointsArr.forEach((point, pIndex)=>Object.assign(point, this.pointRedCoords[pIndex]));
        this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).drawElements);
    }
}

});
parcelRegister("93yRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3d58bdc2bd6817$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $ly9yM = parcelRequire("ly9yM");

var $d55ji = parcelRequire("d55ji");

var $9e8jK = parcelRequire("9e8jK");
class $0f3d58bdc2bd6817$export$2e2bcd8739ae039 extends $ly9yM.Graphics {
    constructor(coord){
        super(), this.Game = (0, $d55ji.default).getInstance(), this.Layers = (0, $9e8jK.default).getInstance(), this.fillColor = 0x000000, this.addToLayer = ()=>this.Layers.UI.addChild(this);
        Object.assign(this, coord);
        this.addToLayer();
    }
    draw(coord) {
        const dim = this.Game.getDim();
        const isVertical = dim.WIDTH < dim.HEIGHT;
        this.clear();
        Object.assign(this, coord);
        this.circle(0, 0, 10).fill({
            color: this.fillColor
        });
        isVertical && this.circle(0, 0, 50).fill({
            color: "blue",
            alpha: 0
        });
    }
}

});

parcelRegister("1yS4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10ba3a30d3e8421$export$2e2bcd8739ae039);

var $93yRI = parcelRequire("93yRI");
class $b10ba3a30d3e8421$export$2e2bcd8739ae039 extends (0, $93yRI.default) {
    constructor(tag, coord, handleDown, handleUp){
        super(coord);
        this.interactive = true;
        this.tag = tag;
        this.fillColor = 0xFF0000;
        this.cursor = "grab";
        this.on("mousedown", ()=>handleDown(this.tag));
        this.on("touchstart", ()=>handleDown(this.tag));
        this.on("mouseup", ()=>handleUp());
        this.on("touchend", ()=>handleUp());
    }
}

});

parcelRegister("2Msgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0292d1e6baf5905$export$2e2bcd8739ae039);

var $eWmIy = parcelRequire("eWmIy");
function $e0292d1e6baf5905$export$2e2bcd8739ae039(centerCoord, radians, radius) {
    return radians.map((angle)=>(0, $eWmIy.default)(centerCoord, radius, angle));
}

});
parcelRegister("eWmIy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d650cbdddba94995$export$2e2bcd8739ae039);
function $d650cbdddba94995$export$2e2bcd8739ae039(sCoord, r, radian) {
    const x = Number((sCoord.x + Math.cos(radian) * r).toFixed(2));
    const y = Number((sCoord.y + Math.sin(radian) * r).toFixed(2));
    return {
        x: x,
        y: y
    };
}

});


parcelRegister("er2zg", function(module, exports) {

$parcel$export(module.exports, "normalizeRadian", () => $875ae3563450834e$export$d44861331f213635);
function $875ae3563450834e$export$d44861331f213635(radian) {
    const twoPi = Math.PI * 2;
    return (radian % twoPi + twoPi) % twoPi;
}

});


parcelRegister("8O5yO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1822bbda2f21ae4b$export$2e2bcd8739ae039);
function $1822bbda2f21ae4b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});

parcelRegister("etsqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $076008beaebc8ef6$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $ly9yM = parcelRequire("ly9yM");

var $9e8jK = parcelRequire("9e8jK");

var $6vXZw = parcelRequire("6vXZw");

var $dVxLj = parcelRequire("dVxLj");
class $076008beaebc8ef6$export$2e2bcd8739ae039 extends $ly9yM.Graphics {
    constructor(details){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.w = 5, this.equelSymbol = false, this.addToLayer = ()=>this.Layers.Middle.addChild(this), this.setLineColor = (color)=>this.lineColor = color;
        this.w = details && details.width ? details.width : 5;
        this.lineColor = details && details.color ? details.color : 0x000000;
        this.equelSymbol = details?.equelSymbol || false;
        this.addToLayer();
    }
    draw(coordStart, coordEnd) {
        this.clear();
        this.moveTo(coordStart.x, coordStart.y).lineTo(coordEnd.x, coordEnd.y).stroke({
            color: this.lineColor,
            width: this.w
        });
        if (this.equelSymbol) {
            const coords = $076008beaebc8ef6$var$getEquelLineCoords(coordStart, coordEnd);
            this.moveTo(coords[0].x, coords[0].y).lineTo(coords[1].x, coords[1].y).stroke({
                color: this.lineColor,
                width: this.w - 2
            });
        }
    }
}
function $076008beaebc8ef6$var$getEquelLineCoords(coordStart, coordEnd) {
    const length = 18;
    const radian = (0, $6vXZw.default)(coordStart, coordEnd) + Math.PI / 2;
    const centerCoord = (0, $dVxLj.default)(coordStart, coordEnd);
    const coord1 = {
        x: Math.cos(radian) * (length / 2) + centerCoord.x,
        y: Math.sin(radian) * (length / 2) + centerCoord.y
    };
    const coord2 = {
        x: Math.cos(radian) * (-length / 2) + centerCoord.x,
        y: Math.sin(radian) * (-length / 2) + centerCoord.y
    };
    return [
        coord1,
        coord2
    ];
}

});
parcelRegister("dVxLj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dcda50846688004$export$2e2bcd8739ae039);
function $1dcda50846688004$export$2e2bcd8739ae039(coordStart, coordEnd) {
    return {
        x: Number(((coordStart.x + coordEnd.x) / 2).toFixed(2)),
        y: Number(((coordStart.y + coordEnd.y) / 2).toFixed(2))
    };
}

});


parcelRegister("9NMk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $289f8a2ead2b00fc$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $ly9yM = parcelRequire("ly9yM");

var $9e8jK = parcelRequire("9e8jK");

var $f5zFe = parcelRequire("f5zFe");

var $h6LSE = parcelRequire("h6LSE");
class $289f8a2ead2b00fc$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.smallDistance = 100, this.smallDistanceOffset = 0, this.addToLayer = ()=>this.Layers.Bottom.addChild(this);
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.AngleValue = new (0, $f5zFe.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addArc() {
        this.arc = new $ly9yM.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $ly9yM.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $h6LSE.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $h6LSE.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $h6LSE.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("f5zFe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a46e71542c4f40$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $28zzx = parcelRequire("28zzx");

var $9e8jK = parcelRequire("9e8jK");

var $8O5yO = parcelRequire("8O5yO");
class $a9a46e71542c4f40$export$2e2bcd8739ae039 extends $28zzx.Text {
    constructor(coord, color){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.addToLayer = ()=>this.Layers.Top.addChild(this), this.setValue = (value)=>this.text = `${value}\xb0`;
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $8O5yO.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});

parcelRegister("h6LSE", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $0a424a41f81c90f5$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $0a424a41f81c90f5$export$9340b6a85ea854b9);
function $0a424a41f81c90f5$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $0a424a41f81c90f5$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("elBkP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dadcc9057dae784$export$2e2bcd8739ae039);
function $1dadcc9057dae784$export$2e2bcd8739ae039(coord1, coord2) {
    return Math.sqrt(Math.pow(coord1.x - coord2.x, 2) + Math.pow(coord1.y - coord2.y, 2));
}

});

parcelRegister("5ekDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $11db6d52ec40e1d2$export$2e2bcd8739ae039);

var $6vXZw = parcelRequire("6vXZw");
function $11db6d52ec40e1d2$export$2e2bcd8739ae039(cCoord, cStart, cEnd) {
    const startRadian = (0, $6vXZw.default)(cCoord, cStart);
    const endRadian = (0, $6vXZw.default)(cCoord, cEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});

parcelRegister("2hUu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eea8fd65a637f31$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $28zzx = parcelRequire("28zzx");

var $9e8jK = parcelRequire("9e8jK");
class $2eea8fd65a637f31$export$2e2bcd8739ae039 extends $28zzx.Text {
    constructor(name){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.addToLayer = ()=>this.Layers.Info.addChild(this), this.updateCoord = (coord)=>Object.assign(this, coord);
        this.text = name;
        this.style.fontSize = 35;
        this.anchor.set(.5);
        this.x = -50;
        this.y = -50;
        this.addToLayer();
    }
}

});

parcelRegister("jG160", function(module, exports) {

$parcel$export(module.exports, "default", () => $73fa5b321c861a0c$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $ly9yM = parcelRequire("ly9yM");

var $9e8jK = parcelRequire("9e8jK");

var $99f70 = parcelRequire("99f70");

var $2Msgp = parcelRequire("2Msgp");
class $73fa5b321c861a0c$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(coord, radians, colors){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.arcs = [], this.colors = [], this.radius = (0, $99f70.INITIAL_CIRCLE_RADIUS), this.radians = [], this.points = [], this.addToLayer = ()=>this.Layers.Middle.addChild(this), this.setColors = (colors)=>this.colors = colors, this.setRadians = (radians)=>this.radians = radians;
        Object.assign(this, coord);
        this.radians = radians;
        this.colors = colors;
        this.addGraphics(radians.length);
        this.addToLayer();
    }
    addGraphics(count) {
        this.arcs = Array(count).fill(new $ly9yM.Graphics());
        this.arcs.forEach((arc)=>this.addChild(arc));
    }
    draw(details, transparent = false) {
        Object.assign(this, details);
        const alpha = transparent ? 0 : 1;
        const points = (0, $2Msgp.default)({
            x: 0,
            y: 0
        }, this.radians, this.radius);
        this.arcs.forEach((arc)=>arc.clear());
        this.radians.forEach((r, rI)=>{
            const lastelm = rI == this.radians.length - 1;
            const arc = this.arcs[rI];
            const point = points[rI];
            arc.moveTo(point.x, point.y).arc(0, 0, this.radius, r, this.radians[!lastelm ? rI + 1 : 0]).stroke({
                color: this.colors[rI],
                width: 5,
                alpha: !lastelm ? alpha : 1
            });
        });
    }
}

});

parcelRegister("cbvsj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5824b1d1258e8346$export$2e2bcd8739ae039);

var $d55ji = parcelRequire("d55ji");

var $76Ylb = parcelRequire("76Ylb");

var $3JQTS = parcelRequire("3JQTS");

var $lhuuv = parcelRequire("lhuuv");
class $5824b1d1258e8346$export$2e2bcd8739ae039 {
    constructor(slidersProps, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL){
        this.Game = (0, $d55ji.default).getInstance();
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.EnumRootEventBus = (0, $3JQTS.EnumRootEventBus);
        this.sliders = [];
        this.slidersProps = [];
        this.dim = this.Game.getDim();
        this.getSliders = ()=>this.sliders;
        this.setAllVisible = (v)=>this.sliders.forEach((slider)=>slider.visible = v);
        this.handleEnd = ()=>{
            this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).setRefRadians);
            setTimeout(()=>this.sliders.forEach((s)=>s.Slider.value = 100), 100);
        };
        this.slidersProps = slidersProps;
        this.generateSliders(SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.setAllVisible(true));
    }
    generateSliders(SLIDERS_COORD, SLIDERS_COORD_VERTICAL) {
        const coords = (0, $lhuuv.getSliderCoords)(this.dim, SLIDERS_COORD, SLIDERS_COORD_VERTICAL);
        coords.forEach((coord, cI)=>{
            const sProps = this.slidersProps[cI];
            const slider = this.addSlider(coord, sProps, sProps.onUpdate);
            this.sliders.push(slider);
        });
    }
    addSlider(coord, sGProps, onUpdate) {
        const props = (0, $lhuuv.generateSliderProps)(coord, sGProps.head, sGProps.colors, sGProps.subHead);
        return new (0, $76Ylb.default)(props, this.handleEnd, onUpdate);
    }
}

});
parcelRegister("76Ylb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf80d5969891eb0$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $ly9yM = parcelRequire("ly9yM");
var $28zzx = parcelRequire("28zzx");

var $d55ji = parcelRequire("d55ji");

var $5V8T8 = parcelRequire("5V8T8");

var $9e8jK = parcelRequire("9e8jK");
class $2cf80d5969891eb0$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(props, handleOnEnd, handleOnUpdate){
        super(), this.Game = (0, $d55ji.default).getInstance(), this.Layers = (0, $9e8jK.default).getInstance(), this.isVertical = false, this.addToLayer = ()=>this.Layers.UI.addChild(this);
        Object.assign(this, props);
        this.getIsVertical();
        this.handleOnEnd = handleOnEnd;
        this.handleOnUpdate = handleOnUpdate;
        this.generateHead();
        props.subHead && this.generateSubHead();
        this.generateBg();
        this.addSlider();
        this.addHandleEvent();
        this.addToLayer();
    }
    getIsVertical() {
        const dim = this.Game.getDim();
        this.isVertical = dim.WIDTH < dim.HEIGHT;
    }
    generateHead() {
        const head = new $28zzx.Text({
            text: this.head
        });
        head.style.fontWeight = "700";
        head.style.fontSize = this.isVertical ? 30 : 25;
        head.anchor.set(.5);
        head.x = this.isVertical ? 115 : 140;
        head.y = -90;
        this.addChild(head);
    }
    generateSubHead() {
        const sub = new $28zzx.Text({
            text: this.subHead
        });
        sub.style.fontWeight = "500";
        sub.style.fontSize = 15;
        sub.anchor.set(.5);
        sub.x = this.isVertical ? 115 : 140;
        sub.y = -70;
        this.addChild(sub);
    }
    generateBar(isTransparent = false) {
        const bar = new $ly9yM.Graphics();
        this.isVertical ? bar.roundRect(0, -10, 230, 20, 8) : bar.rect(0, -5, 280, 10);
        bar.fill({
            color: this.sliderStyle.barColor,
            alpha: isTransparent ? 0 : .5
        });
        return bar;
    }
    generateSliderButton() {
        const button = new $ly9yM.Graphics();
        this.isVertical ? button.circle(0, -10, 30) : button.rect(-15, -30, 30, 50);
        button.fill(this.sliderStyle.buttonColor);
        return button;
    }
    generateBg() {
        const bg = new $ly9yM.Graphics();
        this.isVertical ? bg.roundRect(-25, -60, 280, 120, 30) : bg.roundRect(-25, -60, 330, 120, 25);
        bg.fill({
            color: this.sliderStyle.bgColor,
            alpha: .2
        }).stroke({
            color: 0x000000,
            width: 3
        });
        this.addChild(bg);
    }
    addHandleEvent() {
        this.Slider.interactive = true;
        this.Slider.on("mouseup", ()=>this.handleOnEnd());
        this.Slider.on("touchend", ()=>this.handleOnEnd());
    }
    addSlider() {
        this.Slider = new (0, $5V8T8.Slider)({
            bg: this.generateBar(),
            fill: this.generateBar(true),
            slider: this.generateSliderButton(),
            min: 0,
            max: 200,
            value: 100
        });
        this.addChild(this.Slider);
        this.Slider.onUpdate.connect((value)=>{
            this.handleOnUpdate(value);
        });
    }
}

});
parcelRegister("5V8T8", function(module, exports) {

$parcel$export(module.exports, "Slider", () => $ee0bd0b312126493$export$472062a354075cee);

var $2OJcT = parcelRequire("2OJcT");

var $2pezJ = parcelRequire("2pezJ");
var $ee0bd0b312126493$var$__defProp = Object.defineProperty;
var $ee0bd0b312126493$var$__defNormalProp = (obj, key, value)=>key in obj ? $ee0bd0b312126493$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ee0bd0b312126493$var$__publicField = (obj, key, value)=>$ee0bd0b312126493$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class $ee0bd0b312126493$export$472062a354075cee extends (0, $2pezJ.SliderBase) {
    constructor(options){
        super({
            slider1: options.slider,
            value1: options.value,
            ...options
        });
        $ee0bd0b312126493$var$__publicField(this, "sliderOptions");
        /** Fires when value is changing, on every move of slider. */ $ee0bd0b312126493$var$__publicField(this, "onUpdate", new (0, $2OJcT.Signal)());
        /** Fires when value changed, only when slider is released. */ $ee0bd0b312126493$var$__publicField(this, "onChange", new (0, $2OJcT.Signal)());
        this.sliderOptions = options;
        this.step = options.step || 1;
        this.value = options.value ?? this.min;
        this.updateSlider();
    }
    /** Return selected value. */ get value() {
        return this._value1;
    }
    /** Set selected value. */ set value(value) {
        if (value === this._value1) return;
        if (value < this.min) value = this.min;
        if (value > this.max) value = this.max;
        this._value1 = value;
        this.updateSlider();
        this.onUpdate?.emit(this.value);
    }
    set max(value) {
        super.max = value;
        this.updateSlider();
    }
    get max() {
        return super.max;
    }
    set min(value) {
        super.min = value;
        this.updateSlider();
    }
    get min() {
        return super.min;
    }
    set step(value) {
        super.step = value;
        this.updateSlider();
    }
    get step() {
        return super.step;
    }
    /** Set slider instance ot texture. */ // eslint-disable-next-line accessor-pairs
    set slider(value) {
        this.slider1 = value;
        this.updateSlider();
    }
    update(event) {
        super.update(event);
        if (!this.dragging) return;
        const obj = event.currentTarget;
        const { x: x } = obj.parent.worldTransform.applyInverse(event.global);
        const positionRatio = x / (this.bg?.width || 1);
        const rawValue = this.min + positionRatio * (this.max - this.min);
        this.value = Math.round(rawValue / this.step) * this.step;
    }
    change() {
        this.onChange?.emit(this.value);
    }
    updateSlider() {
        this.progress = ((this.value ?? this.min) - this.min) / (this.max - this.min) * 100;
        this._slider1.x = this.bg?.width / 100 * this.progress - this._slider1.width / 2;
        this._slider1.y = this.bg?.height / 2;
        if (this.sliderOptions?.showValue) {
            this.value1Text.text = `${Math.round(this.value)}`;
            const sliderPosX = this._slider1.x + this._slider1.width / 2;
            const sliderPosY = this._slider1.y;
            this.value1Text.x = sliderPosX + (this.sliderOptions.valueTextOffset?.x ?? 0);
            this.value1Text.y = sliderPosY + (this.sliderOptions.valueTextOffset?.y ?? 0);
        }
    }
    /**
   * Sets width of a Sliders background and fill.
   * If nineSliceSprite is set, then width will be set to nineSliceSprite.
   * If nineSliceSprite is not set, then width will control components width as Container.
   * @param value - Width value.
   */ set width(value) {
        super.width = value;
        this.updateSlider();
    }
    /** Gets width of a Slider. */ get width() {
        return super.width;
    }
    /**
   * Sets height of a Sliders background and fill.
   * If nineSliceSprite is set, then height will be set to nineSliceSprite.
   * If nineSliceSprite is not set, then height will control components height as Container.
   * @param value - Height value.
   */ set height(value) {
        super.height = value;
        this.updateSlider();
    }
    /** Gets height of a Slider. */ get height() {
        return super.height;
    }
    setSize(value, height) {
        super.setSize(value, height);
        this.updateSlider();
    }
}

});
parcelRegister("2OJcT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignalConnections = module.exports.Signal = module.exports.CollectorWhile0 = module.exports.CollectorUntil0 = module.exports.CollectorLast = module.exports.CollectorArray = module.exports.Collector = void 0;

var $i4Sze = parcelRequire("i4Sze");
Object.defineProperty(module.exports, "Collector", {
    enumerable: true,
    get: function() {
        return $i4Sze.Collector;
    }
});

var $c1N2s = parcelRequire("c1N2s");
Object.defineProperty(module.exports, "CollectorArray", {
    enumerable: true,
    get: function() {
        return $c1N2s.CollectorArray;
    }
});

var $b2ORg = parcelRequire("b2ORg");
Object.defineProperty(module.exports, "CollectorLast", {
    enumerable: true,
    get: function() {
        return $b2ORg.CollectorLast;
    }
});

var $9uXaq = parcelRequire("9uXaq");
Object.defineProperty(module.exports, "CollectorUntil0", {
    enumerable: true,
    get: function() {
        return $9uXaq.CollectorUntil0;
    }
});

var $fqkMZ = parcelRequire("fqkMZ");
Object.defineProperty(module.exports, "CollectorWhile0", {
    enumerable: true,
    get: function() {
        return $fqkMZ.CollectorWhile0;
    }
});

var $4ESQT = parcelRequire("4ESQT");
Object.defineProperty(module.exports, "Signal", {
    enumerable: true,
    get: function() {
        return $4ESQT.Signal;
    }
});

var $hAoZl = parcelRequire("hAoZl");
Object.defineProperty(module.exports, "SignalConnections", {
    enumerable: true,
    get: function() {
        return $hAoZl.SignalConnections;
    }
});

});
parcelRegister("i4Sze", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collector = void 0;
/**
 * Base class for collectors.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $d292eda2acc2fb76$var$Collector {
    /**
     * Create a new collector.
     *
     * @param signal The signal to emit.
     */ constructor(signal){
        // eslint-disable-next-line dot-notation
        this.emit = (...args)=>{
            // eslint-disable-next-line dot-notation
            signal["emitCollecting"](this, args);
        };
    }
}
module.exports.Collector = $d292eda2acc2fb76$var$Collector;

});

parcelRegister("c1N2s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectorArray = void 0;

var $i4Sze = parcelRequire("i4Sze");
/**
 * Returns the result of the all signal handlers from a signal emission in an array.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $8c1b9e0f12f4031d$var$CollectorArray extends $i4Sze.Collector {
    constructor(){
        super(...arguments);
        this.result = [];
    }
    handleResult(result) {
        this.result.push(result);
        return true;
    }
    /**
     * Get the list of results from the signal handlers.
     */ getResult() {
        return this.result;
    }
    /**
     * Reset the result
     */ reset() {
        this.result.length = 0;
    }
}
module.exports.CollectorArray = $8c1b9e0f12f4031d$var$CollectorArray;

});

parcelRegister("b2ORg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectorLast = void 0;

var $i4Sze = parcelRequire("i4Sze");
/**
 * Returns the result of the last signal handler from a signal emission.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $80a754f88cb60aae$var$CollectorLast extends $i4Sze.Collector {
    handleResult(result) {
        this.result = result;
        return true;
    }
    /**
     * Get the result of the last signal handler.
     */ getResult() {
        return this.result;
    }
    /**
     * Reset the result
     */ reset() {
        delete this.result;
    }
}
module.exports.CollectorLast = $80a754f88cb60aae$var$CollectorLast;

});

parcelRegister("9uXaq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectorUntil0 = void 0;

var $i4Sze = parcelRequire("i4Sze");
/**
 * Keep signal emissions going while all handlers return true.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $6ea4cfc7359529e1$var$CollectorUntil0 extends $i4Sze.Collector {
    constructor(){
        super(...arguments);
        this.result = false;
    }
    handleResult(result) {
        this.result = result;
        return this.result;
    }
    /**
     * Get the result of the last signal handler.
     */ getResult() {
        return this.result;
    }
    /**
     * Reset the result
     */ reset() {
        this.result = false;
    }
}
module.exports.CollectorUntil0 = $6ea4cfc7359529e1$var$CollectorUntil0;

});

parcelRegister("fqkMZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectorWhile0 = void 0;

var $i4Sze = parcelRequire("i4Sze");
/**
 * Keep signal emissions going while all handlers return false.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $b3a968ff8b4f91d2$var$CollectorWhile0 extends $i4Sze.Collector {
    constructor(){
        super(...arguments);
        this.result = false;
    }
    handleResult(result) {
        this.result = result;
        return !this.result;
    }
    /**
     * Get the result of the last signal handler.
     */ getResult() {
        return this.result;
    }
    /**
     * Reset the result
     */ reset() {
        this.result = false;
    }
}
module.exports.CollectorWhile0 = $b3a968ff8b4f91d2$var$CollectorWhile0;

});

parcelRegister("4ESQT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Signal = void 0;

var $3WsVN = parcelRequire("3WsVN");

var $dlN4J = parcelRequire("dlN4J");
/**
 * A signal is a way to publish and subscribe to events.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $3645725aa0433912$var$Signal {
    constructor(){
        this.head = new $dlN4J.SignalLink();
        this.hasNewLinks = false;
        this.emitDepth = 0;
        this.connectionsCount = 0;
    }
    /**
     * @returns The number of connections on this signal.
     */ getConnectionsCount() {
        return this.connectionsCount;
    }
    /**
     * @returns true if this signal has connections.
     */ hasConnections() {
        return this.connectionsCount > 0;
    }
    /**
     * Subscribe to this signal.
     *
     * @param callback This callback will be run when emit() is called.
     * @param order Handlers with a higher order value will be called later.
     */ connect(callback, order = 0) {
        this.connectionsCount++;
        const link = this.head.insert(callback, order);
        if (this.emitDepth > 0) {
            this.hasNewLinks = true;
            link.newLink = true;
        }
        return new $3WsVN.SignalConnectionImpl(link, ()=>this.decrementConnectionCount());
    }
    decrementConnectionCount() {
        this.connectionsCount--;
    }
    /**
     * Unsubscribe from this signal with the original callback instance.
     * While you can use this method, the SignalConnection returned by connect() will not be updated!
     *
     * @param callback The callback you passed to connect().
     */ disconnect(callback) {
        for(let link = this.head.next; link !== this.head; link = link.next)if (link.callback === callback) {
            this.decrementConnectionCount();
            link.unlink();
            return true;
        }
        return false;
    }
    /**
     * Disconnect all handlers from this signal event.
     */ disconnectAll() {
        while(this.head.next !== this.head)this.head.next.unlink();
        this.connectionsCount = 0;
    }
    /**
     * Publish this signal event (call all handlers).
     */ emit(...args) {
        this.emitDepth++;
        for(let link = this.head.next; link !== this.head; link = link.next)if (link.isEnabled() && link.callback) link.callback.apply(null, args);
        this.emitDepth--;
        this.unsetNewLink();
    }
    emitCollecting(collector, args) {
        this.emitDepth++;
        for(let link = this.head.next; link !== this.head; link = link.next)if (link.isEnabled() && link.callback) {
            const result = link.callback.apply(null, args);
            if (!collector.handleResult(result)) break;
        }
        this.emitDepth--;
        this.unsetNewLink();
    }
    unsetNewLink() {
        if (this.hasNewLinks && this.emitDepth === 0) {
            for(let link = this.head.next; link !== this.head; link = link.next)link.newLink = false;
            this.hasNewLinks = false;
        }
    }
}
module.exports.Signal = $3645725aa0433912$var$Signal;

});
parcelRegister("3WsVN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignalConnectionImpl = void 0;
/**
 * Implementation of SignalConnection, for internal use only.
 * @private
 */ class $2ded3afdb7c54206$var$SignalConnectionImpl {
    /**
     * @param link The actual link of the connection.
     * @param parentCleanup Callback to cleanup the parent signal when a connection is disconnected
     */ constructor(link, parentCleanup){
        this.link = link;
        this.parentCleanup = parentCleanup;
    }
    disconnect() {
        if (this.link !== null) {
            this.link.unlink();
            this.link = null;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.parentCleanup();
            this.parentCleanup = null;
            return true;
        }
        return false;
    }
    set enabled(enable) {
        if (this.link) this.link.setEnabled(enable);
    }
    get enabled() {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        return this.link !== null && this.link.isEnabled();
    }
}
module.exports.SignalConnectionImpl = $2ded3afdb7c54206$var$SignalConnectionImpl;

});

parcelRegister("dlN4J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignalLink = void 0;
/**
 * SignalLink implements a doubly-linked ring with nodes containing the signal handlers.
 * @private
 */ class $9b834dd7ee961b2d$var$SignalLink {
    constructor(prev = null, next = null, order = 0){
        this.enabled = true;
        this.newLink = false;
        this.callback = null;
        this.prev = prev !== null && prev !== void 0 ? prev : this;
        this.next = next !== null && next !== void 0 ? next : this;
        this.order = order;
    }
    isEnabled() {
        return this.enabled && !this.newLink;
    }
    setEnabled(flag) {
        this.enabled = flag;
    }
    unlink() {
        this.callback = null;
        this.next.prev = this.prev;
        this.prev.next = this.next;
    }
    insert(callback, order) {
        let after = this.prev;
        while(after !== this){
            if (after.order <= order) break;
            after = after.prev;
        }
        const link = new $9b834dd7ee961b2d$var$SignalLink(after, after.next, order);
        link.callback = callback;
        after.next = link;
        link.next.prev = link;
        return link;
    }
}
module.exports.SignalLink = $9b834dd7ee961b2d$var$SignalLink;

});


parcelRegister("hAoZl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignalConnections = void 0;
/**
 * Represents a list of connections to a signal for easy disconnect.
 */ class $ccd92ea7a3a04aaa$var$SignalConnections {
    constructor(){
        this.list = [];
    }
    /**
     * Add a connection to the list.
     * @param connection
     */ add(connection) {
        this.list.push(connection);
    }
    /**
     * Disconnect all connections in the list and empty the list.
     */ disconnectAll() {
        for (const connection of this.list)connection.disconnect();
        this.list = [];
    }
    /**
     * @returns The number of connections in this list.
     */ getCount() {
        return this.list.length;
    }
    /**
     * @returns true if this list is empty.
     */ isEmpty() {
        return this.list.length === 0;
    }
}
module.exports.SignalConnections = $ccd92ea7a3a04aaa$var$SignalConnections;

});


parcelRegister("2pezJ", function(module, exports) {

$parcel$export(module.exports, "SliderBase", () => $e84a83d37b0a0d55$export$9418495bb635ebde);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $7FQQW = parcelRequire("7FQQW");
var $28zzx = parcelRequire("28zzx");

var $eS3Zq = parcelRequire("eS3Zq");

var $8UaxK = parcelRequire("8UaxK");
var $e84a83d37b0a0d55$var$__defProp = Object.defineProperty;
var $e84a83d37b0a0d55$var$__defNormalProp = (obj, key, value)=>key in obj ? $e84a83d37b0a0d55$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e84a83d37b0a0d55$var$__publicField = (obj, key, value)=>$e84a83d37b0a0d55$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class $e84a83d37b0a0d55$export$9418495bb635ebde extends (0, $eS3Zq.ProgressBar) {
    constructor(options){
        super(options);
        $e84a83d37b0a0d55$var$__publicField(this, "_slider1");
        $e84a83d37b0a0d55$var$__publicField(this, "_slider2");
        $e84a83d37b0a0d55$var$__publicField(this, "value1Text");
        $e84a83d37b0a0d55$var$__publicField(this, "value2Text");
        $e84a83d37b0a0d55$var$__publicField(this, "_value1");
        $e84a83d37b0a0d55$var$__publicField(this, "_value2");
        $e84a83d37b0a0d55$var$__publicField(this, "dragging", 0);
        /** Minimal value. */ $e84a83d37b0a0d55$var$__publicField(this, "_min", 0);
        /** Maximal value. */ $e84a83d37b0a0d55$var$__publicField(this, "_max", 100);
        /** Progress value step */ $e84a83d37b0a0d55$var$__publicField(this, "_step", 1);
        $e84a83d37b0a0d55$var$__publicField(this, "startX");
        $e84a83d37b0a0d55$var$__publicField(this, "startUpdateValue1");
        $e84a83d37b0a0d55$var$__publicField(this, "startUpdateValue2");
        $e84a83d37b0a0d55$var$__publicField(this, "settings");
        this.settings = options;
        this.slider1 = options.slider1;
        this.slider2 = options.slider2;
        this.min = options.min ?? 0;
        this.max = options.max ?? 100;
    }
    init(progressBarOptions) {
        super.init(progressBarOptions);
        if (this.fill) this.fill.eventMode = "none";
    }
    /**
   * Sets Slider1 instance.
   * @param value - Container or string with texture name.
   */ set slider1(value) {
        if (!value) return;
        if (this._slider1) {
            this.slider1.removeAllListeners();
            this.slider1.destroy();
        }
        this._slider1 = this.createSlider(value);
        if (this.settings.showValue && !this.value1Text) {
            const TextClass = this.settings.valueTextClass ?? (0, $28zzx.Text);
            this.value1Text = new TextClass({
                text: "",
                style: this.settings.valueTextStyle || {
                    fill: 16777215
                }
            });
            this.value1Text.anchor.set(0.5);
            this.addChild(this.value1Text);
        }
    }
    /** Get Slider1 instance. */ get slider1() {
        return this._slider1;
    }
    /**
   * Sets Slider2 instance.
   * @param value - Container or string with texture name.
   */ set slider2(value) {
        if (!value) return;
        if (this._slider2) {
            this.slider2.removeAllListeners();
            this.slider2.destroy();
        }
        this._slider2 = this.createSlider(value);
        if (this.settings.showValue && !this.value2Text) {
            const TextClass = this.settings.valueTextClass ?? (0, $28zzx.Text);
            this.value2Text = new TextClass({
                text: "",
                style: this.settings.valueTextStyle || {
                    fill: 16777215
                }
            });
            this.value2Text.anchor.set(0.5);
            this.addChild(this.value2Text);
        }
    }
    /** Get Slider2 instance. */ get slider2() {
        return this._slider2;
    }
    /**
   * Set bg.
   * @param bg
   */ setBackground(bg) {
        if (this.bg) this.bg.removeAllListeners();
        super.setBackground(bg);
        this.activateBG();
    }
    activateBG() {
        this.bg.eventMode = "static";
        this.bg.on("pointerdown", this.startUpdate, this).on("globalpointermove", this.update, this).on("pointerup", this.endUpdate, this).on("pointerupoutside", this.endUpdate, this);
    }
    createSlider(sliderData) {
        const slider = (0, $8UaxK.getView)(sliderData);
        const onPointerDown = (event)=>{
            if (this.bg) event.currentTarget = this.bg;
            this.startUpdate(event);
        };
        slider.eventMode = "static";
        slider.on("pointerdown", onPointerDown).on("pointerup", this.endUpdate, this).on("pointerupoutside", this.endUpdate, this);
        slider.x = slider.width / 2;
        const container = new (0, $d7k7b.Container)();
        container.addChild(slider);
        if (slider instanceof (0, $7FQQW.Sprite)) slider.anchor.set(0.5);
        container.y = this.bg?.height ? this.bg?.height / 2 : 0;
        this.addChild(container);
        return container;
    }
    startUpdate(event) {
        this.dragging = 1;
        const obj = event.currentTarget;
        this.startX = obj.parent.worldTransform.applyInverse(event.global).x;
        this.startUpdateValue1 = this._value1;
        this.startUpdateValue2 = this._value2;
        this.update(event);
    }
    endUpdate() {
        if (!this.dragging) return;
        this.dragging = 0;
        if (!!this.startX || this.startUpdateValue1 !== this._value1 || this.startUpdateValue2 !== this._value2) this.change();
        this.startUpdateValue1 = null;
        this.startUpdateValue2 = null;
    }
    onClick() {
        this.change();
    }
    /* Called when dragging started and on every move. */ update(_event) {
        const obj = _event.currentTarget;
        const { x: x } = obj.parent.worldTransform.applyInverse(_event.global);
        if (x !== this.startX) this.startX = null;
    }
    /** Called when dragging stopped. */ change() {}
    /**
   * Set max value.
   * @param value
   */ set max(value) {
        this._max = value;
    }
    /** Get max value. */ get max() {
        return this._max;
    }
    /**
   * Set min value.
   * @param value
   */ set min(value) {
        this._min = value;
    }
    /** Get min value. */ get min() {
        return this._min;
    }
    /**
   * Set step value.
   * @param value
   */ set step(value) {
        this._step = value;
    }
    /** Get step value. */ get step() {
        return this._step;
    }
}

});
parcelRegister("eS3Zq", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", () => $3ce71bfbf4fd22c1$export$c17561cb55d4db30);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $lBai8 = parcelRequire("lBai8");
var $7FQQW = parcelRequire("7FQQW");
var $7Ix7i = parcelRequire("7Ix7i");

var $8UaxK = parcelRequire("8UaxK");
var $3ce71bfbf4fd22c1$var$__defProp = Object.defineProperty;
var $3ce71bfbf4fd22c1$var$__defNormalProp = (obj, key, value)=>key in obj ? $3ce71bfbf4fd22c1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3ce71bfbf4fd22c1$var$__publicField = (obj, key, value)=>$3ce71bfbf4fd22c1$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class $3ce71bfbf4fd22c1$export$c17561cb55d4db30 extends (0, $d7k7b.Container) {
    /**
   * Creates a ProgressBar.
   * @param options - Options.
   * @param { Sprite | Graphics | Texture | string } options.bg - Background of the ProgressBar.
   * <br> If you pass a string, it will be used as a texture name.
   * <br> If you want to use NineSliceSprite, you have to pass a text
   * (name of texture) or an instance of Texture as a parameter here.
   * @param { Sprite | Graphics | Texture | string } options.fill - Fill of the ProgressBar.
   * <br> If you pass a string, it will be used as a texture name.
   * <br> If you want to use NineSliceSprite, you have to pass a text
   * (name of texture) or an instance of Texture as a parameter here.
   * @param { FillPaddings } options.fillPaddings - Fill offsets.
   * @param { number } options.fillPaddings.top - Fill top offset.
   * @param { number } options.fillPaddings.right - Fill right offset.
   * @param { number } options.fillPaddings.bottom - Fill bottom offset.
   * @param { number } options.fillPaddings.left - Fill left offset.
   * @param { NineSliceSprite } options.nineSliceSprite - NineSliceSprite values for bg and fill.
   * @param { Array } options.nineSliceSprite.bg - NineSliceSprite config for bg ([number, number, number, number]).
   * <br> <b>!!! IMPORTANT:</b> To make it work, you have to pass a bg parameter as texture name or texture instance.
   * @param { Array } options.nineSliceSprite.fill - NineSliceSprite config fill ([number, number, number, number]).
   * <br> <b>!!! IMPORTANT:</b> To make it work, you have to pass a fill parameter as texture name or texture instance.
   * @param { number } options.progress - Initial progress value.
   */ constructor(options){
        super();
        $3ce71bfbf4fd22c1$var$__publicField(this, "bg");
        $3ce71bfbf4fd22c1$var$__publicField(this, "fill");
        $3ce71bfbf4fd22c1$var$__publicField(this, "fillMask");
        $3ce71bfbf4fd22c1$var$__publicField(this, "progressStart", 0);
        $3ce71bfbf4fd22c1$var$__publicField(this, "_progress", 0);
        $3ce71bfbf4fd22c1$var$__publicField(this, "options");
        /** Container, that holds all inner views. */ $3ce71bfbf4fd22c1$var$__publicField(this, "innerView");
        /** Container, given as a constructor parameter that is a button view. */ $3ce71bfbf4fd22c1$var$__publicField(this, "_view");
        this.options = options;
        this.innerView = new (0, $d7k7b.Container)();
        this.addChild(this.innerView);
        if (options?.bg && options?.fill) this.init(options);
    }
    /**
   * Initialize ProgressBar.
   * @param root0
   * @param root0.bg - Background texture.
   * @param root0.fill - Fill texture.
   * @param root0.fillPaddings - Fill offset.
   * @param root0.progress - Initial progress value.
   */ init({ bg: bg, fill: fill, fillPaddings: fillPaddings, progress: progress }) {
        this.setBackground(bg);
        this.setFill(fill, fillPaddings);
        this.progress = progress;
    }
    /**
   * Set bg.
   * @param bg
   */ setBackground(bg) {
        if (this.bg) this.bg.destroy();
        if (this.options?.nineSliceSprite) {
            if (typeof bg === "string") this.bg = new (0, $lBai8.NineSliceSprite)({
                texture: (0, $7Ix7i.Texture).from(bg),
                leftWidth: this.options.nineSliceSprite.bg[0],
                topHeight: this.options.nineSliceSprite.bg[1],
                rightWidth: this.options.nineSliceSprite.bg[2],
                bottomHeight: this.options.nineSliceSprite.bg[3]
            });
            else if (bg instanceof (0, $7Ix7i.Texture)) this.bg = new (0, $lBai8.NineSliceSprite)({
                texture: bg,
                leftWidth: this.options.nineSliceSprite.bg[0],
                topHeight: this.options.nineSliceSprite.bg[1],
                rightWidth: this.options.nineSliceSprite.bg[2],
                bottomHeight: this.options.nineSliceSprite.bg[3]
            });
            else console.warn(`NineSliceSprite can not be used with views set as Container.
                    Pass the texture or texture name as instead of the Container extended instance.`);
        }
        if (!this.bg) this.bg = (0, $8UaxK.getView)(bg);
        this.innerView.addChildAt(this.bg, 0);
    }
    /**
   * Set fill.
   * @param fill
   * @param fillPadding
   */ setFill(fill, fillPadding) {
        if (this.fill) this.fill.destroy();
        if (this.bg instanceof (0, $7FQQW.Sprite) && fill === this.bg) {
            console.warn("Can not use same Sprite instance for bg and fill.");
            return;
        }
        if (this.options?.nineSliceSprite) {
            if (typeof fill === "string" || fill instanceof (0, $7Ix7i.Texture)) this.fill = new (0, $lBai8.NineSliceSprite)({
                texture: typeof fill === "string" ? (0, $7Ix7i.Texture).from(fill) : fill,
                leftWidth: this.options.nineSliceSprite.fill[0],
                topHeight: this.options.nineSliceSprite.fill[1],
                rightWidth: this.options.nineSliceSprite.fill[2],
                bottomHeight: this.options.nineSliceSprite.fill[3]
            });
            else {
                console.warn(`NineSliceSprite can not be used with views set as Container.
                    Pass the texture or texture name as instead of the Container extended instance.`);
                this.fill = (0, $8UaxK.getView)(fill);
            }
        } else this.fill = (0, $8UaxK.getView)(fill);
        this.innerView.addChildAt(this.fill, 1);
        const offsetX = fillPadding?.left ?? 0;
        const offsetY = fillPadding?.top ?? 0;
        this.fill.x = offsetX;
        this.fill.y = offsetY;
        if (this.fillMask) {
            this.fill.mask = null;
            this.fillMask.destroy();
        }
        const leftWidth = this.fill.width / 2;
        const rightWidth = this.fill.width / 2;
        const topHeight = this.fill.height / 2;
        const bottomHeight = this.fill.height / 2;
        let texture = (0, $7Ix7i.Texture).WHITE;
        if (this.fill instanceof (0, $7FQQW.Sprite) && this.fill.texture) texture = this.fill.texture;
        this.fillMask = new (0, $lBai8.NineSliceSprite)({
            texture: texture,
            leftWidth: leftWidth,
            topHeight: topHeight,
            rightWidth: rightWidth,
            bottomHeight: bottomHeight
        });
        this.fillMask.position.copyFrom(this.fill);
        this.addChild(this.fillMask);
        this.fill.mask = this.fillMask;
    }
    validate(progress) {
        progress = Math.round(progress);
        if (progress < 0) return 0;
        if (progress > 100) return 100;
        return progress;
    }
    /** Set current progress percentage value. */ set progress(progress) {
        this._progress = this.validate(progress);
        if (!this.fill) return;
        if (this.fillMask) {
            this.fill.mask = null;
            this.fillMask.width = this.fill.width / 100 * (this._progress - this.progressStart);
            this.fillMask.x = this.progressStart / 100 * this.fill.width + this.fill.x;
            this.fillMask.height = this.fill.height;
            this.fill.mask = this.fillMask;
        }
    }
    /** Return current progress percentage value. */ get progress() {
        return this._progress;
    }
    /**
   * Sets width of a ProgressBars background and fill.
   * If nineSliceSprite is set, then width will be set to nineSliceSprite.
   * If nineSliceSprite is not set, then width will control components width as Container.
   * @param width - Width value.
   */ set width(width) {
        if (this.options?.nineSliceSprite) {
            if (this.bg) this.bg.width = width;
            if (this.fill) {
                const leftPadding = this.options.fillPaddings?.left ?? 0;
                const rightPadding = this.options.fillPaddings?.right ?? 0;
                this.fill.width = width - leftPadding - rightPadding;
                this.fillMask.width = width - leftPadding - rightPadding;
            }
            this.progress = this._progress;
        } else super.width = width;
    }
    /** Gets width of a ProgressBar. */ get width() {
        return super.width;
    }
    /**
   * Sets height of a ProgressBars background and fill.
   * If nineSliceSprite is set, then height will be set to nineSliceSprite.
   * If nineSliceSprite is not set, then height will control components height as Container.
   * @param height - Height value.
   */ set height(height) {
        if (this.options?.nineSliceSprite) {
            if (this.bg) this.bg.height = height;
            if (this.fill) {
                const topPadding = this.options.fillPaddings?.top ?? 0;
                const bottomPadding = this.options.fillPaddings?.bottom ?? 0;
                this.fill.height = height - topPadding - bottomPadding;
                this.fillMask.height = height - topPadding - bottomPadding;
            }
            this.progress = this._progress;
        } else super.height = height;
    }
    /** Gets height of a ProgressBar. */ get height() {
        return super.height;
    }
    setSize(value, height) {
        if (this.options?.nineSliceSprite) {
            if (this.bg) this.bg.setSize(value, height);
            if (this.fill) {
                if (typeof value === "object") {
                    height = value.height ?? value.width;
                    value = value.width;
                } else height = height ?? value;
                const topPadding = this.options.fillPaddings?.top ?? 0;
                const bottomPadding = this.options.fillPaddings?.bottom ?? 0;
                const leftPadding = this.options.fillPaddings?.left ?? 0;
                const rightPadding = this.options.fillPaddings?.right ?? 0;
                this.fill.setSize(value - leftPadding - rightPadding, height - topPadding - bottomPadding);
                this.fillMask.setSize(value - leftPadding - rightPadding, height - topPadding - bottomPadding);
            }
            this.progress = this._progress;
        } else super.setSize(value, height);
    }
}

});
parcelRegister("8UaxK", function(module, exports) {

$parcel$export(module.exports, "getView", () => $bb97a599b4d40215$export$513f42987b822fd7);
parcelRequire("83ZZo");
var $7FQQW = parcelRequire("7FQQW");
var $7Ix7i = parcelRequire("7Ix7i");
function $bb97a599b4d40215$export$513f42987b822fd7(view) {
    if (typeof view === "string") return (0, $7FQQW.Sprite).from(view);
    if (view instanceof (0, $7Ix7i.Texture)) return new (0, $7FQQW.Sprite)(view);
    return view;
}

});





parcelRegister("lhuuv", function(module, exports) {

$parcel$export(module.exports, "getSliderCoords", () => $ba98f28f0bf1c0ae$export$683fd302086be208);
$parcel$export(module.exports, "generateSliderProps", () => $ba98f28f0bf1c0ae$export$802e1960ddee5612);
function $ba98f28f0bf1c0ae$export$683fd302086be208(dim, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL) {
    return dim.WIDTH > dim.HEIGHT ? SLIDERS_COORD : SLIDERS_COORD_OFFSET_VERTICAL.map((o)=>({
            x: dim.WIDTH / 2 + o.x,
            y: dim.HEIGHT / 2 + o.y
        }));
}
function $ba98f28f0bf1c0ae$export$802e1960ddee5612(coord, head, colors, subHead = "") {
    return {
        x: coord.x,
        y: coord.y,
        head: head,
        subHead: subHead,
        sliderStyle: colors
    };
}

});


parcelRegister("aZDOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $eccc7c51afd7c7c6$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $eccc7c51afd7c7c6$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Angle, onComp){
        super();
        new (0, $lyHkj.default).Tween(Angle).to({
            scale: 1
        }, 500).easing((0, $lyHkj.default).Easing.Linear.None).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("kOFqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $beaaac15d41c5e00$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");

var $99f70 = parcelRequire("99f70");
class $beaaac15d41c5e00$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Circle, targetRadian, radianIndex, transparent, cCoord, onComp){
        super();
        this.Circle = Circle;
        this.cCoord = cCoord;
        this.radians = [
            ...Circle.radians
        ];
        this.radianIndex = radianIndex;
        const r = {
            startRadian: this.radians[radianIndex]
        };
        new (0, $lyHkj.default).Tween({
            ...r
        }).to({
            startRadian: targetRadian
        }, 2000).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((c)=>{
            const radians = [
                ...this.radians
            ];
            radians[radianIndex] = c.startRadian;
            this.Circle.draw({
                radians: radians,
                radius: (0, $99f70.INITIAL_CIRCLE_RADIUS)
            }, transparent);
        }).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("a9Ugo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1335bf01bb3e1ee8$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $1335bf01bb3e1ee8$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Line, sCoord, tCoord, onComp){
        super(), this.sCoord = sCoord, this.tCoord = tCoord;
        new (0, $lyHkj.default).Tween({
            ...sCoord
        }).to({
            x: tCoord.x,
            y: tCoord.y
        }, 1000).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((coord, u)=>{
            Line.draw(sCoord, coord);
        }).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("hL4lC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2140030fa8830f94$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $2140030fa8830f94$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(sprite, startScale, endScale, onComp = ()=>{}){
        super();
        sprite.scale.set(startScale, Math.abs(startScale));
        sprite.visible = true;
        new (0, $lyHkj.default).Tween(sprite.scale).to({
            x: endScale,
            y: Math.abs(endScale)
        }, 300).easing((0, $lyHkj.default).Easing.Elastic.Out).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("dF6vz", function(module, exports) {

$parcel$export(module.exports, "default", () => $365ec51cf192ae80$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");

var $d55ji = parcelRequire("d55ji");

var $9e8jK = parcelRequire("9e8jK");

var $aKJzb = parcelRequire("aKJzb");

var $81Hov = parcelRequire("81Hov");

var $6Ya1S = parcelRequire("6Ya1S");

var $99f70 = parcelRequire("99f70");
class $365ec51cf192ae80$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(coord, infoSliderAssets){
        super(), this.Game = (0, $d55ji.default).getInstance(), this.Layers = (0, $9e8jK.default).getInstance(), this.infoSliderDims = (0, $99f70.INFO_SLIDER_DIMS), this.InfoSliderDots = [], this.addToLayer = ()=>this.Layers.UI.addChild(this);
        if (!$365ec51cf192ae80$export$2e2bcd8739ae039.instance) $365ec51cf192ae80$export$2e2bcd8739ae039.instance = this;
        Object.assign(this, coord);
        this.infoSliderAssets = infoSliderAssets;
        this.isPortial();
        new (0, $81Hov.default)(this.infoSliderDims);
        new (0, $aKJzb.default)(this.infoSliderAssets, this.infoSliderDims);
        this.addDots();
        this.addToLayer();
    }
    static{
        this.getInstance = ()=>$365ec51cf192ae80$export$2e2bcd8739ae039.instance;
    }
    isPortial() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return;
        this.x = dim.WIDTH / 2;
        this.y = this.infoSliderDims.height / 2 + 50;
        this.scale.set(1.3);
    }
    addDots() {
        const lenghtISA = this.infoSliderAssets.length;
        this.infoSliderAssets.forEach((a, aI)=>{
            const even = lenghtISA % 2 == 1 ? true : false;
            const x = (aI - lenghtISA / 2 + (even ? .5 : .5)) * 30;
            const dot = new (0, $6Ya1S.default)(aI, x, this.infoSliderDims);
            this.InfoSliderDots.push(dot);
        });
    }
}

});
parcelRegister("aKJzb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c91dc32f3c396e3$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $ly9yM = parcelRequire("ly9yM");
var $7FQQW = parcelRequire("7FQQW");

var $dF6vz = parcelRequire("dF6vz");

var $11z86 = parcelRequire("11z86");

var $dBtOK = parcelRequire("dBtOK");

var $ge12w = parcelRequire("ge12w");

var $3JQTS = parcelRequire("3JQTS");
const $8c91dc32f3c396e3$var$MASK_PATH = "/info-slider/mask.png";
class $8c91dc32f3c396e3$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(infoSliderAssets, infoSliderDims){
        super(), this.InfoSlider = (0, $dF6vz.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.currPageIndex = 0, this.addToCon = ()=>this.InfoSlider.addChild(this);
        this.infoSliderAssets = infoSliderAssets;
        this.infoSliderDims = infoSliderDims;
        this.addPages();
        this.addMask();
        this.addFrame();
        this.addToCon();
        this.calcBoundaryStatus();
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).setInfoSliderPage, (pNumber)=>this.setPage(pNumber));
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).setInfoSliderPageWArr, (v)=>this.setPageWithArrow(v));
    }
    calcBoundaryStatus() {
        const state = this.currPageIndex == 0 ? "first" : this.currPageIndex == this.infoSliderAssets.length - 1 ? "last" : "middle";
        this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).updateEdgeState, state);
    }
    addFrame() {
        const width = this.infoSliderDims.width;
        const height = this.infoSliderDims.height;
        const frame = new $ly9yM.Graphics().roundRect(-this.infoSliderDims.width / 2, -this.infoSliderDims.height / 2, width, height, 10).stroke({
            color: 0x000000,
            width: 3
        });
        this.addChild(frame);
    }
    addMask() {
        const texture = (0, $ge12w.default).getTexture($8c91dc32f3c396e3$var$MASK_PATH);
        const mask = new $7FQQW.Sprite(texture);
        mask.width = this.infoSliderDims.width;
        mask.height = this.infoSliderDims.height;
        mask.anchor.set(.5);
        this.addChild(mask);
        this.Pages.mask = mask;
    }
    addPages() {
        this.Pages = new $d7k7b.Container();
        this.addChild(this.Pages);
        this.infoSliderAssets.forEach((Asset, assetIndex)=>{
            const slide = new (0, $11z86.default)(Asset);
            slide.x = this.infoSliderDims.width * assetIndex;
            slide.y = 0;
            this.Pages.addChild(slide);
        });
    }
    setPageWithArrow(v) {
        const newPage = Math.min(this.infoSliderAssets.length - 1, Math.max(0, this.currPageIndex + v));
        this.setPage(newPage);
    }
    setPage(pNumber) {
        const delta = Math.abs(pNumber - this.currPageIndex);
        this.currPageIndex = pNumber;
        const offsetX = this.infoSliderDims.width * pNumber;
        const duration = 100 * delta;
        this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).setCurPage, this.currPageIndex);
        new (0, $dBtOK.default)(this.Pages, -offsetX, duration);
    }
}

});
parcelRegister("11z86", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2bae5b811ef7c0d$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $7FQQW = parcelRequire("7FQQW");

var $ge12w = parcelRequire("ge12w");

var $dF6vz = parcelRequire("dF6vz");
class $a2bae5b811ef7c0d$export$2e2bcd8739ae039 extends $7FQQW.Sprite {
    constructor(path){
        super(), this.InfoSlider = (0, $dF6vz.default).getInstance();
        this.generate(path);
    }
    generate(path) {
        this.texture = (0, $ge12w.default).getTexture(path);
        this.anchor.set(.5);
        this.scale.set(.42);
        this.x = this.InfoSlider.x;
        this.y = this.InfoSlider.y;
    }
}

});

parcelRegister("dBtOK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9871dda3ce09a97a$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $9871dda3ce09a97a$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Container, offsetX, duration){
        super();
        new (0, $lyHkj.default).Tween(Container).to({
            x: offsetX
        }, duration * 2).easing((0, $lyHkj.default).Easing.Linear.None).start();
    }
}

});


parcelRegister("81Hov", function(module, exports) {

$parcel$export(module.exports, "default", () => $6170c9590ad2a114$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $d7k7b = parcelRequire("d7k7b");
var $7FQQW = parcelRequire("7FQQW");

var $dF6vz = parcelRequire("dF6vz");

var $3JQTS = parcelRequire("3JQTS");

var $ge12w = parcelRequire("ge12w");
const $6170c9590ad2a114$var$ARROW_PATH = "/info-slider/arrow.png";
class $6170c9590ad2a114$export$2e2bcd8739ae039 extends $d7k7b.Container {
    constructor(infoSliderDims){
        super(), this.InfoSlider = (0, $dF6vz.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.handleArrow = (v)=>this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).setInfoSliderPageWArr, v);
        this.infoSliderDims = infoSliderDims;
        this.addToCon();
        this.addLeftArrow();
        this.addRightArrow();
    }
    setArrowInteractivity(arrow, interactive) {
        arrow.interactive = interactive;
        arrow.alpha = interactive ? 1 : .5;
    }
    updateArrowAvaible(eState) {
        if (eState == "first") {
            this.setArrowInteractivity(this.leftArrow, false);
            this.setArrowInteractivity(this.rightArrow, true);
        } else if (eState == "last") {
            this.setArrowInteractivity(this.leftArrow, true);
            this.setArrowInteractivity(this.rightArrow, false);
        } else if (eState == "middle") {
            this.setArrowInteractivity(this.leftArrow, true);
            this.setArrowInteractivity(this.rightArrow, true);
        }
    }
    addLeftArrow() {
        const coord = {
            x: -this.infoSliderDims.width / 2 - 40,
            y: 0
        };
        this.leftArrow = this.generateArrow(coord, false);
    }
    addRightArrow() {
        const coord = {
            x: this.infoSliderDims.width / 2 + 40,
            y: 0
        };
        this.rightArrow = this.generateArrow(coord, true);
    }
    generateArrow(coord, isRight) {
        let texture = (0, $ge12w.default).getTexture($6170c9590ad2a114$var$ARROW_PATH);
        const Arrow = new $7FQQW.Sprite(texture);
        Object.assign(Arrow, coord);
        const scale = .17;
        Arrow.width = 241;
        Arrow.height = 403;
        Arrow.anchor.set(.5);
        Arrow.scale.set(isRight ? scale : -scale, scale);
        Arrow.cursor = "pointer";
        Arrow.interactive = true;
        Arrow.on("mousedown", ()=>this.handleArrow(isRight ? 1 : -1));
        Arrow.on("touchstart", ()=>this.handleArrow(isRight ? 1 : -1));
        this.addChild(Arrow);
        return Arrow;
    }
    addToCon() {
        this.InfoSlider.addChild(this);
    }
}

});

parcelRegister("6Ya1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf17db80118f103$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $ly9yM = parcelRequire("ly9yM");

var $dF6vz = parcelRequire("dF6vz");

var $3JQTS = parcelRequire("3JQTS");

var $99f70 = parcelRequire("99f70");
class $ccf17db80118f103$export$2e2bcd8739ae039 extends $ly9yM.Graphics {
    constructor(pNumber, x, infoSliderDims){
        super(), this.InfoSlider = (0, $dF6vz.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.currentPage = false, this.addToCon = ()=>this.InfoSlider.addChild(this), this.setInfoSliderPage = ()=>this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).setInfoSliderPage, this.pNumber);
        this.pNumber = pNumber;
        this.currentPage = !pNumber;
        this.infoSliderDims = infoSliderDims;
        this.generate();
        this.addCoord(x);
        this.addToCon();
        this.interactive = true;
        this.cursor = "pointer";
        this.on("mousedown", ()=>this.setInfoSliderPage());
        this.on("touchstart", ()=>this.setInfoSliderPage());
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).setCurPage, (cPage)=>this.setCurPage(Number(cPage)));
    }
    setCurPage(curPage) {
        this.currentPage = curPage == this.pNumber ? true : false;
        this.generate();
    }
    addCoord(x) {
        this.x = x;
        this.y = this.infoSliderDims.height / 2 + 25;
    }
    generate() {
        const dotColor = (0, $99f70.CENTER_ANGLE_COLOR);
        const cs = {
            fill: this.currentPage ? dotColor.color : 0xFFFFFF,
            color: !this.currentPage ? dotColor.textColor : dotColor.color
        };
        this.clear();
        this.circle(0, 0, 10).fill(cs.fill).stroke({
            width: 2,
            color: cs.color
        });
    }
}

});


parcelRegister("6DjBJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6efcd31f886f2555$export$2e2bcd8739ae039);

var $cDZM5 = parcelRequire("cDZM5");

var $99f70 = parcelRequire("99f70");
const $6efcd31f886f2555$var$text = "Drag the points on the circle";
const $6efcd31f886f2555$var$color = 0xF82400;
class $6efcd31f886f2555$export$2e2bcd8739ae039 extends (0, $cDZM5.default) {
    constructor(coord = (0, $99f70.GUIDE_TEXT_COORD)){
        super($6efcd31f886f2555$var$text, $6efcd31f886f2555$var$color, coord);
    }
}

});
parcelRegister("cDZM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0243fe3cf4dfd9c8$export$2e2bcd8739ae039);
parcelRequire("83ZZo");
var $28zzx = parcelRequire("28zzx");

var $d55ji = parcelRequire("d55ji");

var $9e8jK = parcelRequire("9e8jK");

var $hL4lC = parcelRequire("hL4lC");
class $0243fe3cf4dfd9c8$export$2e2bcd8739ae039 extends $28zzx.Text {
    constructor(text, color, coord, yOffset = 0){
        super(), this.Game = (0, $d55ji.default).getInstance(), this.Layers = (0, $9e8jK.default).getInstance(), this.addToLayer = ()=>this.Layers.Info.addChild(this);
        this.addCoord(coord, yOffset);
        this.addDetails(text, color);
        this.addToLayer();
    }
    setVisible(visible) {
        if (visible) {
            this.visible = true;
            new (0, $hL4lC.default)(this, .5, 1);
            return;
        }
        this.visible = visible;
    }
    addCoord(coord, yOffset) {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return Object.assign(this, coord);
        this.x = dim.WIDTH / 2;
        this.y = 460 + yOffset;
        this.anchor.set(.5);
    }
    addDetails(text, color) {
        this.text = text;
        this.style.fill = color;
        this.style.fontWeight = "600";
        this.style.fontStyle = "italic";
        this.style.fontSize = 30;
    }
}

});


var $9af9c9e896498525$exports = {};

(parcelRequire("3xISK")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"iTpb9\",\"index.7114cdce.js\",\"1aH1w\",\"../browserAll.05393a9b.js\",\"2ESdP\",\"../browserAll.2fdd9353.js\",\"8nO6Z\",\"../browserAll.dacf4961.js\",\"eS6a7\",\"../browserAll.eb0ed318.js\",\"f3Eag\",\"../webworkerAll.a9121918.js\",\"6Zoh5\",\"../WebGPURenderer.eb5a95fa.js\",\"gm9hO\",\"../WebGPURenderer.dc972e9c.js\",\"8T1xj\",\"../WebGLRenderer.f4a6945d.js\"]"));


//# sourceMappingURL=index.7114cdce.js.map
